{
  "level": "q306",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q306",
    "objects": "AREAS.E3:q306.e3",
    "mesh": "TREES.E3:q306.e3"
  },
  "spawn_point": {
    "position": [
      620.5081724109795,
      1203.5246695647534,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      620.5081724109795,
      1303.5246695647534,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -6821.484375,
      -4714.78125,
      -300.0
    ],
    "bbox_max": [
      7681.30224609375,
      7450.0,
      2142.593505859375
    ],
    "vertex_count": 2498,
    "vertices": [
      [
        -6821.484375,
        2758.39404296875,
        0.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        0.0
      ],
      [
        -3000.0,
        3072.413818359375,
        0.0
      ],
      [
        -3000.0,
        2944.781005859375,
        -300.0
      ],
      [
        -3000.0,
        -2954.5341796875,
        0.0
      ],
      [
        -3000.0,
        -2803.447265625,
        -300.0
      ],
      [
        -3660.1962890625,
        -2427.517822265625,
        1172.1954345703125
      ],
      [
        -3660.927734375,
        -2428.069091796875,
        1220.0
      ],
      [
        -4110.7685546875,
        -2767.048095703125,
        1371.9029541015625
      ],
      [
        -4116.7685546875,
        -2771.56982421875,
        1403.2762451171875
      ],
      [
        -4102.099609375,
        -2760.515625,
        1220.0
      ],
      [
        -4110.7685546875,
        -2767.048095703125,
        1371.9029541015625
      ],
      [
        -3354.7705078125,
        -3938.2197265625,
        1046.6051025390625
      ],
      [
        -3398.428466796875,
        -3995.13671875,
        1045.652587890625
      ],
      [
        -3507.259521484375,
        -3939.684814453125,
        1397.2437744140625
      ],
      [
        -3464.2958984375,
        -3883.6728515625,
        1398.18115234375
      ],
      [
        -3380.023193359375,
        -3911.88134765625,
        1152.351318359375
      ],
      [
        -3343.854248046875,
        -3923.988037109375,
        1046.84326171875
      ],
      [
        -3661.619384765625,
        -2428.59033203125,
        1091.7215576171875
      ],
      [
        -3660.1962890625,
        -2427.517822265625,
        1172.1954345703125
      ],
      [
        -3000.0,
        -3214.59765625,
        1181.8935546875
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3000.0,
        -3565.30615234375,
        1052.5999755859375
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3515.1474609375,
        -2584.24951171875,
        630.2245483398438
      ],
      [
        -3661.619384765625,
        -2428.59033203125,
        1091.7215576171875
      ],
      [
        -3658.444091796875,
        -2426.19775390625,
        1057.6986083984375
      ],
      [
        -3452.1201171875,
        -2659.722412109375,
        642.3209228515625
      ],
      [
        -3515.1474609375,
        -2584.24951171875,
        630.224609375
      ],
      [
        -3452.1201171875,
        -2659.722412109375,
        642.3209228515625
      ],
      [
        -3577.691162109375,
        -2365.345947265625,
        192.41732788085938
      ],
      [
        -3543.18798828125,
        -2339.345947265625,
        0.0
      ],
      [
        -3000.0,
        -2954.536865234375,
        0.0
      ],
      [
        -3000.0,
        -3005.550537109375,
        150.8363037109375
      ],
      [
        -3000.0,
        -3210.00390625,
        1194.0616455078125
      ],
      [
        -3000.0,
        -3052.4541015625,
        311.63726806640625
      ],
      [
        -3000.0,
        -3210.00390625,
        1194.0616455078125
      ],
      [
        -3577.691162109375,
        -2365.345947265625,
        192.41732788085938
      ],
      [
        -3000.0,
        -3052.4541015625,
        311.6372375488281
      ],
      [
        -3000.0,
        -3005.550537109375,
        150.83631896972656
      ],
      [
        -3000.0,
        -4714.78125,
        1390.1104736328125
      ],
      [
        -3000.0,
        -4650.2626953125,
        1191.9580078125
      ],
      [
        -3000.0,
        -4671.95703125,
        1040.098388671875
      ],
      [
        -3000.0,
        -4650.2626953125,
        1191.9580078125
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -5545.388671875,
        4741.15380859375,
        334.1224365234375
      ],
      [
        -6158.31884765625,
        3750.891357421875,
        976.300048828125
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8642578125
      ],
      [
        -5506.39208984375,
        4726.5693359375,
        0.0
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.9832763671875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755867958068848
      ],
      [
        -4113.74951171875,
        -2769.29443359375,
        1387.4892578125
      ],
      [
        -4205.0,
        -2619.44677734375,
        1400.274658203125
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755615234375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.983154296875
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -5704.54443359375,
        4430.01318359375,
        976.300048828125
      ],
      [
        -5573.556640625,
        4626.0498046875,
        901.1133422851562
      ],
      [
        -5185.80517578125,
        5206.36181640625,
        0.0
      ],
      [
        -5532.3203125,
        4687.76513671875,
        347.8642578125
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        41.128997802734375
      ],
      [
        -5342.2373046875,
        4972.24462890625,
        157.04103088378906
      ],
      [
        -4474.53173828125,
        4475.62646484375,
        150.0
      ],
      [
        -4591.423828125,
        5531.40869140625,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      [
        -5332.0185546875,
        4987.5380859375,
        150.0
      ],
      [
        -5174.01171875,
        5224.01171875,
        671.7750244140625
      ],
      [
        -3179.908447265625,
        3702.747802734375,
        150.0
      ],
      [
        -3000.0,
        3147.970458984375,
        160.642333984375
      ],
      [
        -3000.0,
        3121.493896484375,
        115.36239624023438
      ],
      [
        -3000.0,
        3072.413818359375,
        0.0
      ],
      [
        -3000.0,
        3121.493896484375,
        115.36239624023438
      ],
      [
        -3714.02197265625,
        -2323.558349609375,
        1179.126708984375
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.53662109375
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3660.219970703125,
        -2427.53564453125,
        1173.7484130859375
      ],
      [
        -3179.908203125,
        3702.747802734375,
        150.0
      ],
      [
        -4020.98193359375,
        5936.4208984375,
        150.0
      ],
      [
        -3725.158447265625,
        -2329.2001953125,
        1299.8638916015625
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3697.79833984375,
        -2384.52392578125,
        1182.312255859375
      ],
      [
        -3697.73974609375,
        -2384.451171875,
        1181.5667724609375
      ],
      [
        -3697.79833984375,
        -2384.52392578125,
        1182.3121337890625
      ],
      [
        -3702.450439453125,
        -2378.302978515625,
        1210.5587158203125
      ],
      [
        -3702.450439453125,
        -2378.302978515625,
        1210.5587158203125
      ],
      [
        -3703.801513671875,
        -2376.973876953125,
        1220.0
      ],
      [
        -3000.0,
        3595.34423828125,
        150.0
      ],
      [
        -3000.0,
        6661.31591796875,
        150.0
      ],
      [
        -3000.0,
        3595.34423828125,
        150.0
      ],
      [
        -3000.0,
        3214.951416015625,
        275.1920166015625
      ],
      [
        -3000.0,
        3214.951416015625,
        275.19207763671875
      ],
      [
        -5174.01171875,
        5224.01171875,
        714.5433349609375
      ],
      [
        -5331.83203125,
        4987.8173828125,
        762.363525390625
      ],
      [
        4138.5498046875,
        4965.47119140625,
        137.9085693359375
      ],
      [
        4063.46240234375,
        5106.68994140625,
        183.4736328125
      ],
      [
        4063.462646484375,
        5106.68994140625,
        183.4736785888672
      ],
      [
        3242.2421875,
        6651.18115234375,
        550.7012939453125
      ],
      [
        3015.587890625,
        7077.4560546875,
        687.5199584960938
      ],
      [
        3242.2421875,
        6651.18115234375,
        550.7012939453125
      ],
      [
        2958.814697265625,
        7184.23095703125,
        720.4558715820312
      ],
      [
        3015.587890625,
        7077.4560546875,
        687.5199584960938
      ],
      [
        4516.6787109375,
        4254.31396484375,
        258.1122131347656
      ],
      [
        4138.5498046875,
        4965.47119140625,
        137.9085693359375
      ],
      [
        5075.16259765625,
        4000.0,
        1379.597412109375
      ],
      [
        4651.89990234375,
        4000.0,
        749.28955078125
      ],
      [
        4516.6787109375,
        4254.31396484375,
        258.1121826171875
      ],
      [
        5075.16259765625,
        4000.0,
        1379.597412109375
      ],
      [
        6769.1220703125,
        4000.0,
        2142.593505859375
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.115966796875
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        -187.97914123535156,
        5502.95947265625,
        0.0
      ],
      [
        -233.35060119628906,
        5716.41552734375,
        150.0
      ],
      [
        -187.97914123535156,
        5502.9599609375,
        0.0
      ],
      [
        -97.2362060546875,
        5076.0478515625,
        -300.0
      ],
      [
        -233.35060119628906,
        5716.41552734375,
        150.0
      ],
      [
        -255.05752563476562,
        5818.53857421875,
        189.62399291992188
      ],
      [
        -450.0968017578125,
        7064.0869140625,
        557.4568481445312
      ],
      [
        -139.55206298828125,
        7382.458984375,
        -22.699951171875
      ],
      [
        -569.308837890625,
        7296.97509765625,
        -22.699951171875
      ],
      [
        -569.3087768554688,
        7296.97509765625,
        625.141357421875
      ],
      [
        -489.0639953613281,
        7312.93701171875,
        630.946533203125
      ],
      [
        -197.38243103027344,
        7370.9560546875,
        150.00013732910156
      ],
      [
        -361.5218505859375,
        7338.306640625,
        640.17333984375
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693603515625
      ],
      [
        4141.0390625,
        4144.17333984375,
        -250.32057189941406
      ],
      [
        3966.75,
        4947.60009765625,
        -13.693601608276367
      ],
      [
        3944.89013671875,
        4000.0,
        -295.782470703125
      ],
      [
        3942.69775390625,
        4000.0,
        -300.0
      ],
      [
        4141.0390625,
        4144.17333984375,
        -250.32057189941406
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784912109375
      ],
      [
        816.3760375976562,
        7327.39501953125,
        652.46484375
      ],
      [
        3018.309814453125,
        6889.4033203125,
        624.2335205078125
      ],
      [
        3127.081298828125,
        6867.76708984375,
        620.217529296875
      ],
      [
        4040.1279296875,
        4609.34765625,
        -113.31649780273438
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464569091796875
      ],
      [
        3282.322265625,
        6575.80126953125,
        532.7785034179688
      ],
      [
        4000.44775390625,
        4954.3212890625,
        24.79598045349121
      ],
      [
        3986.6806640625,
        4979.27001953125,
        32.464569091796875
      ],
      [
        4000.44775390625,
        4954.3212890625,
        24.795982360839844
      ],
      [
        3999.89697265625,
        4949.31103515625,
        23.076099395751953
      ],
      [
        3992.506103515625,
        4882.09033203125,
        0.0
      ],
      [
        4144.63134765625,
        4143.130859375,
        -241.0099639892578
      ],
      [
        3992.506103515625,
        4882.09033203125,
        0.0
      ],
      [
        4006.63916015625,
        4045.38671875,
        -281.4707336425781
      ],
      [
        4144.63134765625,
        4143.130859375,
        -241.0099639892578
      ],
      [
        4047.87451171875,
        5080.8212890625,
        152.81597900390625
      ],
      [
        3956.206787109375,
        5048.34375,
        54.11053466796875
      ],
      [
        4047.874267578125,
        5080.8212890625,
        152.81594848632812
      ],
      [
        4072.85498046875,
        5089.02490234375,
        177.77395629882812
      ],
      [
        -514.5919189453125,
        7039.55224609375,
        663.3798217773438
      ],
      [
        -489.06396484375,
        7312.93701171875,
        630.946533203125
      ],
      [
        -569.3087768554688,
        7296.97509765625,
        763.2601318359375
      ],
      [
        -569.3087768554688,
        7296.97509765625,
        976.300048828125
      ],
      [
        3973.670166015625,
        4000.0,
        -240.4162139892578
      ],
      [
        4227.99853515625,
        4000.0,
        118.03058624267578
      ],
      [
        4098.64111328125,
        4000.0,
        0.0
      ],
      [
        -431.8513488769531,
        4000.0,
        150.0
      ],
      [
        -3000.0,
        4000.0,
        150.0
      ],
      [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      [
        -569.308837890625,
        7296.97509765625,
        150.0
      ],
      [
        -380.952392578125,
        4000.0,
        0.0
      ],
      [
        -431.851318359375,
        4000.0,
        150.0
      ],
      [
        -380.952392578125,
        4000.0,
        0.0
      ],
      [
        -279.15447998046875,
        4000.0,
        -300.0
      ],
      [
        -1165.5224609375,
        7178.380859375,
        976.300048828125
      ],
      [
        -698.511962890625,
        7271.27490234375,
        976.300048828125
      ],
      [
        -569.3087768554688,
        7296.97509765625,
        763.2601928710938
      ],
      [
        -2525.290771484375,
        6907.90576171875,
        150.0
      ],
      [
        477.51397705078125,
        -3695.77197265625,
        1852.5999755859375
      ],
      [
        882.31884765625,
        -3613.49072265625,
        0.0
      ],
      [
        949.6846923828125,
        -3670.01708984375,
        1852.5999755859375
      ],
      [
        -2395.35791015625,
        -863.1936645507812,
        100.0
      ],
      [
        -2823.71630859375,
        -503.75830078125,
        100.0
      ],
      [
        -2395.35791015625,
        -863.1936645507812,
        100.0
      ],
      [
        -2355.001708984375,
        -897.0564575195312,
        0.0
      ],
      [
        -800.0,
        -1452.5167236328125,
        0.0
      ],
      [
        -800.0,
        -1855.504150390625,
        287.160888671875
      ],
      [
        -800.0,
        -1452.5167236328125,
        0.0
      ],
      [
        -800.0,
        -1347.3697509765625,
        -300.0
      ],
      [
        -800.0,
        -2100.0,
        508.155517578125
      ],
      [
        -800.0,
        -1855.504150390625,
        287.1609191894531
      ],
      [
        -1928.281005859375,
        -575.3740234375,
        100.0
      ],
      [
        -2794.94091796875,
        322.07867431640625,
        100.0
      ],
      [
        -1928.2808837890625,
        -575.3740234375,
        100.0
      ],
      [
        -1895.5322265625,
        -609.2863159179688,
        7.897435665130615
      ],
      [
        -1892.729736328125,
        -612.1883544921875,
        0.0
      ],
      [
        -1821.7576904296875,
        -685.6819458007812,
        -300.0
      ],
      [
        -1892.729736328125,
        -612.1884155273438,
        0.0
      ],
      [
        -1895.5322265625,
        -609.2863159179688,
        7.897438049316406
      ],
      [
        -800.0,
        3767.0244140625,
        150.0
      ],
      [
        -800.0,
        4000.0,
        150.0
      ],
      [
        -3000.0,
        3141.74755859375,
        150.0
      ],
      [
        -1846.6666259765625,
        1326.6666259765625,
        -10.0
      ],
      [
        -2723.333251953125,
        1326.6666259765625,
        -10.000000953674316
      ],
      [
        -1846.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1846.6666259765625,
        1326.6666259765625,
        -10.000000953674316
      ],
      [
        -1846.6668701171875,
        1950.0,
        -10.0
      ],
      [
        -1526.6666259765625,
        2573.333251953125,
        -10.0
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.000000953674316
      ],
      [
        -1526.6666259765625,
        2096.666748046875,
        -10.0
      ],
      [
        -1846.6666259765625,
        2096.666748046875,
        -10.000000953674316
      ],
      [
        -1840.0,
        2000.0,
        -10.0
      ],
      [
        -1840.0,
        1950.0,
        -10.0
      ],
      [
        -1840.0,
        1800.0,
        -10.0
      ],
      [
        -1840.0,
        1750.0,
        -10.0
      ],
      [
        -1840.0,
        1950.0,
        -10.0
      ],
      [
        -2700.0,
        1330.0,
        0.0
      ],
      [
        -2700.0,
        1326.6666259765625,
        -10.000000953674316
      ],
      [
        -1846.6668701171875,
        1950.0,
        -10.0
      ],
      [
        -1880.0,
        1950.0,
        0.0
      ],
      [
        -1850.0001220703125,
        1950.0,
        0.0
      ],
      [
        -1840.0,
        1950.0,
        0.0
      ],
      [
        -1840.0,
        1800.0,
        0.0
      ],
      [
        -1840.0,
        1950.0,
        0.0
      ],
      [
        -2700.0,
        1330.0,
        200.0
      ],
      [
        -2700.0,
        1330.0,
        0.0
      ],
      [
        -1530.0,
        2550.0,
        200.0
      ],
      [
        -1530.0,
        2550.0,
        0.0
      ],
      [
        4832.6005859375,
        2700.0,
        1325.890869140625
      ],
      [
        7681.30224609375,
        2700.0,
        1793.450439453125
      ],
      [
        4832.60107421875,
        2700.0,
        1325.8907470703125
      ],
      [
        4147.26904296875,
        2700.0,
        1007.5693969726562
      ],
      [
        5046.24072265625,
        4000.0,
        1336.528076171875
      ],
      [
        4147.26904296875,
        2700.0,
        1007.5693969726562
      ],
      [
        3737.0400390625,
        2700.0,
        725.110595703125
      ],
      [
        3662.3603515625,
        2778.274169921875,
        667.953125
      ],
      [
        3662.3603515625,
        2778.274169921875,
        667.9532470703125
      ],
      [
        3737.0400390625,
        2700.0,
        725.1106567382812
      ],
      [
        3560.334716796875,
        2700.0,
        605.2196655273438
      ],
      [
        3252.70068359375,
        2700.0,
        396.496337890625
      ],
      [
        2924.8818359375,
        2700.0,
        199.68502807617188
      ],
      [
        2780.0,
        2700.0,
        98.89763641357422
      ],
      [
        2924.8818359375,
        2700.0,
        199.68505859375
      ],
      [
        3252.70068359375,
        2700.0,
        396.496337890625
      ],
      [
        2400.0,
        -2849.047607421875,
        1857.3123779296875
      ],
      [
        6992.103515625,
        -1390.9161376953125,
        590.90966796875
      ],
      [
        6992.103515625,
        -1390.9161376953125,
        590.90966796875
      ],
      [
        2400.0,
        -1319.9400634765625,
        329.8454895019531
      ],
      [
        2400.0,
        -1246.4334716796875,
        296.4333801269531
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        2400.0,
        -1546.88427734375,
        433.001953125
      ],
      [
        650.0,
        -867.0938720703125,
        16.996383666992188
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -867.0938720703125,
        16.99639320373535
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -743.0372314453125,
        -300.0
      ],
      [
        -279.618896484375,
        -1127.742431640625,
        -300.0
      ],
      [
        -800.0,
        -1412.9681396484375,
        -112.83790588378906
      ],
      [
        4050.0,
        2236.2041015625,
        975.8950805664062
      ],
      [
        4050.0,
        1387.95849609375,
        795.417236328125
      ],
      [
        4530.3369140625,
        2700.0,
        1185.495849609375
      ],
      [
        4050.0,
        935.8558959960938,
        606.6973876953125
      ],
      [
        4050.0,
        1360.935791015625,
        789.6677856445312
      ],
      [
        4050.0,
        2371.977294921875,
        964.6397705078125
      ],
      [
        4050.0,
        2700.0,
        940.5958251953125
      ],
      [
        4050.0,
        2236.2041015625,
        975.89501953125
      ],
      [
        4050.0,
        2371.977294921875,
        964.6398315429688
      ],
      [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      [
        4050.0,
        935.8558959960938,
        606.6973876953125
      ],
      [
        4050.0,
        1374.29296875,
        795.417236328125
      ],
      [
        4050.0,
        1387.95849609375,
        795.417236328125
      ],
      [
        4050.0,
        1374.29296875,
        795.417236328125
      ],
      [
        3000.0,
        706.95654296875,
        120.86956787109375
      ],
      [
        3000.0,
        887.2413330078125,
        128.96551513671875
      ],
      [
        3285.123046875,
        1852.6285400390625,
        488.7391357421875
      ],
      [
        3669.991455078125,
        2700.0,
        679.61962890625
      ],
      [
        3250.0,
        820.0,
        375.30828857421875
      ],
      [
        3350.0,
        820.0,
        402.7763671875
      ],
      [
        3312.43017578125,
        1790.47265625,
        489.9930419921875
      ],
      [
        3285.123046875,
        1852.6285400390625,
        488.7391357421875
      ],
      [
        3312.43017578125,
        1790.47265625,
        489.9930419921875
      ],
      [
        3000.0,
        1830.0,
        140.0
      ],
      [
        3000.0,
        1830.0,
        171.30172729492188
      ],
      [
        3228.21484375,
        1830.0,
        451.8016357421875
      ],
      [
        3228.21484375,
        1830.0,
        451.8016357421875
      ],
      [
        3227.146728515625,
        1836.1837158203125,
        450.7663879394531
      ],
      [
        3217.469482421875,
        1892.20361328125,
        441.3879089355469
      ],
      [
        3054.73388671875,
        2700.0,
        277.64373779296875
      ],
      [
        3217.469482421875,
        1892.20361328125,
        441.3879089355469
      ],
      [
        3000.0,
        887.2413940429688,
        128.96551513671875
      ],
      [
        3000.0,
        1690.0,
        195.17239379882812
      ],
      [
        3007.493408203125,
        2471.92041015625,
        267.9293518066406
      ],
      [
        3000.0,
        2494.87451171875,
        261.5539245605469
      ],
      [
        3000.0,
        2700.0,
        244.78341674804688
      ],
      [
        3211.686279296875,
        1830.0,
        440.3035583496094
      ],
      [
        3007.493408203125,
        2471.92041015625,
        267.92938232421875
      ],
      [
        3000.0,
        1830.0,
        206.71871948242188
      ],
      [
        3211.686279296875,
        1830.0,
        440.3035583496094
      ],
      [
        3000.0,
        1830.0,
        293.0434875488281
      ],
      [
        3000.0,
        2492.608642578125,
        261.73919677734375
      ],
      [
        3000.0,
        1830.0,
        293.0434875488281
      ],
      [
        3000.0,
        2492.608642578125,
        261.7391662597656
      ],
      [
        4050.0,
        1360.935791015625,
        789.6677856445312
      ],
      [
        3437.258056640625,
        1506.344482421875,
        495.7249755859375
      ],
      [
        3250.0,
        820.0,
        464.1409912109375
      ],
      [
        3350.0,
        820.0,
        505.5504150390625
      ],
      [
        371.2994384765625,
        1690.0,
        240.0
      ],
      [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      [
        1083.078369140625,
        1690.0,
        329.0
      ],
      [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      [
        1770.0,
        720.0,
        80.0
      ],
      [
        2964.5,
        768.5,
        80.0
      ],
      [
        2950.0,
        962.4999389648438,
        80.0
      ],
      [
        2966.428466796875,
        715.7142944335938,
        80.0
      ],
      [
        2964.5,
        768.5,
        80.0
      ],
      [
        866.760986328125,
        304.0712890625,
        80.0
      ],
      [
        1200.0,
        426.63616943359375,
        79.99999237060547
      ],
      [
        650.0,
        940.0,
        78.0
      ],
      [
        650.0,
        940.0,
        80.0
      ],
      [
        650.0,
        1150.0,
        80.0
      ],
      [
        650.0,
        1150.0,
        78.0
      ],
      [
        480.0,
        1150.0,
        80.0
      ],
      [
        480.0,
        1150.0,
        78.0
      ],
      [
        650.0,
        1130.0,
        78.0
      ],
      [
        650.0,
        1130.0,
        80.0
      ],
      [
        480.0,
        1130.0,
        78.0
      ],
      [
        650.0,
        1130.0,
        78.0
      ],
      [
        650.0,
        1150.0,
        78.0
      ],
      [
        480.0,
        1150.0,
        78.0
      ],
      [
        480.0,
        940.0,
        78.0
      ],
      [
        650.0,
        940.0,
        78.0
      ],
      [
        650.0,
        980.0,
        78.0
      ],
      [
        480.0,
        980.0,
        78.0
      ],
      [
        480.0,
        979.0,
        78.0
      ],
      [
        480.0,
        980.0,
        80.0
      ],
      [
        650.0,
        980.0,
        80.0
      ],
      [
        650.0,
        979.0,
        78.0
      ],
      [
        650.0,
        1111.0,
        78.0
      ],
      [
        650.0,
        1110.0,
        80.0
      ],
      [
        480.0,
        1110.0,
        80.0
      ],
      [
        480.0,
        1111.0,
        78.0
      ],
      [
        500.0,
        1111.0,
        78.0
      ],
      [
        650.0,
        970.0,
        60.0
      ],
      [
        480.0,
        970.0,
        60.0
      ],
      [
        480.0,
        1120.0,
        60.0
      ],
      [
        650.0,
        1120.0,
        60.0
      ],
      [
        360.0,
        980.0,
        78.0
      ],
      [
        360.0,
        979.0,
        78.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        480.0,
        979.0,
        78.0
      ],
      [
        441.0,
        1111.0,
        78.0
      ],
      [
        440.0,
        1150.0,
        80.0
      ],
      [
        441.0,
        1150.0,
        78.0
      ],
      [
        480.0,
        1111.0,
        78.0
      ],
      [
        441.0,
        1111.0,
        78.0
      ],
      [
        480.0,
        1111.0,
        78.0
      ],
      [
        477.0,
        1110.0,
        80.0
      ],
      [
        477.0,
        1120.0,
        80.0
      ],
      [
        477.0,
        1120.0,
        80.0
      ],
      [
        360.0,
        970.0,
        60.0
      ],
      [
        450.0,
        1150.0,
        60.0
      ],
      [
        650.0,
        1420.0,
        78.0
      ],
      [
        650.0,
        1420.0,
        80.0
      ],
      [
        360.0,
        1450.0,
        60.0
      ],
      [
        360.0,
        1460.0,
        80.0
      ],
      [
        650.0,
        1450.0,
        60.0
      ],
      [
        650.0,
        1460.0,
        80.0
      ],
      [
        499.0000305175781,
        1459.0,
        78.0
      ],
      [
        500.0,
        1459.0,
        78.0
      ],
      [
        395.0,
        1459.0,
        78.0
      ],
      [
        499.0000305175781,
        1459.0,
        78.0
      ],
      [
        550.0,
        1459.0,
        78.0
      ],
      [
        600.0,
        1459.0,
        78.0
      ],
      [
        500.0,
        1459.0,
        78.0
      ],
      [
        480.0,
        1420.0,
        78.0
      ],
      [
        650.0,
        1440.0,
        78.0
      ],
      [
        650.0,
        1420.0,
        78.0
      ],
      [
        504.0,
        1440.0,
        78.0
      ],
      [
        504.0,
        1440.0,
        78.0
      ],
      [
        504.0,
        1450.0,
        78.0
      ],
      [
        480.0,
        1420.0,
        78.0
      ],
      [
        480.0,
        1420.0,
        80.0
      ],
      [
        525.0,
        1450.0,
        65.4999771118164
      ],
      [
        535.9999389648438,
        1450.0,
        60.0
      ],
      [
        525.0,
        1440.0,
        65.4999771118164
      ],
      [
        525.0,
        1450.0,
        65.4999771118164
      ],
      [
        450.0,
        1420.0,
        60.0
      ],
      [
        445.0,
        1420.0,
        70.0
      ],
      [
        650.0,
        1170.0,
        60.0
      ],
      [
        650.0,
        1170.0,
        80.0
      ],
      [
        480.0,
        1170.0,
        80.0
      ],
      [
        480.0,
        1170.0,
        78.0
      ],
      [
        500.0,
        1170.0,
        80.0
      ],
      [
        500.0,
        1170.0,
        78.0
      ],
      [
        480.0,
        1170.0,
        78.0
      ],
      [
        500.0,
        1170.0,
        78.0
      ],
      [
        360.0,
        1280.0,
        78.0
      ],
      [
        360.0,
        1280.0,
        80.0
      ],
      [
        360.0,
        1280.0,
        78.0
      ],
      [
        360.0,
        1286.6666259765625,
        78.0
      ],
      [
        360.0,
        1286.6666259765625,
        78.0
      ],
      [
        360.0,
        1310.0,
        78.0
      ],
      [
        441.0,
        1400.0,
        78.0
      ],
      [
        441.0,
        1416.0,
        78.0
      ],
      [
        441.0,
        1309.0,
        78.0
      ],
      [
        441.0,
        1400.0,
        78.0
      ],
      [
        360.0,
        1309.0,
        78.0
      ],
      [
        360.0,
        1310.0,
        80.0
      ],
      [
        441.0,
        1309.0,
        78.0
      ],
      [
        400.0,
        1309.0,
        78.0
      ],
      [
        360.0,
        1300.0,
        60.0
      ],
      [
        360.0,
        1250.0,
        60.0
      ],
      [
        360.0,
        1240.0,
        80.0
      ],
      [
        450.0,
        1170.0,
        60.0
      ],
      [
        440.0,
        1170.0,
        80.0
      ],
      [
        360.0,
        930.0,
        60.0
      ],
      [
        650.0,
        930.0,
        60.0
      ],
      [
        650.0,
        920.0,
        80.0
      ],
      [
        621.0,
        560.0,
        78.0
      ],
      [
        620.0,
        560.0,
        80.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        360.0,
        560.0,
        80.0
      ],
      [
        456.27862548828125,
        481.1797790527344,
        78.0
      ],
      [
        500.0,
        511.0,
        78.0
      ],
      [
        500.0,
        510.0,
        80.0
      ],
      [
        630.0,
        600.0,
        60.0
      ],
      [
        620.0,
        604.1421508789062,
        80.0
      ],
      [
        650.0,
        620.0,
        60.0
      ],
      [
        650.0,
        634.1421508789062,
        80.0
      ],
      [
        630.907958984375,
        567.050048828125,
        80.0
      ],
      [
        630.907958984375,
        567.050048828125,
        78.0
      ],
      [
        650.0,
        586.1421508789062,
        80.0
      ],
      [
        650.0,
        586.1421508789062,
        78.0
      ],
      [
        310.0,
        970.0,
        80.0
      ],
      [
        310.0,
        980.0,
        80.0
      ],
      [
        310.0,
        250.0,
        80.0
      ],
      [
        310.0,
        970.0,
        80.0
      ],
      [
        310.0,
        1240.0,
        78.0
      ],
      [
        310.0,
        1291.25,
        78.0
      ],
      [
        310.0,
        1291.25,
        78.0
      ],
      [
        310.0,
        1310.0,
        78.0
      ],
      [
        310.0,
        979.0,
        78.0
      ],
      [
        360.0,
        979.0,
        78.0
      ],
      [
        310.0,
        1309.0,
        78.0
      ],
      [
        310.0,
        1310.0,
        80.0
      ],
      [
        360.0,
        1309.0,
        78.0
      ],
      [
        310.0,
        1459.0,
        78.0
      ],
      [
        310.0,
        1460.0,
        80.0
      ],
      [
        360.0,
        1459.0,
        78.0
      ],
      [
        360.0,
        1241.0,
        78.0
      ],
      [
        310.0,
        1240.0,
        80.0
      ],
      [
        310.0,
        1241.0,
        78.0
      ],
      [
        340.0,
        1240.9998779296875,
        78.0
      ],
      [
        320.0,
        956.0,
        78.0
      ],
      [
        310.0,
        956.0,
        78.0
      ],
      [
        320.0,
        956.0,
        78.0
      ],
      [
        360.0,
        921.0,
        78.0
      ],
      [
        359.0,
        921.0,
        78.0
      ],
      [
        310.0,
        1300.0,
        60.0
      ],
      [
        310.0,
        1450.0,
        60.0
      ],
      [
        310.0,
        1250.0,
        60.0
      ],
      [
        360.0,
        928.7999877929688,
        62.40000915527344
      ],
      [
        360.0,
        928.0,
        64.00000762939453
      ],
      [
        352.0,
        928.0,
        64.00000762939453
      ],
      [
        351.20001220703125,
        928.7999877929688,
        62.40000915527344
      ],
      [
        -50.0,
        830.0,
        80.0
      ],
      [
        -500.0,
        830.0,
        80.0
      ],
      [
        260.0,
        1250.0,
        80.0
      ],
      [
        260.0,
        1300.0,
        80.0
      ],
      [
        260.0,
        1500.0,
        80.0
      ],
      [
        260.0,
        1300.0,
        80.0
      ],
      [
        260.0,
        1000.0,
        80.0
      ],
      [
        260.0,
        1250.0,
        80.0
      ],
      [
        -533.3333129882812,
        1413.3333740234375,
        80.0
      ],
      [
        -350.0,
        1413.3333740234375,
        80.0
      ],
      [
        -300.0,
        1413.3333740234375,
        80.0
      ],
      [
        -66.66666412353516,
        1413.3333740234375,
        80.0
      ],
      [
        -350.0,
        1413.3333740234375,
        80.0
      ],
      [
        -350.0,
        1430.0,
        80.0
      ],
      [
        -50.0,
        1410.0,
        60.0
      ],
      [
        -50.0,
        1413.3333740234375,
        80.0
      ],
      [
        -50.0,
        1430.0,
        80.0
      ],
      [
        -50.0,
        1250.0,
        80.0
      ],
      [
        -533.3333129882812,
        1250.0,
        80.0
      ],
      [
        -533.3333129882812,
        1413.3333740234375,
        80.0
      ],
      [
        -550.0,
        1250.0,
        80.0
      ],
      [
        -533.3333129882812,
        1250.0,
        80.0
      ],
      [
        -50.0,
        1050.0,
        80.0
      ],
      [
        -160.0,
        1050.0,
        80.0
      ],
      [
        -254.49293518066406,
        911.17822265625,
        80.0
      ],
      [
        -289.4964599609375,
        850.55029296875,
        80.0
      ],
      [
        -289.4964599609375,
        971.80615234375,
        80.0
      ],
      [
        -254.49293518066406,
        911.17822265625,
        80.0
      ],
      [
        -289.5,
        1011.7999877929688,
        60.00611877441406
      ],
      [
        -309.4938659667969,
        971.80615234375,
        80.0
      ],
      [
        -309.4938659667969,
        1006.4426879882812,
        80.0
      ],
      [
        -303.6130676269531,
        1050.0,
        74.1191635131836
      ],
      [
        -309.493896484375,
        1050.0,
        80.0
      ],
      [
        -286.5886535644531,
        1050.0,
        60.0042839050293
      ],
      [
        -290.12823486328125,
        1050.0,
        62.939483642578125
      ],
      [
        -303.613037109375,
        1050.0,
        74.1191635131836
      ],
      [
        -290.12823486328125,
        1050.0,
        62.939483642578125
      ],
      [
        -250.78097534179688,
        1083.898193359375,
        66.12432861328125
      ],
      [
        -249.1448516845703,
        1077.77587890625,
        60.003910064697266
      ],
      [
        -295.0,
        1230.0,
        69.02511596679688
      ],
      [
        -310.0,
        1230.0,
        69.02511596679688
      ],
      [
        -299.513916015625,
        1239.02783203125,
        60.0
      ],
      [
        -295.0,
        1230.0,
        69.02511596679688
      ],
      [
        -310.0,
        1235.0,
        64.02666473388672
      ],
      [
        -310.0,
        1239.02783203125,
        60.0
      ],
      [
        -209.63284301757812,
        1363.8450927734375,
        64.0
      ],
      [
        -210.64144897460938,
        1365.5921630859375,
        64.0
      ],
      [
        -183.61666870117188,
        1326.7862548828125,
        60.0
      ],
      [
        -187.34521484375,
        1325.2418212890625,
        64.0
      ],
      [
        -205.90431213378906,
        1365.3895263671875,
        60.0
      ],
      [
        -209.63284301757812,
        1363.8450927734375,
        64.0
      ],
      [
        -309.4938659667969,
        1051.7982177734375,
        80.0
      ],
      [
        -309.493896484375,
        1051.7982177734375,
        80.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        80.0
      ],
      [
        260.0,
        1000.0,
        80.0
      ],
      [
        0.0,
        1240.0,
        79.99999237060547
      ],
      [
        120.0,
        1240.0,
        80.0
      ],
      [
        215.2666778564453,
        1310.0,
        75.0
      ],
      [
        215.26657104492188,
        1310.0,
        60.0
      ],
      [
        215.2666778564453,
        1310.0,
        75.0
      ],
      [
        215.2666778564453,
        1240.0,
        75.0
      ],
      [
        120.0,
        1240.0,
        75.0
      ],
      [
        120.0,
        1240.0,
        79.99999237060547
      ],
      [
        120.0,
        1250.0,
        80.0
      ],
      [
        120.0,
        1250.0,
        75.0
      ],
      [
        215.2666778564453,
        1240.0,
        75.0
      ],
      [
        215.26657104492188,
        1240.0,
        60.0
      ],
      [
        -33.161930084228516,
        875.3493041992188,
        80.0
      ],
      [
        -28.569726943969727,
        864.2627563476562,
        80.0
      ],
      [
        -28.56972885131836,
        864.2627563476562,
        80.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        79.9343032836914
      ],
      [
        2.688058853149414,
        870.4802856445312,
        80.0
      ],
      [
        120.0,
        1000.0,
        75.0
      ],
      [
        120.0,
        1000.0,
        80.0
      ],
      [
        90.0,
        1000.0,
        80.0
      ],
      [
        90.0,
        1000.0,
        75.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      [
        260.0,
        1459.0,
        78.0
      ],
      [
        310.0,
        1459.0,
        78.0
      ],
      [
        310.0,
        1241.0,
        78.0
      ],
      [
        260.0,
        1241.0,
        78.0
      ],
      [
        270.0,
        1309.0,
        78.0
      ],
      [
        310.0,
        1309.0,
        78.0
      ],
      [
        658.9999389648438,
        344.5075988769531,
        78.0
      ],
      [
        680.0,
        650.0,
        60.0
      ],
      [
        655.8578491210938,
        640.0,
        80.0
      ],
      [
        733.1422119140625,
        641.0000610351562,
        78.0
      ],
      [
        704.85205078125,
        641.0000610351562,
        78.0
      ],
      [
        704.85205078125,
        641.0000610351562,
        78.0
      ],
      [
        703.8523559570312,
        640.0,
        80.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        674.9039916992188,
        640.6351928710938,
        78.72969818115234
      ],
      [
        674.5391235351562,
        641.0000610351562,
        78.0
      ],
      [
        675.5390625,
        640.0000610351562,
        80.0
      ],
      [
        674.9039916992188,
        640.6351928710938,
        78.72969818115234
      ],
      [
        730.0,
        707.730224609375,
        60.0
      ],
      [
        720.0,
        707.730224609375,
        80.0
      ],
      [
        720.0,
        707.730224609375,
        78.0
      ],
      [
        721.0000610351562,
        704.1422119140625,
        78.0
      ],
      [
        721.0000610351562,
        707.730224609375,
        78.0
      ],
      [
        721.4142456054688,
        704.1422119140625,
        78.0
      ],
      [
        725.0022583007812,
        707.730224609375,
        78.0
      ],
      [
        744.83642578125,
        681.0,
        78.0
      ],
      [
        744.83642578125,
        681.0,
        78.0
      ],
      [
        760.0,
        696.1694946289062,
        78.0
      ],
      [
        760.0,
        689.9500122070312,
        78.0
      ],
      [
        760.0,
        696.1694946289062,
        78.0
      ],
      [
        760.0,
        696.1694946289062,
        80.0
      ],
      [
        764.0615844726562,
        686.0,
        80.0
      ],
      [
        760.0,
        689.9500122070312,
        78.0
      ],
      [
        765.6922607421875,
        689.9500122070312,
        78.0
      ],
      [
        770.0,
        689.9500122070312,
        78.0
      ],
      [
        770.0,
        689.9500122070312,
        78.0
      ],
      [
        851.6212158203125,
        707.730224609375,
        78.0
      ],
      [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      [
        850.6215209960938,
        706.631591796875,
        78.0
      ],
      [
        837.730224609375,
        707.730224609375,
        60.85891342163086
      ],
      [
        770.0,
        706.1732788085938,
        69.78567504882812
      ],
      [
        770.0,
        706.1732788085938,
        67.78567504882812
      ],
      [
        760.0,
        696.1694946289062,
        74.85089111328125
      ],
      [
        770.0,
        706.1732788085938,
        69.78567504882812
      ],
      [
        760.0,
        696.1694946289062,
        74.85089874267578
      ],
      [
        760.0,
        696.1694946289062,
        72.85089111328125
      ],
      [
        822.269775390625,
        707.730224609375,
        60.0
      ],
      [
        833.4356689453125,
        707.730224609375,
        60.85891342163086
      ],
      [
        833.4356689453125,
        707.730224609375,
        60.85891342163086
      ],
      [
        837.730224609375,
        707.730224609375,
        61.189266204833984
      ],
      [
        760.0,
        707.730224609375,
        78.0
      ],
      [
        741.6415405273438,
        707.730224609375,
        78.0
      ],
      [
        741.6415405273438,
        707.730224609375,
        78.0
      ],
      [
        760.0,
        707.730224609375,
        78.0
      ],
      [
        760.0,
        707.730224609375,
        80.0
      ],
      [
        760.0,
        707.730224609375,
        68.99735260009766
      ],
      [
        770.0,
        707.730224609375,
        68.99735260009766
      ],
      [
        760.0,
        707.730224609375,
        68.99735260009766
      ],
      [
        760.0,
        707.730224609375,
        66.99735260009766
      ],
      [
        770.0,
        707.730224609375,
        68.99735260009766
      ],
      [
        770.0,
        707.730224609375,
        66.99735260009766
      ],
      [
        1250.0,
        720.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        780.0,
        1540.0,
        80.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        780.0,
        1170.0,
        80.0
      ],
      [
        780.0,
        1280.0,
        80.0
      ],
      [
        780.0,
        1690.0,
        80.0
      ],
      [
        780.0,
        1570.0,
        80.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        1420.0,
        60.0
      ],
      [
        980.0,
        1420.0,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      [
        780.0,
        1570.0,
        80.0
      ],
      [
        780.0,
        1420.0,
        78.0
      ],
      [
        820.0,
        1420.0,
        78.0
      ],
      [
        820.0,
        1540.0,
        78.0
      ],
      [
        820.0,
        1540.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        78.0
      ],
      [
        890.0,
        1472.83544921875,
        78.0
      ],
      [
        890.0,
        1472.83544921875,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        78.0
      ],
      [
        871.110595703125,
        1450.0,
        78.0
      ],
      [
        820.0,
        1450.0,
        78.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        871.110595703125,
        1450.0,
        80.0
      ],
      [
        832.5558471679688,
        1540.0,
        80.0
      ],
      [
        832.5558471679688,
        1570.0,
        80.0
      ],
      [
        960.0,
        1550.0,
        80.0
      ],
      [
        890.0,
        1450.0,
        80.0
      ],
      [
        890.0,
        1450.0,
        78.0
      ],
      [
        790.0,
        1530.0,
        80.0
      ],
      [
        790.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        871.110595703125,
        1450.0,
        69.1110610961914
      ],
      [
        871.110595703125,
        1450.0,
        78.0
      ],
      [
        780.0,
        1280.0,
        80.0
      ],
      [
        905.0,
        1120.0,
        73.88888549804688
      ],
      [
        950.0,
        1120.0,
        78.88888549804688
      ],
      [
        905.0,
        1170.0,
        73.88888549804688
      ],
      [
        905.0,
        1120.0,
        73.88888549804688
      ],
      [
        905.0,
        1170.0,
        73.88888549804688
      ],
      [
        876.4285888671875,
        1160.0,
        70.71428680419922
      ],
      [
        876.4285888671875,
        1170.0,
        70.71428680419922
      ],
      [
        881.5714111328125,
        1160.0,
        71.28570556640625
      ],
      [
        881.5714111328125,
        1170.0,
        71.28570556640625
      ],
      [
        870.0,
        1160.0,
        65.50001525878906
      ],
      [
        858.9999389648438,
        1160.0,
        60.0
      ],
      [
        876.4285888671875,
        1160.0,
        70.71428680419922
      ],
      [
        881.5714111328125,
        1160.0,
        71.28570556640625
      ],
      [
        870.0,
        1170.0,
        65.50001525878906
      ],
      [
        870.0,
        1160.0,
        65.50000762939453
      ],
      [
        905.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        780.0,
        970.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        905.0,
        1170.0,
        80.0
      ],
      [
        780.0,
        1170.0,
        80.0
      ],
      [
        780.0,
        1150.0,
        78.0
      ],
      [
        780.0,
        1130.0,
        78.0
      ],
      [
        780.0,
        1150.0,
        78.0
      ],
      [
        780.0,
        1150.0,
        80.0
      ],
      [
        891.6666870117188,
        1130.0,
        80.0
      ],
      [
        780.0,
        1130.0,
        80.0
      ],
      [
        780.0,
        1130.0,
        78.0
      ],
      [
        905.0,
        1130.0,
        78.0
      ],
      [
        905.0,
        1150.0,
        78.0
      ],
      [
        905.0,
        1150.0,
        80.0
      ],
      [
        905.0,
        1130.0,
        80.0
      ],
      [
        891.6666870117188,
        1120.0,
        80.0
      ],
      [
        891.6666870117188,
        1130.0,
        80.0
      ],
      [
        905.0,
        1120.0,
        80.0
      ],
      [
        905.0,
        1120.0,
        78.0
      ],
      [
        905.0,
        1170.0,
        78.0
      ],
      [
        905.0,
        1170.0,
        80.0
      ],
      [
        891.0,
        1160.0,
        78.0
      ],
      [
        891.0,
        1170.0,
        78.0
      ],
      [
        891.0,
        1160.0,
        78.0
      ],
      [
        945.5584716796875,
        1310.0,
        76.55585479736328
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1310.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        80.0
      ],
      [
        945.5584716796875,
        1310.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        78.0
      ],
      [
        820.0,
        1400.0,
        78.0
      ],
      [
        820.0,
        1400.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        80.0
      ],
      [
        820.0,
        1310.0,
        78.0
      ],
      [
        827.0,
        1404.0,
        80.0
      ],
      [
        832.5558471679688,
        1280.0,
        80.0
      ],
      [
        832.5558471679688,
        1310.0,
        80.0
      ],
      [
        960.0,
        1280.0,
        80.0
      ],
      [
        960.0,
        1300.0,
        80.0
      ],
      [
        960.0,
        1300.0,
        80.0
      ],
      [
        740.0,
        707.730224609375,
        78.0
      ],
      [
        720.0,
        979.0,
        78.0
      ],
      [
        650.0,
        979.0,
        78.0
      ],
      [
        720.0,
        979.0,
        78.0
      ],
      [
        721.0,
        940.0,
        78.0
      ],
      [
        721.0,
        960.0,
        78.0
      ],
      [
        721.0,
        960.0,
        78.0
      ],
      [
        721.0,
        1560.0,
        78.0
      ],
      [
        721.0,
        1438.9000244140625,
        78.0
      ],
      [
        721.0,
        1690.0,
        78.0
      ],
      [
        721.0,
        1560.0,
        78.0
      ],
      [
        721.0000610351562,
        1420.0,
        78.0
      ],
      [
        721.0,
        1438.9000244140625,
        78.0
      ],
      [
        650.0,
        1459.0,
        78.0
      ],
      [
        721.0,
        1459.0,
        78.0
      ],
      [
        721.0000610351562,
        707.730224609375,
        78.0
      ],
      [
        721.0000610351562,
        750.0,
        78.0
      ],
      [
        721.0000610351562,
        750.0,
        78.0
      ],
      [
        1660.0,
        1398.28369140625,
        400.0
      ],
      [
        1660.0,
        1398.28369140625,
        280.0
      ],
      [
        1680.0,
        1378.28369140625,
        260.0
      ],
      [
        1680.0,
        1378.2838134765625,
        240.0
      ],
      [
        1680.0,
        1378.2838134765625,
        180.0
      ],
      [
        1680.0,
        1378.28369140625,
        200.0
      ],
      [
        1660.0,
        1398.28369140625,
        280.0
      ],
      [
        1680.0,
        1378.2838134765625,
        260.0
      ],
      [
        1750.0,
        1308.2840576171875,
        210.0
      ],
      [
        1750.0,
        1308.2840576171875,
        260.0
      ],
      [
        1695.0,
        1363.2840576171875,
        160.0
      ],
      [
        1680.0,
        1378.28369140625,
        180.0
      ],
      [
        1695.0,
        1363.2840576171875,
        140.0
      ],
      [
        1695.0,
        1363.2840576171875,
        160.0
      ],
      [
        1630.0,
        960.0,
        120.0
      ],
      [
        1630.0,
        960.0,
        118.0
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1750.0,
        1220.0,
        180.0
      ],
      [
        1750.0,
        1235.0,
        140.0
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1710.0,
        1235.0,
        140.0
      ],
      [
        1650.0,
        960.0,
        118.0
      ],
      [
        1630.0,
        960.0,
        118.0
      ],
      [
        1633.0,
        1140.0,
        120.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1700.0,
        1210.0,
        310.0
      ],
      [
        1700.0,
        1210.0,
        120.0
      ],
      [
        1700.0,
        1210.0,
        310.0
      ],
      [
        1600.0,
        1270.0,
        490.0
      ],
      [
        1600.0,
        1270.0,
        671.8229370117188
      ],
      [
        1600.0,
        1270.0,
        490.0
      ],
      [
        1600.0,
        1270.0,
        140.0
      ],
      [
        1600.0,
        1399.9998779296875,
        763.746826171875
      ],
      [
        1600.0,
        1270.0,
        671.822998046875
      ],
      [
        1600.0,
        1130.0,
        465.0
      ],
      [
        1600.0,
        1130.0,
        140.0
      ],
      [
        1630.0,
        1130.0,
        100.0
      ],
      [
        1600.0,
        1120.0,
        100.0
      ],
      [
        1600.0,
        1130.0,
        100.0
      ],
      [
        1630.0,
        1130.0,
        120.0
      ],
      [
        1600.0,
        1120.0,
        120.0
      ],
      [
        1600.0,
        1130.0,
        120.0
      ],
      [
        1600.0,
        1120.0,
        118.0
      ],
      [
        1600.0,
        1130.0,
        118.0
      ],
      [
        1615.0,
        1120.0,
        130.0
      ],
      [
        1600.0,
        1130.0,
        140.0
      ],
      [
        1600.0,
        1120.0,
        130.0
      ],
      [
        1600.0,
        1170.0,
        140.0
      ],
      [
        1600.0,
        1170.0,
        100.0
      ],
      [
        1600.0,
        1170.0,
        100.0
      ],
      [
        1600.0,
        1140.0,
        120.0
      ],
      [
        1600.0,
        1160.0,
        106.66666412353516
      ],
      [
        1600.0,
        1160.0,
        104.66666412353516
      ],
      [
        1600.0,
        1170.0,
        106.66666412353516
      ],
      [
        1600.0,
        1160.0,
        106.66666412353516
      ],
      [
        1600.0,
        1140.0,
        118.0
      ],
      [
        1600.0,
        1140.0,
        120.0
      ],
      [
        1600.0,
        1140.0,
        118.0
      ],
      [
        1600.0,
        1110.0,
        120.0
      ],
      [
        1600.0,
        920.0,
        80.0
      ],
      [
        1600.0,
        920.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        98.0
      ],
      [
        1720.0,
        940.0,
        100.0
      ],
      [
        1530.0,
        1270.0,
        490.0
      ],
      [
        1530.0,
        1270.0,
        622.3255004882812
      ],
      [
        1530.0,
        1270.0,
        490.0
      ],
      [
        1530.0,
        1270.0,
        140.0
      ],
      [
        1530.0,
        1270.0,
        622.3255004882812
      ],
      [
        1530.0,
        1130.0,
        465.0
      ],
      [
        1530.0,
        1130.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        465.0
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1600.0,
        1120.0,
        130.0
      ],
      [
        1555.0,
        1120.0,
        118.0
      ],
      [
        1600.0,
        1130.0,
        118.0
      ],
      [
        1555.0,
        1130.0,
        118.0
      ],
      [
        1600.0,
        1130.0,
        120.0
      ],
      [
        1555.0,
        1120.0,
        120.0
      ],
      [
        1555.0,
        1130.0,
        120.0
      ],
      [
        1555.0,
        1120.0,
        100.0
      ],
      [
        1555.0,
        1130.0,
        100.0
      ],
      [
        1600.0,
        1130.0,
        100.0
      ],
      [
        1530.0,
        1120.0,
        120.0
      ],
      [
        1530.0,
        1130.0,
        120.0
      ],
      [
        1530.0,
        1120.0,
        100.0
      ],
      [
        1530.0,
        1130.0,
        100.0
      ],
      [
        1530.0,
        1120.0,
        118.0
      ],
      [
        1530.0,
        1130.0,
        118.0
      ],
      [
        1535.0,
        1130.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1130.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1130.0,
        138.0
      ],
      [
        1535.0,
        1130.0,
        140.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1530.0,
        1130.0,
        140.0
      ],
      [
        1530.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1170.0,
        140.0
      ],
      [
        1530.0,
        1170.0,
        100.0
      ],
      [
        1530.0,
        1170.0,
        100.0
      ],
      [
        1530.0,
        1140.0,
        120.0
      ],
      [
        1530.0,
        1140.0,
        118.0
      ],
      [
        1530.0,
        1140.0,
        120.0
      ],
      [
        1530.0,
        1140.0,
        118.0
      ],
      [
        1557.0,
        1110.0,
        120.0
      ],
      [
        1556.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1110.0,
        120.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1400.0,
        1270.0,
        140.0
      ],
      [
        1400.0,
        1270.0,
        108.69564819335938
      ],
      [
        1350.0,
        1320.0,
        108.69564819335938
      ],
      [
        1400.0,
        1270.0,
        108.69564819335938
      ],
      [
        1350.0,
        1270.0,
        106.52173614501953
      ],
      [
        1350.0,
        1290.0,
        140.0
      ],
      [
        1350.0,
        1290.0,
        138.0
      ],
      [
        1422.7491455078125,
        1362.7491455078125,
        360.0
      ],
      [
        1422.7491455078125,
        1362.7491455078125,
        340.0
      ],
      [
        1387.393798828125,
        1327.393798828125,
        410.0
      ],
      [
        1387.393798828125,
        1327.393798828125,
        390.0
      ],
      [
        1350.0,
        1130.0,
        250.10211181640625
      ],
      [
        1350.0,
        1130.0,
        160.0
      ],
      [
        1395.0,
        1120.0,
        130.0
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        465.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1120.0,
        465.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        118.0
      ],
      [
        1530.0,
        1130.0,
        118.0
      ],
      [
        1475.0,
        1130.0,
        118.0
      ],
      [
        1475.0,
        1130.0,
        120.0
      ],
      [
        1530.0,
        1130.0,
        120.0
      ],
      [
        1475.0,
        1120.0,
        120.0
      ],
      [
        1475.0,
        1120.0,
        100.0
      ],
      [
        1475.0,
        1130.0,
        100.0
      ],
      [
        1530.0,
        1130.0,
        100.0
      ],
      [
        1395.0,
        1130.0,
        120.0
      ],
      [
        1395.0,
        1120.0,
        120.0
      ],
      [
        1395.0,
        1120.0,
        100.0
      ],
      [
        1395.0,
        1130.0,
        100.0
      ],
      [
        1395.0,
        1120.0,
        118.0
      ],
      [
        1395.0,
        1130.0,
        118.0
      ],
      [
        1395.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1130.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1455.0,
        1130.0,
        138.0
      ],
      [
        1475.0,
        1130.0,
        138.0
      ],
      [
        1455.0,
        1130.0,
        138.0
      ],
      [
        1350.0,
        1120.0,
        140.0
      ],
      [
        1350.0,
        1130.0,
        160.0
      ],
      [
        1350.0,
        1120.0,
        100.0
      ],
      [
        1350.0,
        1130.0,
        100.0
      ],
      [
        1350.0,
        1120.0,
        120.0
      ],
      [
        1350.0,
        1130.0,
        120.0
      ],
      [
        1360.0,
        1130.0,
        120.0
      ],
      [
        1360.0,
        1130.0,
        120.0
      ],
      [
        1360.0,
        1130.0,
        118.0
      ],
      [
        1350.0,
        1130.0,
        118.0
      ],
      [
        1350.0,
        1120.0,
        118.0
      ],
      [
        1360.0,
        1130.0,
        118.0
      ],
      [
        1350.0,
        1170.0,
        140.0
      ],
      [
        1350.0,
        1170.0,
        100.0
      ],
      [
        1350.0,
        1220.0,
        140.0
      ],
      [
        1350.0,
        1220.0,
        104.34782409667969
      ],
      [
        1350.0,
        1220.0,
        104.34782409667969
      ],
      [
        1350.0,
        1170.0,
        100.0
      ],
      [
        1350.0,
        1170.0,
        102.17391204833984
      ],
      [
        1250.0,
        1130.0,
        250.10211181640625
      ],
      [
        1250.0,
        1130.0,
        160.0
      ],
      [
        1250.0,
        1130.0,
        160.0
      ],
      [
        1250.0,
        1130.0,
        118.0
      ],
      [
        1250.0,
        1120.0,
        118.0
      ],
      [
        1350.0,
        1130.0,
        118.0
      ],
      [
        1250.0,
        1120.0,
        120.0
      ],
      [
        1250.0,
        1130.0,
        120.0
      ],
      [
        1350.0,
        1130.0,
        120.0
      ],
      [
        1300.0,
        1130.0,
        100.0
      ],
      [
        1250.0,
        1130.0,
        100.0
      ],
      [
        1300.0,
        1130.0,
        100.0
      ],
      [
        1340.0,
        1130.0,
        100.0
      ],
      [
        1250.0,
        1140.0,
        120.0
      ],
      [
        1250.0,
        1140.0,
        118.0
      ],
      [
        1300.0,
        1170.0,
        120.0
      ],
      [
        1300.0,
        1170.0,
        118.0
      ],
      [
        1350.0,
        1220.0,
        118.0
      ],
      [
        1350.0,
        1220.0,
        120.0
      ],
      [
        1350.0,
        1170.0,
        120.0
      ],
      [
        1350.0,
        1170.0,
        118.0
      ],
      [
        1300.0,
        1170.0,
        118.0
      ],
      [
        1300.0,
        1170.0,
        120.0
      ],
      [
        1336.0,
        1160.0,
        118.0
      ],
      [
        1336.0,
        1150.0,
        118.0
      ],
      [
        1336.0,
        1150.0,
        118.0
      ],
      [
        1346.0,
        1170.0,
        120.0
      ],
      [
        1346.0,
        1160.0,
        120.0
      ],
      [
        1346.0,
        1160.0,
        120.0
      ],
      [
        1290.0,
        1160.0,
        140.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1250.0,
        1690.0,
        379.0
      ],
      [
        1250.0,
        1630.0,
        379.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        140.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        515.0
      ],
      [
        1488.70166015625,
        992.9840087890625,
        140.0
      ],
      [
        1488.70166015625,
        992.9839477539062,
        515.0
      ],
      [
        1477.0,
        1110.0,
        120.0
      ],
      [
        1476.0,
        1120.0,
        130.0
      ],
      [
        1405.0,
        1110.0,
        120.0
      ],
      [
        1405.0,
        1120.0,
        130.0
      ],
      [
        1397.0,
        1110.0,
        120.0
      ],
      [
        1396.0,
        1120.0,
        130.0
      ],
      [
        1250.0,
        919.5852661132812,
        160.0
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1390.0,
        962.6142578125,
        160.0
      ],
      [
        1330.0,
        944.1526489257812,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        98.0
      ],
      [
        1250.0,
        919.5372924804688,
        98.0
      ],
      [
        1330.0,
        944.1526489257812,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        100.0
      ],
      [
        1330.0,
        944.1526489257812,
        100.0
      ],
      [
        1250.0,
        919.5372924804688,
        100.0
      ],
      [
        1330.0,
        944.1526489257812,
        100.0
      ],
      [
        1390.0,
        960.0,
        160.0
      ],
      [
        1381.503662109375,
        960.0,
        160.0
      ],
      [
        1250.0,
        914.8063354492188,
        160.0
      ],
      [
        1480.0,
        920.0,
        98.0
      ],
      [
        1480.0,
        920.0,
        100.0
      ],
      [
        1480.0,
        920.0,
        98.0
      ],
      [
        1500.0,
        920.0,
        98.0
      ],
      [
        1510.0,
        904.0,
        98.0
      ],
      [
        1520.0,
        904.0,
        98.0
      ],
      [
        1510.0,
        904.0,
        98.0
      ],
      [
        1520.0,
        920.0,
        88.0
      ],
      [
        1510.0,
        920.0,
        88.0
      ],
      [
        1510.0,
        920.0,
        90.0
      ],
      [
        1510.0,
        920.0,
        88.0
      ],
      [
        1510.0,
        920.0,
        90.0
      ],
      [
        1520.0,
        920.0,
        90.0
      ],
      [
        760.0,
        460.0,
        140.0
      ],
      [
        760.0,
        516.0,
        140.0
      ],
      [
        760.0,
        707.730224609375,
        140.0
      ],
      [
        762.4912719726562,
        707.730224609375,
        140.0
      ],
      [
        762.4912719726562,
        707.730224609375,
        140.0
      ],
      [
        766.0144653320312,
        707.730224609375,
        140.0
      ],
      [
        880.0,
        640.0,
        140.0
      ],
      [
        840.0,
        640.0,
        140.0
      ],
      [
        990.0,
        640.0,
        140.0
      ],
      [
        950.0,
        640.0,
        140.0
      ],
      [
        1040.0,
        600.0,
        140.0
      ],
      [
        990.0,
        640.0,
        140.0
      ],
      [
        930.0,
        600.0,
        140.0
      ],
      [
        880.0,
        640.0,
        140.0
      ],
      [
        950.0,
        640.0,
        140.0
      ],
      [
        950.0,
        600.0,
        140.0
      ],
      [
        1060.0,
        640.0,
        140.0
      ],
      [
        1060.0,
        600.0,
        140.0
      ],
      [
        1040.0,
        600.0,
        140.0
      ],
      [
        1060.0,
        600.0,
        140.0
      ],
      [
        760.0,
        615.8578491210938,
        100.0
      ],
      [
        760.0,
        640.0,
        100.0
      ],
      [
        760.0,
        460.0,
        100.0
      ],
      [
        760.0,
        615.8578491210938,
        100.0
      ],
      [
        760.0,
        615.8578491210938,
        80.0
      ],
      [
        760.0,
        615.8578491210938,
        100.0
      ],
      [
        760.0,
        615.8577880859375,
        98.0
      ],
      [
        760.0,
        640.0,
        98.0
      ],
      [
        760.0,
        460.0,
        140.0
      ],
      [
        760.0,
        460.0,
        100.0
      ],
      [
        760.0,
        644.1637573242188,
        100.0
      ],
      [
        760.0,
        644.163818359375,
        98.0
      ],
      [
        760.0,
        644.163818359375,
        100.0
      ],
      [
        760.0,
        644.1637573242188,
        98.0
      ],
      [
        782.269775390625,
        707.730224609375,
        118.0
      ],
      [
        789.3162231445312,
        707.730224609375,
        118.0
      ],
      [
        794.298828125,
        707.730224609375,
        118.0
      ],
      [
        789.3162231445312,
        707.730224609375,
        118.0
      ],
      [
        789.3162231445312,
        707.730224609375,
        120.0
      ],
      [
        782.269775390625,
        707.730224609375,
        120.0
      ],
      [
        794.298828125,
        707.730224609375,
        120.0
      ],
      [
        789.3162231445312,
        707.730224609375,
        120.0
      ],
      [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      [
        760.0,
        334.07470703125,
        190.0
      ],
      [
        760.0,
        516.0,
        190.0
      ],
      [
        1040.0,
        600.0,
        190.0
      ],
      [
        990.0,
        640.0,
        190.0
      ],
      [
        930.0,
        600.0,
        190.0
      ],
      [
        880.0,
        640.0,
        190.0
      ],
      [
        880.0,
        640.0,
        190.0
      ],
      [
        840.0,
        640.0,
        190.0
      ],
      [
        990.0,
        640.0,
        190.0
      ],
      [
        950.0,
        640.0,
        190.0
      ],
      [
        950.0,
        640.0,
        190.0
      ],
      [
        950.0,
        600.0,
        190.0
      ],
      [
        1060.0,
        640.0,
        190.0
      ],
      [
        1060.0,
        600.0,
        190.0
      ],
      [
        1040.0,
        600.0,
        190.0
      ],
      [
        1060.0,
        600.0,
        190.0
      ],
      [
        760.0,
        516.0,
        190.0
      ],
      [
        760.0,
        516.0,
        140.0
      ],
      [
        766.0144653320312,
        707.730224609375,
        140.0
      ],
      [
        760.0,
        701.7157592773438,
        190.0
      ],
      [
        766.0144653320312,
        707.730224609375,
        190.0
      ],
      [
        760.0,
        516.0999755859375,
        175.0
      ],
      [
        760.0,
        516.0999755859375,
        145.0
      ],
      [
        766.0144653320312,
        707.730224609375,
        220.0
      ],
      [
        760.0,
        707.730224609375,
        220.0
      ],
      [
        762.6031494140625,
        707.730224609375,
        232.14804077148438
      ],
      [
        950.0,
        1541.28955078125,
        140.0
      ],
      [
        950.0,
        1570.0,
        140.0
      ],
      [
        950.0,
        950.0,
        140.0
      ],
      [
        950.0,
        930.0,
        140.0
      ],
      [
        950.0,
        920.0,
        140.0
      ],
      [
        950.0,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        950.0,
        1120.0,
        140.0
      ],
      [
        1030.0,
        1550.0,
        140.0
      ],
      [
        1030.0,
        1570.0,
        140.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1170.0,
        140.0
      ],
      [
        1030.0,
        1460.0,
        140.0
      ],
      [
        1030.0,
        1550.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1390.0,
        140.0
      ],
      [
        1030.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1460.0,
        140.0
      ],
      [
        1030.0,
        1460.0,
        140.0
      ],
      [
        1030.0,
        1590.0,
        118.0
      ],
      [
        1030.0,
        1590.0,
        120.0
      ],
      [
        1030.0,
        1610.0,
        120.0
      ],
      [
        1030.0,
        1590.0,
        120.0
      ],
      [
        1030.0,
        1590.0,
        118.0
      ],
      [
        1030.0,
        1610.0,
        118.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1037.2222900390625,
        1629.509521484375,
        120.0
      ],
      [
        1036.5,
        1690.0,
        118.0
      ],
      [
        1037.2222900390625,
        1690.0,
        120.0
      ],
      [
        1037.2222900390625,
        1629.509521484375,
        120.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1200.0,
        1620.0,
        118.0
      ],
      [
        1033.75,
        1620.0,
        118.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        100.0
      ],
      [
        1030.0,
        1590.0,
        80.0
      ],
      [
        1030.0,
        1610.0,
        114.0
      ],
      [
        1030.0,
        1620.0,
        114.0
      ],
      [
        1030.0,
        1620.0,
        116.0
      ],
      [
        1030.0,
        1610.0,
        116.0
      ],
      [
        1030.0,
        1610.0,
        116.0
      ],
      [
        1030.0,
        1610.0,
        114.0
      ],
      [
        1037.5947265625,
        1690.0,
        140.0
      ],
      [
        1037.5947265625,
        1639.419189453125,
        140.0
      ],
      [
        1187.731689453125,
        1630.0,
        140.0
      ],
      [
        1037.5947265625,
        1630.0,
        140.0
      ],
      [
        1037.5947265625,
        1630.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1090.0,
        1390.0,
        140.0
      ],
      [
        1090.0,
        1460.0,
        140.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        100.0
      ],
      [
        1030.0,
        1440.0,
        100.0
      ],
      [
        1030.0,
        1460.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1030.0,
        1460.0,
        98.0
      ],
      [
        1030.0,
        1440.0,
        98.0
      ],
      [
        1030.0,
        1440.0,
        100.0
      ],
      [
        1030.0,
        1440.0,
        98.0
      ],
      [
        1250.0,
        1170.0,
        100.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1170.0,
        118.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1120.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1120.0,
        120.0
      ],
      [
        980.0,
        1120.0,
        118.0
      ],
      [
        980.0,
        1120.0,
        120.0
      ],
      [
        950.0,
        1660.0,
        100.0
      ],
      [
        950.0,
        1630.0,
        100.0
      ],
      [
        950.0,
        1690.0,
        100.0
      ],
      [
        950.0,
        1660.0,
        100.0
      ],
      [
        950.0,
        1570.0,
        100.0
      ],
      [
        950.0,
        1600.0,
        100.0
      ],
      [
        950.0,
        1460.0,
        100.0
      ],
      [
        950.0,
        1541.28955078125,
        100.0
      ],
      [
        980.0,
        1460.0,
        100.0
      ],
      [
        950.0,
        1543.0755615234375,
        98.0
      ],
      [
        950.0,
        1570.0,
        98.0
      ],
      [
        950.0,
        1541.28955078125,
        98.0
      ],
      [
        950.0,
        1543.0755615234375,
        98.0
      ],
      [
        950.0,
        1541.28955078125,
        98.0
      ],
      [
        950.0,
        1460.0,
        98.0
      ],
      [
        980.0,
        1460.0,
        98.0
      ],
      [
        950.0,
        1570.0,
        100.0
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        950.0,
        1570.0,
        98.0
      ],
      [
        960.0,
        1550.0,
        98.0
      ],
      [
        960.0,
        1550.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        100.0
      ],
      [
        980.0,
        1550.0,
        98.0
      ],
      [
        950.0,
        1570.0,
        80.0
      ],
      [
        955.0,
        1655.0,
        140.0
      ],
      [
        980.0,
        1670.0,
        140.0
      ],
      [
        950.0,
        1586.6666259765625,
        120.0
      ],
      [
        950.0,
        1586.6666259765625,
        140.0
      ],
      [
        960.0,
        1570.0,
        140.0
      ],
      [
        950.0,
        1308.71044921875,
        100.0
      ],
      [
        950.0,
        1280.0,
        98.0
      ],
      [
        950.0,
        1306.9244384765625,
        98.0
      ],
      [
        950.0,
        1308.71044921875,
        98.0
      ],
      [
        950.0,
        1306.9244384765625,
        98.0
      ],
      [
        950.0,
        1308.71044921875,
        98.0
      ],
      [
        980.0,
        1170.0,
        98.0
      ],
      [
        960.0,
        1120.0,
        98.0
      ],
      [
        980.0,
        1280.0,
        98.0
      ],
      [
        950.0,
        1280.0,
        100.0
      ],
      [
        950.0,
        1280.0,
        98.0
      ],
      [
        960.0,
        1280.0,
        100.0
      ],
      [
        960.0,
        1280.0,
        98.0
      ],
      [
        960.0,
        1300.0,
        98.0
      ],
      [
        960.0,
        1300.0,
        100.0
      ],
      [
        960.0,
        1300.0,
        100.0
      ],
      [
        960.0,
        1300.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        98.0
      ],
      [
        980.0,
        1300.0,
        100.0
      ],
      [
        950.0,
        1280.0,
        80.0
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        950.0,
        1280.0,
        100.0
      ],
      [
        980.0,
        1280.0,
        140.0
      ],
      [
        950.0,
        1280.0,
        140.0
      ],
      [
        980.0,
        1120.0,
        133.9837646484375
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        980.0,
        1460.0,
        98.0
      ],
      [
        980.0,
        1460.0,
        100.0
      ],
      [
        1003.75,
        1610.0,
        100.0
      ],
      [
        1003.75,
        1620.0,
        100.0
      ],
      [
        1003.75,
        1610.0,
        100.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        990.0,
        1120.0,
        120.0
      ],
      [
        980.0,
        1120.0,
        120.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        980.0,
        1120.0,
        118.0
      ],
      [
        988.9999389648438,
        1120.0,
        118.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        1000.0,
        1120.0,
        100.0
      ],
      [
        1000.0,
        1120.0,
        98.0
      ],
      [
        1000.0,
        1120.0,
        98.0
      ],
      [
        1000.0,
        1120.0,
        100.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1010.0,
        1386.0,
        98.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1020.0,
        1246.0,
        100.0
      ],
      [
        1030.0,
        1246.0,
        100.0
      ],
      [
        1020.0,
        1246.0,
        100.0
      ],
      [
        1030.0,
        1206.0,
        120.0
      ],
      [
        1020.0,
        1206.0,
        120.0
      ],
      [
        1020.0000610351562,
        1120.0,
        118.0
      ],
      [
        1020.0000610351562,
        1140.0,
        118.0
      ],
      [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      [
        1020.0000610351562,
        1120.0,
        120.0
      ],
      [
        1010.0,
        1120.0,
        100.0
      ],
      [
        959.5000610351562,
        1100.9998779296875,
        98.0
      ],
      [
        950.0,
        1100.9998779296875,
        98.0
      ],
      [
        999.0000610351562,
        1100.9998779296875,
        98.0
      ],
      [
        959.5000610351562,
        1100.9998779296875,
        98.0
      ],
      [
        999.0000610351562,
        1100.9998779296875,
        98.0
      ],
      [
        1000.0,
        1100.9998779296875,
        98.0
      ],
      [
        1000.0,
        1100.9998779296875,
        98.0
      ],
      [
        950.0,
        930.0,
        98.88888549804688
      ],
      [
        950.0,
        930.0,
        80.0
      ],
      [
        950.0,
        930.0,
        98.88888549804688
      ],
      [
        950.0,
        930.0,
        140.0
      ],
      [
        1215.0,
        930.0,
        120.0
      ],
      [
        1235.0,
        930.0,
        120.0
      ],
      [
        1235.0,
        930.0,
        118.0
      ],
      [
        1215.0,
        930.0,
        118.0
      ],
      [
        1215.0,
        930.0,
        120.0
      ],
      [
        1215.0,
        930.0,
        118.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1189.5999755859375,
        940.4000244140625,
        140.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1159.5999755859375,
        1109.199951171875,
        140.0
      ],
      [
        1020.7999877929688,
        970.4000244140625,
        140.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1159.5999755859375,
        940.7999877929688,
        140.0
      ],
      [
        1160.0,
        940.4000244140625,
        140.0
      ],
      [
        1020.3999633789062,
        1080.0,
        140.0
      ],
      [
        1020.7999877929688,
        1079.5999755859375,
        140.0
      ],
      [
        1016.6666870117188,
        1083.3333740234375,
        140.0
      ],
      [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      [
        1016.6666870117188,
        966.2667236328125,
        140.0
      ],
      [
        1016.6666870117188,
        1083.7332763671875,
        140.0
      ],
      [
        1010.0,
        940.0,
        130.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        940.4000244140625,
        140.0
      ],
      [
        1010.0,
        1110.0,
        130.0
      ],
      [
        1010.7999877929688,
        1109.5999755859375,
        140.0
      ],
      [
        1010.7999877929688,
        1089.5999755859375,
        140.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        1089.5999755859375,
        140.0
      ],
      [
        1163.3333740234375,
        936.6666870117188,
        140.0
      ],
      [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      [
        1163.7332763671875,
        936.6666870117188,
        140.0
      ],
      [
        1010.7999877929688,
        936.6666870117188,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      [
        1169.5999755859375,
        930.7999877929688,
        140.0
      ],
      [
        1199.199951171875,
        930.7999877929688,
        140.0
      ],
      [
        1169.5999755859375,
        930.7999877929688,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1163.3333740234375,
        1113.3333740234375,
        140.0
      ],
      [
        1046.6666259765625,
        1113.3333740234375,
        140.0
      ],
      [
        1163.7333984375,
        1113.3333740234375,
        140.0
      ],
      [
        1010.7999877929688,
        1113.3333740234375,
        140.0
      ],
      [
        1040.4000244140625,
        1119.199951171875,
        140.0
      ],
      [
        1010.7999877929688,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        1010.7999877929688,
        1119.199951171875,
        140.0
      ],
      [
        1000.0,
        930.0,
        120.0
      ],
      [
        1000.0,
        930.0,
        118.0
      ],
      [
        986.2361450195312,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        986.2120971679688,
        930.0,
        120.0
      ],
      [
        1000.0,
        930.0,
        120.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        980.0,
        930.0,
        120.0
      ],
      [
        986.2361450195312,
        930.0,
        118.0
      ],
      [
        980.0,
        930.0,
        118.0
      ],
      [
        1000.0,
        930.0,
        118.0
      ],
      [
        986.2120971679688,
        930.0,
        118.0
      ],
      [
        980.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        960.0,
        930.0,
        120.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        950.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        956.0,
        990.0,
        108.0
      ],
      [
        956.0,
        970.0,
        108.0
      ],
      [
        960.0,
        1084.0,
        108.00000762939453
      ],
      [
        960.0,
        1084.0,
        108.00000762939453
      ],
      [
        956.0,
        1084.0,
        108.00000762939453
      ],
      [
        956.0,
        1070.0,
        108.0
      ],
      [
        950.0,
        1084.0,
        108.0
      ],
      [
        950.0,
        1094.0,
        103.00000762939453
      ],
      [
        950.0,
        1090.0,
        103.00000762939453
      ],
      [
        1125.0,
        910.0,
        98.0
      ],
      [
        1125.0,
        900.0,
        98.0
      ],
      [
        1125.0,
        910.0,
        98.0
      ],
      [
        980.0,
        900.0,
        120.0
      ],
      [
        980.0,
        920.0,
        120.0
      ],
      [
        1000.0,
        920.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        120.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        978.2843017578125,
        920.0,
        120.0
      ],
      [
        958.2843017578125,
        900.0,
        120.0
      ],
      [
        950.0,
        900.0,
        120.0
      ],
      [
        1215.0,
        900.0,
        120.0
      ],
      [
        1215.0,
        920.0,
        120.0
      ],
      [
        1235.0,
        920.0,
        120.0
      ],
      [
        1235.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        1000.0,
        920.0,
        118.0
      ],
      [
        980.0,
        920.0,
        118.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        978.2843017578125,
        920.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        900.0,
        118.0
      ],
      [
        1235.0,
        900.0,
        118.0
      ],
      [
        1235.0,
        920.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        118.0
      ],
      [
        1215.0,
        900.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        120.0
      ],
      [
        978.2843017578125,
        920.0,
        120.0
      ],
      [
        978.2843017578125,
        920.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        1000.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        920.0,
        120.0
      ],
      [
        1000.0,
        920.0,
        118.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        980.0,
        920.0,
        120.0
      ],
      [
        980.0,
        900.0,
        120.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        980.0,
        920.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        120.0
      ],
      [
        1215.0,
        900.0,
        120.0
      ],
      [
        1215.0,
        900.0,
        118.0
      ],
      [
        1215.0,
        920.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        950.0,
        920.0,
        98.88888549804688
      ],
      [
        950.0,
        920.0,
        80.0
      ],
      [
        950.0,
        920.0,
        140.0
      ],
      [
        950.0,
        920.0,
        98.88888549804688
      ],
      [
        950.0,
        950.0,
        140.0
      ],
      [
        950.0,
        950.0,
        220.0
      ],
      [
        1240.0,
        950.0,
        259.00299072265625
      ],
      [
        1240.0,
        950.0,
        160.0
      ],
      [
        1240.0,
        1120.0,
        160.0
      ],
      [
        1240.0,
        1690.0,
        379.0
      ],
      [
        1240.0,
        1630.0,
        379.0
      ],
      [
        1250.0,
        950.0,
        140.0
      ],
      [
        1240.0,
        950.0,
        160.0
      ],
      [
        950.0,
        1120.0,
        140.0
      ],
      [
        950.0,
        1120.0,
        280.0
      ],
      [
        950.0,
        1280.0,
        180.0
      ],
      [
        950.0,
        1280.0,
        140.0
      ],
      [
        950.0,
        1280.0,
        280.0
      ],
      [
        950.0,
        1280.0,
        400.0
      ],
      [
        1000.0,
        1170.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        950.0,
        1179.3992919921875,
        380.0
      ],
      [
        950.0,
        1179.3992919921875,
        300.0
      ],
      [
        985.4664306640625,
        1170.0,
        280.0
      ],
      [
        950.0,
        1179.3992919921875,
        280.0
      ],
      [
        950.0,
        1179.3992919921875,
        400.0
      ],
      [
        985.4664306640625,
        1170.0,
        400.0
      ],
      [
        950.0,
        1170.0,
        280.0
      ],
      [
        950.0,
        1179.3992919921875,
        280.0
      ],
      [
        985.4664306640625,
        1170.0,
        280.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        950.0,
        1120.0,
        280.0
      ],
      [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      [
        1030.0,
        1550.0,
        180.0
      ],
      [
        1030.0,
        1550.0,
        160.0
      ],
      [
        1030.0,
        1550.0,
        160.0
      ],
      [
        1030.0,
        1570.0,
        160.0
      ],
      [
        1039.49951171875,
        1630.0,
        160.0
      ],
      [
        1170.0,
        1630.0,
        160.0
      ],
      [
        1057.5947265625,
        1630.0,
        303.5163879394531
      ],
      [
        1083.078369140625,
        1630.0,
        329.0
      ],
      [
        1057.5947265625,
        1630.0,
        303.5163879394531
      ],
      [
        1039.49951171875,
        1690.0,
        160.0
      ],
      [
        1039.49951171875,
        1630.0,
        160.0
      ],
      [
        1075.0,
        1470.0,
        580.0
      ],
      [
        1175.0,
        1470.0,
        580.0
      ],
      [
        1075.0,
        1540.0,
        580.0
      ],
      [
        1075.0,
        1470.0,
        580.0
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1540.0,
        370.0852355957031
      ],
      [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      [
        1030.0,
        1470.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1470.0,
        370.0852355957031
      ],
      [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      [
        1030.0,
        1540.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        1090.0,
        1310.0,
        515.0
      ],
      [
        1090.0,
        1310.0,
        580.0
      ],
      [
        1175.0,
        1310.0,
        580.0
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1030.0,
        1330.0,
        355.9431457519531
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1075.0,
        1380.0,
        580.0
      ],
      [
        1075.0,
        1310.0,
        580.0
      ],
      [
        1075.0,
        1310.0,
        580.0
      ],
      [
        1030.0,
        1280.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        160.0
      ],
      [
        950.0,
        1670.0,
        150.0
      ],
      [
        950.0,
        1680.0,
        150.0
      ],
      [
        950.0,
        1652.0,
        140.0
      ],
      [
        960.0,
        1658.0,
        150.0
      ],
      [
        950.0,
        1586.6666259765625,
        216.0
      ],
      [
        960.0,
        1580.0,
        150.0
      ],
      [
        954.0000610351562,
        1580.0,
        150.0
      ],
      [
        954.0000610351562,
        1580.0,
        200.0
      ],
      [
        970.0,
        1580.0,
        159.99996948242188
      ],
      [
        950.0,
        1590.0,
        150.0
      ],
      [
        950.0,
        1580.0,
        150.0
      ],
      [
        950.0,
        1580.0,
        200.0
      ],
      [
        950.0,
        1310.0,
        290.0852355957031
      ],
      [
        950.0,
        1330.0,
        290.085205078125
      ],
      [
        950.0,
        1520.0,
        290.0852355957031
      ],
      [
        950.0,
        1540.0,
        290.0852355957031
      ],
      [
        950.0,
        1330.0,
        290.0852355957031
      ],
      [
        950.0,
        1520.0,
        290.085205078125
      ],
      [
        950.0,
        1520.0,
        290.0852355957031
      ],
      [
        950.0,
        1330.0,
        290.085205078125
      ],
      [
        950.0,
        1330.0,
        275.943115234375
      ],
      [
        950.0,
        1310.0,
        275.943115234375
      ],
      [
        950.0,
        1540.0,
        275.943115234375
      ],
      [
        950.0,
        1520.0,
        275.943115234375
      ],
      [
        950.0,
        1520.0,
        290.085205078125
      ],
      [
        950.0,
        1520.0,
        275.943115234375
      ],
      [
        950.0,
        1310.0,
        290.0852355957031
      ],
      [
        950.0,
        1310.0,
        275.943115234375
      ],
      [
        950.0,
        1541.28955078125,
        180.0
      ],
      [
        950.0,
        1541.28955078125,
        160.0
      ],
      [
        950.0,
        1541.28955078125,
        140.0
      ],
      [
        1020.4000244140625,
        950.0,
        140.0
      ],
      [
        1038.0,
        957.0,
        580.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1155.0,
        950.0,
        255.0000762939453
      ],
      [
        1020.3999633789062,
        1080.0,
        140.0
      ],
      [
        1037.0,
        1092.0,
        580.0
      ],
      [
        1010.7999877929688,
        1109.5999755859375,
        140.0
      ],
      [
        1010.7999877929688,
        950.0,
        140.0
      ],
      [
        1075.0,
        1470.0,
        750.0
      ],
      [
        1175.0,
        1470.0,
        750.0
      ],
      [
        1075.0,
        1540.0,
        750.0
      ],
      [
        1075.0,
        1470.0,
        750.0
      ],
      [
        1075.0,
        1310.0,
        750.0
      ],
      [
        1175.0,
        1310.0,
        750.0
      ],
      [
        1075.0,
        1380.0,
        750.0
      ],
      [
        1075.0,
        1310.0,
        750.0
      ],
      [
        1240.0,
        916.4603881835938,
        160.0
      ],
      [
        1240.0,
        916.4603881835938,
        161.1999969482422
      ],
      [
        1240.0,
        916.4603881835938,
        160.0
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1010.7999877929688,
        940.4000244140625,
        140.0
      ],
      [
        1160.0,
        940.4000244140625,
        140.0
      ],
      [
        998.6842041015625,
        940.3999633789062,
        140.0
      ],
      [
        1001.8842163085938,
        943.5999755859375,
        220.0
      ],
      [
        950.0,
        950.0,
        220.0
      ],
      [
        995.8233642578125,
        944.6067504882812,
        245.16854858398438
      ],
      [
        950.0,
        944.6067504882812,
        245.16854858398438
      ],
      [
        989.084228515625,
        930.7999877929688,
        140.0
      ],
      [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      [
        986.7498779296875,
        940.6796264648438,
        263.49517822265625
      ],
      [
        950.0,
        940.6796264648438,
        263.49517822265625
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        220.0
      ],
      [
        950.0,
        924.773681640625,
        337.72265625
      ],
      [
        760.0,
        900.0,
        140.0
      ],
      [
        780.0,
        900.0,
        140.0
      ],
      [
        930.0,
        900.0,
        140.0
      ],
      [
        780.0,
        900.0,
        80.0
      ],
      [
        780.0,
        900.0,
        140.0
      ],
      [
        780.0,
        1670.0,
        140.0
      ],
      [
        805.0,
        1655.0,
        140.0
      ],
      [
        800.0,
        1570.0,
        140.0
      ],
      [
        815.0,
        1595.0,
        140.0
      ],
      [
        780.0,
        1590.0,
        140.0
      ],
      [
        800.0,
        1570.0,
        140.0
      ],
      [
        945.0,
        1595.0,
        140.0
      ],
      [
        950.0,
        1586.6666259765625,
        140.0
      ],
      [
        890.0,
        1472.83544921875,
        89.1501693725586
      ],
      [
        890.0,
        1472.83544921875,
        91.15017700195312
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        97.99999237060547
      ],
      [
        950.0,
        1460.0,
        100.0
      ],
      [
        945.5584106445312,
        1460.0,
        100.0
      ],
      [
        933.0026245117188,
        1524.8212890625,
        98.0
      ],
      [
        933.0026245117188,
        1460.0,
        98.0
      ],
      [
        945.5584716796875,
        1460.0,
        98.0
      ],
      [
        950.0,
        1545.3692626953125,
        98.0
      ],
      [
        950.0,
        1460.0,
        98.0
      ],
      [
        780.0,
        1460.0,
        120.0
      ],
      [
        820.0,
        1460.0,
        120.0
      ],
      [
        890.0,
        1472.83544921875,
        120.0
      ],
      [
        890.0,
        1472.83544921875,
        140.0
      ],
      [
        945.5584716796875,
        1540.0,
        140.0
      ],
      [
        820.0,
        1540.0,
        140.0
      ],
      [
        890.0,
        1460.0,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        820.0,
        1540.0,
        100.0
      ],
      [
        820.0,
        1460.0,
        100.0
      ],
      [
        820.0,
        1460.0,
        80.0
      ],
      [
        790.0,
        1530.0,
        100.0
      ],
      [
        780.0,
        1530.0,
        100.0
      ],
      [
        890.0,
        1460.0,
        98.0
      ],
      [
        820.0,
        1460.0,
        120.0
      ],
      [
        780.0,
        1130.0,
        110.0
      ],
      [
        900.0,
        1120.0,
        110.0
      ],
      [
        950.0,
        1120.0,
        110.0
      ],
      [
        950.0,
        930.0,
        110.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        930.0,
        900.0,
        96.66666412353516
      ],
      [
        930.0,
        900.0,
        80.0
      ],
      [
        950.0,
        920.0,
        110.0
      ],
      [
        930.0,
        900.0,
        96.66666412353516
      ],
      [
        930.0,
        900.0,
        110.0
      ],
      [
        836.0,
        930.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        836.0,
        950.0,
        110.0
      ],
      [
        950.0,
        1280.0,
        110.0
      ],
      [
        780.0,
        1280.0,
        110.0
      ],
      [
        780.0,
        1165.0,
        110.0
      ],
      [
        900.0,
        1165.0,
        110.0
      ],
      [
        780.0,
        1130.0,
        108.0
      ],
      [
        848.3333129882812,
        1130.0,
        108.0
      ],
      [
        780.0,
        1130.0,
        110.0
      ],
      [
        780.0,
        1130.0,
        108.0
      ],
      [
        848.3333129882812,
        1130.0,
        108.0
      ],
      [
        848.3333129882812,
        1120.0,
        108.0
      ],
      [
        900.0,
        1130.0,
        110.0
      ],
      [
        900.0,
        1120.0,
        110.0
      ],
      [
        901.0,
        1120.0,
        108.0
      ],
      [
        901.0,
        1130.0,
        108.0
      ],
      [
        901.0,
        1166.0,
        108.0
      ],
      [
        900.0,
        1165.0,
        110.0
      ],
      [
        780.0,
        1310.0,
        98.0
      ],
      [
        780.0,
        1310.0,
        100.0
      ],
      [
        790.0,
        1310.0,
        100.0
      ],
      [
        790.0,
        1310.0,
        98.0
      ],
      [
        820.0,
        1310.0,
        98.0
      ],
      [
        820.0,
        1310.0,
        100.0
      ],
      [
        945.5584716796875,
        1310.0,
        100.0
      ],
      [
        945.5584716796875,
        1310.0,
        98.0
      ],
      [
        820.0,
        1400.0,
        98.0
      ],
      [
        820.0,
        1400.0,
        100.0
      ],
      [
        820.0,
        1310.0,
        100.0
      ],
      [
        820.0,
        1310.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        820.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1460.0,
        98.0
      ],
      [
        820.0,
        1460.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        98.0
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        883.0,
        1440.0,
        98.0
      ],
      [
        883.0,
        1404.0,
        98.0
      ],
      [
        883.0,
        1404.0,
        98.0
      ],
      [
        933.0026245117188,
        1310.0,
        98.0
      ],
      [
        933.0026245117188,
        1280.0,
        98.0
      ],
      [
        882.9999389648438,
        1450.0,
        98.0
      ],
      [
        780.0,
        1310.0,
        110.0
      ],
      [
        790.0,
        1310.0,
        110.0
      ],
      [
        820.0,
        1310.0,
        110.0
      ],
      [
        945.5584716796875,
        1310.0,
        110.0
      ],
      [
        820.0,
        1400.0,
        110.0
      ],
      [
        820.0,
        1310.0,
        110.0
      ],
      [
        820.0,
        1450.0,
        110.0
      ],
      [
        820.0,
        1460.0,
        110.0
      ],
      [
        890.0,
        1450.0,
        110.0
      ],
      [
        820.0,
        1450.0,
        110.0
      ],
      [
        780.0,
        1280.0,
        140.0
      ],
      [
        930.0,
        900.0,
        118.0
      ],
      [
        930.0,
        900.0,
        120.0
      ],
      [
        930.0,
        900.0,
        140.0
      ],
      [
        930.0,
        900.0,
        120.0
      ],
      [
        930.0,
        900.0,
        118.0
      ],
      [
        780.0,
        1150.0,
        140.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        140.0
      ],
      [
        865.0,
        990.0,
        140.0
      ],
      [
        865.0,
        1100.0,
        140.0
      ],
      [
        822.5736083984375,
        1083.890869140625,
        140.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        140.0
      ],
      [
        865.0,
        1100.0,
        140.0
      ],
      [
        865.0,
        990.0,
        140.0
      ],
      [
        907.4263916015625,
        1006.109130859375,
        140.0
      ],
      [
        925.0,
        1045.0,
        140.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        140.0
      ],
      [
        907.4263916015625,
        1006.109130859375,
        140.0
      ],
      [
        925.0,
        1045.0,
        140.0
      ],
      [
        805.0,
        1045.0,
        140.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        140.0
      ],
      [
        822.5736083984375,
        1083.890869140625,
        140.0
      ],
      [
        805.0,
        1045.0,
        140.0
      ],
      [
        780.0,
        950.0,
        120.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        824.0,
        950.0,
        118.0
      ],
      [
        780.0,
        950.0,
        120.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        824.0,
        950.0,
        118.0
      ],
      [
        824.0,
        930.0,
        118.0
      ],
      [
        890.0,
        1450.0,
        120.0
      ],
      [
        820.0,
        1310.0,
        140.0
      ],
      [
        820.0,
        1310.0,
        140.0
      ],
      [
        760.0,
        1690.0,
        98.0
      ],
      [
        760.0,
        1690.0,
        100.0
      ],
      [
        775.0000610351562,
        1122.5,
        110.0
      ],
      [
        775.0000610351562,
        1130.0,
        110.0
      ],
      [
        775.0000610351562,
        1040.0,
        110.0
      ],
      [
        775.0000610351562,
        1122.5,
        110.0
      ],
      [
        776.0,
        1130.0,
        108.0
      ],
      [
        776.0,
        1122.0,
        108.0
      ],
      [
        776.0,
        1122.0,
        108.0
      ],
      [
        776.0,
        1040.0,
        108.0
      ],
      [
        776.0,
        1166.0,
        108.0
      ],
      [
        775.0,
        1165.0,
        110.0
      ],
      [
        780.0,
        1165.0,
        110.0
      ],
      [
        780.0,
        1166.0,
        108.0
      ],
      [
        780.0,
        1280.0,
        108.0
      ],
      [
        780.0,
        1280.0,
        110.0
      ],
      [
        775.0,
        1280.0,
        110.0
      ],
      [
        776.0,
        1280.0,
        108.0
      ],
      [
        776.0,
        1040.0,
        108.0
      ],
      [
        775.0000610351562,
        1040.0,
        110.0
      ],
      [
        775.0000610351562,
        1130.0,
        110.0
      ],
      [
        776.0,
        1130.0,
        108.0
      ],
      [
        770.0,
        940.0,
        120.0
      ],
      [
        770.0,
        950.0,
        120.0
      ],
      [
        770.0,
        940.0,
        120.0
      ],
      [
        780.0,
        900.0,
        120.0
      ],
      [
        770.0,
        900.0,
        120.0
      ],
      [
        771.0,
        950.0,
        118.0
      ],
      [
        771.0,
        939.0,
        118.0
      ],
      [
        780.0,
        900.0,
        118.0
      ],
      [
        771.0,
        939.0,
        118.0
      ],
      [
        771.0,
        900.0,
        118.0
      ],
      [
        770.0,
        950.0,
        120.0
      ],
      [
        771.0,
        950.0,
        118.0
      ],
      [
        760.0,
        900.0,
        120.0
      ],
      [
        760.0,
        900.0,
        118.0
      ],
      [
        910.0,
        1232.41455078125,
        280.0
      ],
      [
        910.0,
        1232.41455078125,
        400.0
      ],
      [
        910.0,
        1232.41455078125,
        140.0
      ],
      [
        910.0,
        1232.41455078125,
        280.0
      ],
      [
        910.0,
        1232.4144287109375,
        320.0
      ],
      [
        950.0,
        1128.4915771484375,
        280.0
      ],
      [
        910.0,
        1151.58544921875,
        280.0
      ],
      [
        892.3572387695312,
        1161.771484375,
        140.0
      ],
      [
        892.3572387695312,
        1161.771484375,
        280.0
      ],
      [
        892.3572387695312,
        1161.771484375,
        280.0
      ],
      [
        806.0,
        1580.0,
        216.0
      ],
      [
        815.0,
        1595.0,
        150.0
      ],
      [
        806.0,
        1580.0,
        150.0
      ],
      [
        790.0,
        1664.0,
        216.0
      ],
      [
        805.0,
        1655.0,
        150.0
      ],
      [
        790.0,
        1664.0,
        150.0
      ],
      [
        945.0,
        1595.0,
        150.0
      ],
      [
        950.0,
        1586.6666259765625,
        150.0
      ],
      [
        780.0,
        1590.0,
        150.0
      ],
      [
        790.0,
        1580.0,
        216.0
      ],
      [
        790.0,
        1580.0,
        150.0
      ],
      [
        780.0,
        1670.0,
        150.0
      ],
      [
        799.9999389648438,
        1658.0,
        150.0
      ],
      [
        805.0,
        1655.0,
        144.9999542236328
      ],
      [
        945.0,
        1595.0,
        145.0
      ],
      [
        948.0,
        1590.0,
        150.0
      ],
      [
        815.0,
        1595.0,
        145.0
      ],
      [
        812.0000610351562,
        1590.0,
        150.0
      ],
      [
        806.0,
        1580.0,
        140.0
      ],
      [
        790.0,
        1580.0,
        140.0
      ],
      [
        820.0,
        1550.0,
        180.0
      ],
      [
        820.0,
        1550.0,
        140.0
      ],
      [
        820.0,
        1310.0,
        160.08518981933594
      ],
      [
        799.9147338867188,
        1310.0,
        140.0
      ],
      [
        820.0,
        1540.0,
        160.08518981933594
      ],
      [
        820.0,
        1540.0,
        145.9430694580078
      ],
      [
        820.0,
        1550.0,
        145.9430694580078
      ],
      [
        820.0,
        1550.0,
        160.08518981933594
      ],
      [
        929.0144653320312,
        1520.0,
        180.0
      ],
      [
        929.0144653320312,
        1520.0,
        140.0
      ],
      [
        820.0,
        1310.0,
        160.08518981933594
      ],
      [
        820.0,
        1280.0,
        160.08518981933594
      ],
      [
        892.7614135742188,
        900.0,
        453.33331298828125
      ],
      [
        810.0,
        900.0,
        453.3333435058594
      ],
      [
        760.0,
        900.0,
        220.0
      ],
      [
        810.0,
        900.0,
        453.33331298828125
      ],
      [
        1031.3619384765625,
        867.8525390625,
        120.0
      ],
      [
        1029.7410888671875,
        867.8524780273438,
        118.0
      ],
      [
        1047.9403076171875,
        887.8524780273438,
        118.0
      ],
      [
        1047.9403076171875,
        887.8524780273438,
        118.0
      ],
      [
        1049.56103515625,
        887.8524780273438,
        120.0
      ],
      [
        1014.2000122070312,
        867.8925170898438,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        1034.1600341796875,
        887.8524780273438,
        118.0
      ],
      [
        1014.2000122070312,
        867.8925170898438,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        118.0
      ],
      [
        1029.7412109375,
        867.8525390625,
        118.0
      ],
      [
        1034.1600341796875,
        887.8524780273438,
        118.0
      ],
      [
        1034.1600341796875,
        887.8524780273438,
        120.0
      ],
      [
        930.0,
        900.0,
        120.0
      ],
      [
        780.0,
        900.0,
        118.0
      ],
      [
        780.0,
        900.0,
        120.0
      ],
      [
        780.0,
        750.0,
        118.0
      ],
      [
        1000.0,
        882.0472412109375,
        120.0
      ],
      [
        1000.0,
        882.0472412109375,
        118.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        140.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        140.0
      ],
      [
        1024.16015625,
        867.8525390625,
        140.0
      ],
      [
        1142.5,
        867.8525390625,
        140.0
      ],
      [
        1200.0,
        867.8525390625,
        140.0
      ],
      [
        1107.5,
        867.8525390625,
        140.0
      ],
      [
        1024.16015625,
        867.8525390625,
        140.0
      ],
      [
        1142.5,
        867.8525390625,
        140.0
      ],
      [
        1142.5,
        825.0,
        140.0
      ],
      [
        760.0,
        867.8525390625,
        220.0
      ],
      [
        831.906494140625,
        867.8525390625,
        555.5635375976562
      ],
      [
        926.1367797851562,
        867.8525390625,
        140.0
      ],
      [
        926.1367797851562,
        867.8525390625,
        220.0
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        340.0
      ],
      [
        650.0,
        980.0,
        160.0
      ],
      [
        650.0,
        980.0,
        190.0
      ],
      [
        650.0,
        980.0,
        80.0
      ],
      [
        650.0,
        980.0,
        120.0
      ],
      [
        440.0,
        1460.0,
        190.0
      ],
      [
        440.0,
        1460.0,
        240.0
      ],
      [
        440.0,
        1460.0,
        120.0
      ],
      [
        360.0,
        1460.0,
        120.0
      ],
      [
        360.0,
        1460.0,
        140.0
      ],
      [
        440.0,
        1460.0,
        140.0
      ],
      [
        440.0,
        1460.0,
        80.0
      ],
      [
        360.0,
        1460.0,
        80.0
      ],
      [
        360.0,
        1460.0,
        120.0
      ],
      [
        440.0,
        1460.0,
        120.0
      ],
      [
        440.0,
        1460.0,
        140.0
      ],
      [
        360.0,
        1460.0,
        140.0
      ],
      [
        360.0,
        1460.0,
        190.0
      ],
      [
        440.0,
        1460.0,
        190.0
      ],
      [
        360.0,
        1460.0,
        287.368408203125
      ],
      [
        440.0,
        1460.0,
        245.26315307617188
      ],
      [
        440.0,
        1460.0,
        240.0
      ],
      [
        360.0,
        1460.0,
        240.0
      ],
      [
        440.0,
        1688.0108642578125,
        240.0
      ],
      [
        440.0,
        1690.0,
        240.0
      ],
      [
        440.0,
        1510.0,
        150.0
      ],
      [
        440.0,
        1510.0,
        140.0
      ],
      [
        440.0,
        1520.0,
        80.0
      ],
      [
        440.0,
        1520.0,
        95.0
      ],
      [
        440.0,
        1600.0,
        80.0
      ],
      [
        440.0,
        1600.0,
        95.0
      ],
      [
        440.0,
        1510.0,
        150.0
      ],
      [
        440.0,
        1495.0,
        150.0
      ],
      [
        440.0,
        1510.0,
        140.0
      ],
      [
        440.0,
        1495.0,
        140.0
      ],
      [
        360.0,
        980.0,
        340.0
      ],
      [
        360.0,
        1240.0,
        340.0
      ],
      [
        360.0,
        1240.0,
        120.0
      ],
      [
        360.0,
        1240.0,
        140.0
      ],
      [
        360.0,
        1240.0,
        100.0
      ],
      [
        360.0,
        1240.0,
        120.0
      ],
      [
        360.0,
        1240.0,
        80.0
      ],
      [
        360.0,
        1240.0,
        100.0
      ],
      [
        360.0,
        1240.0,
        140.0
      ],
      [
        360.0,
        1240.0,
        190.0
      ],
      [
        360.0,
        1240.0,
        190.0
      ],
      [
        360.0,
        1240.0,
        340.0
      ],
      [
        360.0,
        1310.0,
        240.0
      ],
      [
        360.0,
        1415.0,
        240.0
      ],
      [
        360.0,
        1310.0,
        140.0
      ],
      [
        360.0,
        1310.0,
        100.0
      ],
      [
        360.0,
        1310.0,
        140.0
      ],
      [
        360.0,
        1310.0,
        180.0
      ],
      [
        360.0,
        1310.0,
        240.0
      ],
      [
        360.0,
        1310.0,
        180.0
      ],
      [
        360.0,
        1380.0,
        210.0
      ],
      [
        360.0,
        1350.0,
        210.0
      ],
      [
        360.0,
        1390.0,
        200.0
      ],
      [
        360.0,
        1380.0,
        210.0
      ],
      [
        360.0,
        1380.0,
        190.0
      ],
      [
        360.0,
        1390.0,
        190.0
      ],
      [
        360.0,
        1340.0,
        190.0
      ],
      [
        360.0,
        1350.0,
        190.0
      ],
      [
        360.0,
        1360.0,
        190.0
      ],
      [
        360.0,
        1370.0,
        190.0
      ],
      [
        360.0,
        1350.0,
        185.0
      ],
      [
        360.0,
        1360.0,
        185.0
      ],
      [
        360.0,
        1370.0,
        185.0
      ],
      [
        360.0,
        1380.0,
        185.0
      ],
      [
        360.0,
        1360.0,
        185.0
      ],
      [
        360.0,
        1360.0,
        190.0
      ],
      [
        360.0,
        1380.0,
        185.0
      ],
      [
        360.0,
        1380.0,
        190.0
      ],
      [
        360.0,
        1390.0,
        200.0
      ],
      [
        360.0,
        1390.0,
        190.0
      ],
      [
        400.0,
        1310.0,
        80.0
      ],
      [
        360.0,
        1310.0,
        80.0
      ],
      [
        360.0,
        1310.0,
        100.0
      ],
      [
        400.0,
        1310.0,
        100.0
      ],
      [
        450.0,
        1510.0,
        150.0
      ],
      [
        450.0,
        1495.0,
        150.0
      ],
      [
        450.0,
        1510.0,
        140.0
      ],
      [
        450.0,
        1495.0,
        140.0
      ],
      [
        450.0,
        1510.0,
        150.0
      ],
      [
        450.0,
        1510.0,
        140.0
      ],
      [
        450.0,
        1240.0,
        330.0
      ],
      [
        450.0,
        980.0,
        330.0
      ],
      [
        450.0,
        1425.0,
        100.0
      ],
      [
        450.0,
        1420.0,
        100.0
      ],
      [
        450.0,
        1415.0,
        100.0
      ],
      [
        450.0,
        1420.0,
        100.0
      ],
      [
        450.0,
        1310.0,
        100.0
      ],
      [
        450.0,
        1415.0,
        100.0
      ],
      [
        450.0,
        1310.0,
        100.0
      ],
      [
        450.0,
        1130.0,
        100.0
      ],
      [
        450.0,
        1415.0,
        98.0
      ],
      [
        450.0,
        1420.0,
        98.0
      ],
      [
        450.0,
        1415.0,
        98.0
      ],
      [
        450.0,
        1310.0,
        98.0
      ],
      [
        450.0,
        1310.0,
        98.0
      ],
      [
        450.0,
        1130.0,
        98.0
      ],
      [
        440.0,
        1110.0,
        100.0
      ],
      [
        440.0,
        1110.0,
        98.0
      ],
      [
        450.0,
        1110.0,
        98.0
      ],
      [
        450.0,
        1110.0,
        100.0
      ],
      [
        450.0,
        1110.0,
        80.0
      ],
      [
        450.0,
        1320.0,
        91.5
      ],
      [
        450.0,
        1310.0,
        91.5
      ],
      [
        450.0,
        1415.0,
        91.5
      ],
      [
        450.0,
        1405.0,
        91.5
      ],
      [
        450.0,
        1310.0,
        98.0
      ],
      [
        450.0,
        1310.0,
        91.5
      ],
      [
        450.0,
        1405.0,
        98.0
      ],
      [
        450.0,
        1405.0,
        91.5
      ],
      [
        450.0,
        1240.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        330.0
      ],
      [
        450.0,
        1110.0,
        190.0
      ],
      [
        450.0,
        1240.0,
        190.0
      ],
      [
        450.0,
        980.0,
        190.0
      ],
      [
        450.0,
        1110.0,
        190.0
      ],
      [
        450.0,
        1090.0,
        160.0
      ],
      [
        450.0,
        1090.0,
        120.0
      ],
      [
        450.0,
        1000.0,
        160.0
      ],
      [
        450.0,
        1000.0,
        120.0
      ],
      [
        450.0,
        996.0,
        120.0
      ],
      [
        450.0,
        1000.0,
        120.0
      ],
      [
        450.0,
        980.0,
        120.0
      ],
      [
        450.0,
        1000.0,
        120.0
      ],
      [
        450.0,
        1000.0,
        160.0
      ],
      [
        450.0,
        980.0,
        160.0
      ],
      [
        450.0,
        1110.0,
        160.0
      ],
      [
        450.0,
        1110.0,
        190.0
      ],
      [
        450.0,
        1110.0,
        120.0
      ],
      [
        450.0,
        1090.0,
        120.0
      ],
      [
        450.0,
        1094.0,
        120.0
      ],
      [
        450.0,
        1090.0,
        120.0
      ],
      [
        450.0,
        1110.0,
        120.0
      ],
      [
        450.0,
        1110.0,
        160.0
      ],
      [
        450.0,
        1090.0,
        160.0
      ],
      [
        650.0,
        1235.0,
        520.0
      ],
      [
        650.0,
        1204.1727294921875,
        520.0
      ],
      [
        650.0,
        1204.1727294921875,
        535.0
      ],
      [
        650.0,
        1235.0,
        535.0
      ],
      [
        647.2877197265625,
        1185.6285400390625,
        535.0
      ],
      [
        627.7926025390625,
        1185.6285400390625,
        535.0
      ],
      [
        647.2877197265625,
        1185.6285400390625,
        535.0
      ],
      [
        650.0,
        1187.59912109375,
        550.0
      ],
      [
        650.0,
        1187.59912109375,
        535.0
      ],
      [
        631.7926025390625,
        1185.6285400390625,
        520.0
      ],
      [
        631.7926025390625,
        1185.6285400390625,
        524.0
      ],
      [
        631.7926025390625,
        1185.6285400390625,
        524.0
      ],
      [
        631.7926025390625,
        1185.6285400390625,
        535.0
      ],
      [
        650.0,
        1235.0,
        535.0
      ],
      [
        650.0,
        1235.0,
        520.0
      ],
      [
        650.0,
        1204.1727294921875,
        535.0
      ],
      [
        650.0,
        1204.1727294921875,
        520.0
      ],
      [
        650.0,
        1187.59912109375,
        520.0
      ],
      [
        650.0,
        1304.6898193359375,
        550.0
      ],
      [
        650.0,
        1304.6898193359375,
        520.0
      ],
      [
        650.0,
        1265.3101806640625,
        550.0
      ],
      [
        650.0,
        1265.3101806640625,
        520.0
      ],
      [
        602.2073974609375,
        1225.0,
        520.0
      ],
      [
        627.7926025390625,
        1225.0,
        520.0
      ],
      [
        627.7926025390625,
        1225.0,
        520.0
      ],
      [
        602.2073974609375,
        1225.0,
        520.0
      ],
      [
        650.0,
        1460.0,
        80.0
      ],
      [
        650.0,
        1460.0,
        190.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        120.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        140.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        140.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        120.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        120.0
      ],
      [
        625.537109375,
        1572.7098388671875,
        140.0
      ],
      [
        640.0,
        1500.0,
        140.0
      ],
      [
        640.0,
        1500.0,
        120.0
      ],
      [
        450.0,
        1690.0,
        120.0
      ],
      [
        450.0,
        1690.0,
        140.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        140.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        120.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        120.0
      ],
      [
        522.7098388671875,
        1675.537109375,
        140.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        140.0
      ],
      [
        584.3502807617188,
        1634.350341796875,
        120.0
      ],
      [
        650.0,
        1187.59912109375,
        140.0
      ],
      [
        650.0,
        1187.59912109375,
        160.0
      ],
      [
        650.0,
        1187.59912109375,
        100.0
      ],
      [
        650.0,
        1187.59912109375,
        140.0
      ],
      [
        650.0,
        1187.59912109375,
        160.0
      ],
      [
        650.0,
        1187.59912109375,
        520.0
      ],
      [
        627.7926025390625,
        1222.0,
        501.5
      ],
      [
        627.7926025390625,
        1225.0,
        500.0
      ],
      [
        627.7926025390625,
        1222.0,
        500.0
      ],
      [
        627.7926025390625,
        1225.0,
        501.5
      ],
      [
        627.7926025390625,
        1225.0,
        500.0
      ],
      [
        627.7926025390625,
        1222.0,
        500.0
      ],
      [
        627.7926025390625,
        1222.0,
        501.5
      ],
      [
        650.0,
        1187.59912109375,
        100.0
      ],
      [
        650.0,
        1185.6285400390625,
        96.81153869628906
      ],
      [
        650.0,
        1175.6285400390625,
        80.0
      ],
      [
        650.0,
        1177.281005859375,
        83.30496978759766
      ],
      [
        650.0,
        1177.281005859375,
        83.30496978759766
      ],
      [
        650.0,
        1304.6898193359375,
        100.0
      ],
      [
        650.0,
        1304.6898193359375,
        80.0
      ],
      [
        650.0,
        1304.6898193359375,
        160.0
      ],
      [
        650.0,
        1304.6898193359375,
        140.0
      ],
      [
        650.0,
        1304.6898193359375,
        140.0
      ],
      [
        650.0,
        1304.6898193359375,
        100.0
      ],
      [
        650.0,
        1304.6898193359375,
        520.0
      ],
      [
        650.0,
        1304.6898193359375,
        160.0
      ],
      [
        650.0,
        1265.3101806640625,
        100.0
      ],
      [
        650.0,
        1265.3101806640625,
        80.0
      ],
      [
        650.0,
        1265.3101806640625,
        160.0
      ],
      [
        650.0,
        1265.3101806640625,
        140.0
      ],
      [
        650.0,
        1265.3101806640625,
        140.0
      ],
      [
        650.0,
        1265.3101806640625,
        100.0
      ],
      [
        650.0,
        1265.3101806640625,
        520.0
      ],
      [
        650.0,
        1265.3101806640625,
        160.0
      ],
      [
        602.2073974609375,
        1222.0,
        501.5
      ],
      [
        602.2073974609375,
        1225.0,
        500.0
      ],
      [
        602.2073974609375,
        1222.0,
        500.0
      ],
      [
        602.2073974609375,
        1225.0,
        501.5
      ],
      [
        602.2073974609375,
        1225.0,
        500.0
      ],
      [
        602.2073974609375,
        1222.0,
        500.0
      ],
      [
        602.2073974609375,
        1222.0,
        501.5
      ],
      [
        596.4761352539062,
        1175.6285400390625,
        80.0
      ],
      [
        617.5,
        1225.0,
        518.0
      ],
      [
        617.5,
        1225.0,
        520.0
      ],
      [
        612.5,
        1225.0,
        518.0
      ],
      [
        617.5,
        1225.0,
        518.0
      ],
      [
        617.5,
        1225.0,
        520.0
      ],
      [
        612.5,
        1225.0,
        520.0
      ],
      [
        617.5,
        1225.0,
        518.0
      ],
      [
        612.5,
        1225.0,
        518.0
      ],
      [
        612.5,
        1225.0,
        520.0
      ],
      [
        617.5,
        1225.0,
        520.0
      ],
      [
        612.5,
        1300.3714599609375,
        520.0
      ],
      [
        617.5,
        1300.3714599609375,
        520.0
      ],
      [
        617.5,
        1300.3714599609375,
        518.0
      ],
      [
        612.5,
        1300.3714599609375,
        518.0
      ],
      [
        617.5,
        1314.3714599609375,
        520.0
      ],
      [
        612.5,
        1314.3714599609375,
        520.0
      ],
      [
        612.5,
        1314.3714599609375,
        518.0
      ],
      [
        617.5,
        1314.3714599609375,
        518.0
      ],
      [
        627.7926025390625,
        1225.0,
        518.0
      ],
      [
        627.7926025390625,
        1225.0,
        518.0
      ],
      [
        602.2073974609375,
        1225.0,
        518.0
      ],
      [
        602.2073974609375,
        1225.0,
        518.0
      ],
      [
        620.0,
        1300.3714599609375,
        100.0
      ],
      [
        620.0,
        1300.3714599609375,
        140.0
      ],
      [
        620.0,
        1300.3714599609375,
        100.0
      ],
      [
        610.0,
        1300.3714599609375,
        100.0
      ],
      [
        610.0,
        1300.3714599609375,
        140.0
      ],
      [
        610.0,
        1300.3714599609375,
        100.0
      ],
      [
        505.25732421875,
        1301.1802978515625,
        80.0
      ],
      [
        460.0,
        1274.7840576171875,
        100.0
      ],
      [
        450.0,
        1282.04931640625,
        100.0
      ],
      [
        460.0,
        1274.7840576171875,
        98.0
      ],
      [
        460.0,
        1274.7840576171875,
        100.0
      ],
      [
        450.0,
        1282.04931640625,
        98.0
      ],
      [
        460.0,
        1274.7840576171875,
        98.0
      ],
      [
        516.7057495117188,
        1233.5849609375,
        80.0
      ],
      [
        650.0,
        980.0,
        190.0
      ],
      [
        650.0,
        1110.0,
        190.0
      ],
      [
        650.0,
        1110.0,
        160.0
      ],
      [
        650.0,
        1110.0,
        190.0
      ],
      [
        650.0,
        1110.0,
        80.0
      ],
      [
        650.0,
        1110.0,
        120.0
      ],
      [
        650.0,
        1000.0,
        160.0
      ],
      [
        650.0,
        1000.0,
        120.0
      ],
      [
        650.0,
        1090.0,
        160.0
      ],
      [
        650.0,
        1090.0,
        120.0
      ],
      [
        650.0,
        1090.0,
        120.0
      ],
      [
        650.0,
        1094.0,
        120.0
      ],
      [
        650.0,
        1090.0,
        120.0
      ],
      [
        650.0,
        1110.0,
        120.0
      ],
      [
        650.0,
        1110.0,
        160.0
      ],
      [
        650.0,
        1090.0,
        160.0
      ],
      [
        650.0,
        996.0,
        120.0
      ],
      [
        650.0,
        1000.0,
        120.0
      ],
      [
        650.0,
        980.0,
        120.0
      ],
      [
        650.0,
        1000.0,
        120.0
      ],
      [
        650.0,
        1000.0,
        160.0
      ],
      [
        650.0,
        980.0,
        160.0
      ],
      [
        453.0,
        1130.0,
        100.0
      ],
      [
        453.0,
        1120.0,
        100.0
      ],
      [
        453.0,
        1120.0,
        98.0
      ],
      [
        453.0,
        1120.0,
        100.0
      ],
      [
        453.0,
        1130.0,
        100.0
      ],
      [
        453.0,
        1110.0,
        98.0
      ],
      [
        453.0,
        1120.0,
        98.0
      ],
      [
        529.6189575195312,
        1222.9669189453125,
        98.0
      ],
      [
        582.3873291015625,
        1184.6285400390625,
        98.0
      ],
      [
        582.3873291015625,
        1184.6285400390625,
        98.0
      ],
      [
        584.0886840820312,
        1184.6285400390625,
        98.0
      ],
      [
        529.0932006835938,
        1224.5849609375,
        98.0
      ],
      [
        529.6189575195312,
        1222.9669189453125,
        98.0
      ],
      [
        483.0,
        1130.0,
        120.0
      ],
      [
        483.0,
        1120.0,
        120.0
      ],
      [
        483.0,
        1110.0,
        120.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        410.03387451171875,
        750.0,
        460.0
      ],
      [
        410.0107116699219,
        750.0,
        460.0
      ],
      [
        609.9009399414062,
        809.9009399414062,
        240.0
      ],
      [
        609.9009399414062,
        809.9009399414062,
        240.0
      ],
      [
        650.0,
        769.8019409179688,
        240.0
      ],
      [
        650.0,
        750.0,
        240.0
      ],
      [
        650.0,
        920.0,
        140.0
      ],
      [
        650.0,
        920.0,
        80.0
      ],
      [
        650.0,
        920.0,
        140.0
      ],
      [
        310.0,
        750.0,
        420.0
      ],
      [
        310.0,
        750.0,
        80.0
      ],
      [
        310.0,
        1460.0,
        120.0
      ],
      [
        310.0,
        1460.0,
        140.0
      ],
      [
        310.0,
        1460.0,
        80.0
      ],
      [
        310.0,
        1460.0,
        120.0
      ],
      [
        310.0,
        1460.0,
        140.0
      ],
      [
        310.0,
        1460.0,
        190.0
      ],
      [
        310.0,
        1460.0,
        313.6842041015625
      ],
      [
        310.0,
        1460.0,
        240.0
      ],
      [
        310.0,
        1240.0,
        340.0
      ],
      [
        310.0,
        1240.0,
        120.0
      ],
      [
        310.0,
        1240.0,
        140.0
      ],
      [
        310.0,
        1240.0,
        100.0
      ],
      [
        310.0,
        1240.0,
        120.0
      ],
      [
        310.0,
        1240.0,
        80.0
      ],
      [
        310.0,
        1240.0,
        100.0
      ],
      [
        310.0,
        1240.0,
        140.0
      ],
      [
        310.0,
        1240.0,
        190.0
      ],
      [
        310.0,
        1240.0,
        190.0
      ],
      [
        310.0,
        1240.0,
        340.0
      ],
      [
        310.0,
        1310.0,
        240.0
      ],
      [
        310.0,
        1415.0,
        240.0
      ],
      [
        310.0,
        1310.0,
        140.0
      ],
      [
        310.0,
        1310.0,
        100.0
      ],
      [
        310.0,
        1310.0,
        140.0
      ],
      [
        310.0,
        1310.0,
        180.0
      ],
      [
        310.0,
        1310.0,
        80.0
      ],
      [
        310.0,
        1310.0,
        100.0
      ],
      [
        310.0,
        1310.0,
        240.0
      ],
      [
        310.0,
        1310.0,
        180.0
      ],
      [
        -100.0,
        770.0,
        130.0
      ],
      [
        -100.0,
        750.0,
        130.0
      ],
      [
        -50.0,
        1250.0,
        82.0
      ],
      [
        -50.0,
        1430.0,
        82.0
      ],
      [
        -100.0,
        1050.0,
        82.0
      ],
      [
        -100.0,
        1050.0,
        80.0
      ],
      [
        -50.0,
        830.0,
        82.0
      ],
      [
        -100.0,
        830.0,
        82.0
      ],
      [
        -100.0,
        830.0,
        80.0
      ],
      [
        -66.33332824707031,
        1413.666748046875,
        82.0
      ],
      [
        -100.0,
        1413.3333740234375,
        80.0
      ],
      [
        -100.0,
        1413.666748046875,
        82.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        82.0
      ],
      [
        260.0,
        1000.0,
        82.0
      ],
      [
        0.0,
        1240.0,
        82.0
      ],
      [
        120.0,
        1240.0,
        82.0
      ],
      [
        10.0,
        1310.0,
        82.0
      ],
      [
        110.0,
        1310.0,
        82.0
      ],
      [
        120.0,
        1250.0,
        82.0
      ],
      [
        110.0,
        1265.0,
        82.0
      ],
      [
        110.0,
        1265.0,
        82.0
      ],
      [
        97.5,
        1270.0,
        82.0
      ],
      [
        120.0,
        1240.0,
        82.0
      ],
      [
        120.0,
        1250.0,
        82.0
      ],
      [
        3.5756804943084717,
        870.6568603515625,
        82.0
      ],
      [
        120.0,
        1000.0,
        82.0
      ],
      [
        90.0,
        1000.0,
        82.0
      ],
      [
        -50.0,
        1250.0,
        104.0
      ],
      [
        -50.0,
        1430.0,
        104.0
      ],
      [
        -50.0,
        830.0,
        104.0
      ],
      [
        -100.0,
        830.0,
        104.0
      ],
      [
        -62.666664123535156,
        1417.3333740234375,
        104.0
      ],
      [
        -100.0,
        1417.3333740234375,
        104.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        104.0
      ],
      [
        260.0,
        1000.0,
        104.0
      ],
      [
        0.0,
        1240.0,
        104.0
      ],
      [
        120.0,
        1240.0,
        104.0
      ],
      [
        10.0,
        1310.0,
        104.0
      ],
      [
        110.0,
        1310.0,
        104.0
      ],
      [
        120.0,
        1250.0,
        104.0
      ],
      [
        110.0,
        1265.0,
        104.0
      ],
      [
        110.0,
        1265.0,
        104.0
      ],
      [
        97.5,
        1270.0,
        104.0
      ],
      [
        120.0,
        1240.0,
        104.0
      ],
      [
        120.0,
        1250.0,
        104.0
      ],
      [
        43.123802185058594,
        945.1792602539062,
        104.0
      ],
      [
        35.2203254699707,
        933.3508911132812,
        102.0
      ],
      [
        120.0,
        1000.0,
        104.0
      ],
      [
        90.0,
        1000.0,
        104.0
      ],
      [
        -50.0,
        830.0,
        104.0
      ],
      [
        15.056183815002441,
        842.9404907226562,
        104.0
      ],
      [
        -50.0,
        890.0,
        126.0
      ],
      [
        -50.0,
        1050.0,
        126.0
      ],
      [
        -100.0,
        1420.0,
        120.0
      ],
      [
        -100.0,
        1430.0,
        120.0
      ],
      [
        -100.0,
        820.0,
        120.0
      ],
      [
        -100.0,
        770.0,
        120.0
      ],
      [
        -50.0,
        1050.0,
        120.0
      ],
      [
        -100.0,
        1050.0,
        120.0
      ],
      [
        -100.0,
        830.0,
        120.0
      ],
      [
        -100.0,
        1420.0,
        120.0
      ],
      [
        -100.0,
        770.0,
        120.0
      ],
      [
        -50.0,
        770.0,
        126.0
      ],
      [
        -100.0,
        770.0,
        126.0
      ],
      [
        -50.0,
        1050.0,
        126.0
      ],
      [
        -100.0,
        1050.0,
        126.0
      ],
      [
        110.0,
        1316.54541015625,
        126.0
      ],
      [
        110.0,
        1490.0,
        126.0
      ],
      [
        0.0,
        1240.0,
        126.0
      ],
      [
        110.0,
        1240.0,
        126.0
      ],
      [
        110.0,
        1240.0,
        104.0
      ],
      [
        10.0,
        1316.54541015625,
        126.0
      ],
      [
        110.0,
        1316.54541015625,
        126.0
      ],
      [
        110.0,
        1265.0,
        126.0
      ],
      [
        97.5,
        1270.0,
        126.0
      ],
      [
        53.55341339111328,
        750.0,
        120.0
      ],
      [
        110.0,
        753.2655639648438,
        120.0
      ],
      [
        105.11277770996094,
        750.0,
        120.0
      ],
      [
        53.55341339111328,
        750.0,
        120.0
      ],
      [
        110.0,
        813.4000244140625,
        120.0
      ],
      [
        90.0,
        1000.0,
        119.21685028076172
      ],
      [
        110.0,
        1000.0,
        104.0
      ],
      [
        110.0,
        1000.0,
        120.0
      ],
      [
        97.20521545410156,
        1000.0,
        120.0
      ],
      [
        -50.0,
        830.0,
        120.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        120.0
      ],
      [
        110.0,
        949.7266235351562,
        116.72677612304688
      ],
      [
        99.67156219482422,
        973.212158203125,
        120.0
      ],
      [
        110.0,
        968.9339599609375,
        120.0
      ],
      [
        90.0,
        1000.0,
        120.0
      ],
      [
        98.67143249511719,
        973.212158203125,
        120.0
      ],
      [
        99.67156219482422,
        973.212158203125,
        120.0
      ],
      [
        84.67156982421875,
        973.212158203125,
        120.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        126.0
      ],
      [
        -50.0,
        830.0,
        126.0
      ],
      [
        -50.0,
        830.0,
        126.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        126.0
      ],
      [
        105.11277770996094,
        750.0,
        120.0
      ],
      [
        110.0,
        753.2655639648438,
        120.0
      ],
      [
        110.0,
        753.2655639648438,
        126.0
      ],
      [
        105.11277770996094,
        750.0,
        126.0
      ],
      [
        110.0,
        1000.0,
        126.0
      ],
      [
        110.0,
        986.8224487304688,
        123.04846954345703
      ],
      [
        110.0,
        1000.0,
        126.0
      ],
      [
        110.0,
        986.8224487304688,
        123.04846954345703
      ],
      [
        236.40264892578125,
        881.3681640625,
        126.0
      ],
      [
        260.0,
        1000.0,
        126.0
      ],
      [
        120.0,
        1250.0,
        120.0
      ],
      [
        110.0,
        1265.0,
        120.0
      ],
      [
        113.52975463867188,
        967.471923828125,
        120.0
      ],
      [
        110.0,
        968.9339599609375,
        120.0
      ],
      [
        120.0,
        1240.0,
        120.0
      ],
      [
        110.0,
        1240.0,
        120.0
      ],
      [
        120.0,
        1240.0,
        120.0
      ],
      [
        120.0,
        1250.0,
        120.0
      ],
      [
        120.0,
        1000.0,
        120.0
      ],
      [
        110.0,
        1000.0,
        120.0
      ],
      [
        161.99351501464844,
        788.0064697265625,
        126.0
      ],
      [
        120.0,
        1250.0,
        126.0
      ],
      [
        110.0,
        1265.0,
        126.0
      ],
      [
        120.0,
        1240.0,
        126.0
      ],
      [
        120.0,
        1240.0,
        126.0
      ],
      [
        120.0,
        1250.0,
        126.0
      ],
      [
        110.0,
        1000.0,
        125.29412078857422
      ],
      [
        110.0,
        1320.9090576171875,
        130.0
      ],
      [
        110.0,
        1490.0,
        130.0
      ],
      [
        -50.0,
        890.0,
        130.0
      ],
      [
        -50.0,
        1050.0,
        130.0
      ],
      [
        -50.0,
        1050.0,
        130.0
      ],
      [
        -100.0,
        1050.0,
        130.0
      ],
      [
        -100.0,
        770.0,
        130.0
      ],
      [
        0.0,
        1240.0,
        130.0
      ],
      [
        110.0,
        1240.0,
        130.0
      ],
      [
        110.0,
        1240.0,
        126.0
      ],
      [
        10.0,
        1320.9090576171875,
        130.0
      ],
      [
        110.0,
        1320.9090576171875,
        130.0
      ],
      [
        110.0,
        1265.0,
        130.0
      ],
      [
        97.5,
        1270.0,
        130.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        130.0
      ],
      [
        -50.0,
        830.0,
        130.0
      ],
      [
        -50.0,
        830.0,
        130.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        130.0
      ],
      [
        110.0,
        753.2655639648438,
        130.0
      ],
      [
        105.11277770996094,
        750.0,
        130.0
      ],
      [
        110.0,
        753.2655639648438,
        126.0
      ],
      [
        236.40264892578125,
        881.3681640625,
        130.0
      ],
      [
        260.0,
        1000.0,
        130.0
      ],
      [
        161.99351501464844,
        788.0064697265625,
        130.0
      ],
      [
        120.0,
        1250.0,
        130.0
      ],
      [
        110.0,
        1265.0,
        130.0
      ],
      [
        120.0,
        1240.0,
        130.0
      ],
      [
        120.0,
        1240.0,
        130.0
      ],
      [
        120.0,
        1250.0,
        130.0
      ],
      [
        260.0,
        970.0,
        160.0
      ],
      [
        260.0,
        970.0,
        420.0
      ],
      [
        189.17669677734375,
        750.0,
        230.0
      ],
      [
        246.4127197265625,
        750.0,
        230.0
      ],
      [
        246.4127197265625,
        750.0,
        230.0
      ],
      [
        254.03260803222656,
        750.0,
        230.0
      ],
      [
        114.03263092041016,
        970.0,
        155.0
      ],
      [
        -50.0,
        970.0,
        155.0
      ],
      [
        123.1123046875,
        750.0,
        140.0
      ],
      [
        105.11277770996094,
        750.0,
        140.0
      ],
      [
        254.03262329101562,
        970.0,
        140.0
      ],
      [
        254.03262329101562,
        970.0,
        130.0
      ],
      [
        -50.0,
        890.0,
        140.0
      ],
      [
        -50.0,
        970.0,
        140.0
      ],
      [
        -50.0,
        970.0,
        130.0
      ],
      [
        105.11277770996094,
        750.0,
        140.0
      ],
      [
        -50.0,
        830.0,
        140.0
      ],
      [
        15.056182861328125,
        842.9404907226562,
        140.0
      ],
      [
        114.03263092041016,
        970.0,
        130.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        140.0
      ],
      [
        114.03263092041016,
        970.0,
        140.0
      ],
      [
        -50.0,
        970.0,
        144.0
      ],
      [
        114.03263092041016,
        970.0,
        155.0
      ],
      [
        189.17669677734375,
        750.0,
        160.0
      ],
      [
        246.4127197265625,
        750.0,
        160.0
      ],
      [
        9.500479698181152,
        851.2551879882812,
        160.0
      ],
      [
        -50.0,
        839.8079223632812,
        160.0
      ],
      [
        -50.0,
        839.8079223632812,
        160.0
      ],
      [
        -100.0,
        839.8079833984375,
        160.0
      ],
      [
        114.03263092041016,
        970.0,
        155.0
      ],
      [
        107.05952453613281,
        934.9437866210938,
        160.0
      ],
      [
        114.03263092041016,
        970.0,
        160.0
      ],
      [
        104.3251724243164,
        970.0,
        175.0
      ],
      [
        114.03263092041016,
        970.0,
        175.0
      ],
      [
        114.03263092041016,
        970.0,
        175.0
      ],
      [
        110.0,
        1348.1817626953125,
        155.0
      ],
      [
        110.0,
        1490.0,
        155.0
      ],
      [
        0.0,
        1240.0,
        155.0
      ],
      [
        110.0,
        1240.0,
        155.0
      ],
      [
        110.0,
        1240.0,
        130.0
      ],
      [
        10.0,
        1348.1817626953125,
        155.0
      ],
      [
        110.0,
        1348.1817626953125,
        155.0
      ],
      [
        110.0,
        1265.0,
        155.0
      ],
      [
        97.5,
        1270.0,
        155.0
      ],
      [
        120.0,
        1250.0,
        155.0
      ],
      [
        110.0,
        1265.0,
        155.0
      ],
      [
        120.0,
        1240.0,
        155.0
      ],
      [
        120.0,
        1240.0,
        155.0
      ],
      [
        120.0,
        1250.0,
        155.0
      ],
      [
        110.0,
        1370.0,
        175.0
      ],
      [
        110.0,
        1490.0,
        175.0
      ],
      [
        110.0,
        1240.0,
        175.0
      ],
      [
        110.0,
        1240.0,
        155.0
      ],
      [
        10.0,
        1370.0,
        175.0
      ],
      [
        110.0,
        1370.0,
        175.0
      ],
      [
        310.0,
        970.0,
        112.5
      ],
      [
        260.0,
        970.0,
        112.5
      ],
      [
        300.0,
        980.0,
        120.0
      ],
      [
        300.0,
        970.0,
        112.5
      ],
      [
        -309.5,
        971.800048828125,
        120.0
      ],
      [
        -340.0,
        1240.0,
        120.0
      ],
      [
        -340.0,
        1210.4000244140625,
        120.0
      ],
      [
        -119.5,
        1175.720458984375,
        100.00611877441406
      ],
      [
        -119.5,
        1175.720458984375,
        120.0
      ],
      [
        -144.5,
        1219.021728515625,
        120.0
      ],
      [
        -119.5,
        1175.720458984375,
        80.0
      ],
      [
        -119.5,
        1175.720458984375,
        100.00611877441406
      ],
      [
        -295.0,
        1230.0,
        120.0
      ],
      [
        -295.0,
        1210.4000244140625,
        120.0
      ],
      [
        -300.0,
        1240.0,
        120.0
      ],
      [
        -295.0,
        1230.0,
        120.0
      ],
      [
        -144.5,
        1097.7781982421875,
        120.0
      ],
      [
        -109.5,
        1158.39990234375,
        120.0
      ],
      [
        -109.5,
        1158.39990234375,
        120.0
      ],
      [
        -100.0,
        1050.0,
        120.0
      ],
      [
        -160.0,
        1050.0,
        120.0
      ],
      [
        -294.49993896484375,
        1074.6842041015625,
        250.0
      ],
      [
        -334.136474609375,
        1051.800048828125,
        250.0
      ],
      [
        -119.5,
        1175.720458984375,
        120.00611877441406
      ],
      [
        -119.5,
        1175.720458984375,
        120.0
      ],
      [
        -119.5,
        1175.720458984375,
        120.00611877441406
      ],
      [
        -119.5,
        1175.720458984375,
        500.0
      ],
      [
        -309.5,
        770.0,
        130.0
      ],
      [
        -309.5,
        750.0,
        130.0
      ],
      [
        -309.5,
        770.0,
        120.0
      ],
      [
        -309.5,
        770.0,
        130.0
      ],
      [
        -309.5,
        1066.02392578125,
        250.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        225.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        250.0
      ],
      [
        -309.5,
        1006.4411010742188,
        250.0
      ],
      [
        -309.5,
        1006.4411010742188,
        200.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        200.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        205.0
      ],
      [
        -296.82049560546875,
        984.4795532226562,
        205.0
      ],
      [
        -290.7701416015625,
        974.0,
        210.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        210.0
      ],
      [
        -309.5,
        1006.4411010742188,
        300.0
      ],
      [
        -289.4999694824219,
        971.800048828125,
        300.0
      ],
      [
        -110.63330841064453,
        1160.36279296875,
        120.00611877441406
      ],
      [
        -110.63330841064453,
        1160.36279296875,
        120.0
      ],
      [
        -110.63330841064453,
        1160.36279296875,
        120.00611877441406
      ],
      [
        -110.63330841064453,
        1160.36279296875,
        500.0
      ],
      [
        -184.49986267089844,
        1045.8167724609375,
        202.5
      ],
      [
        -224.5,
        1115.0986328125,
        202.5
      ],
      [
        -100.0,
        1050.0,
        130.0
      ],
      [
        -160.0,
        1050.0,
        130.0
      ],
      [
        -110.0,
        840.0,
        240.0
      ],
      [
        -150.0,
        840.0,
        240.0
      ],
      [
        -100.0,
        920.0,
        240.0
      ],
      [
        -110.0,
        920.0,
        240.0
      ],
      [
        550.0,
        680.0,
        240.0
      ],
      [
        449.9999694824219,
        580.0,
        240.0
      ],
      [
        550.0,
        680.0,
        100.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        680.0,
        240.0
      ],
      [
        380.0,
        510.0,
        220.0
      ],
      [
        360.0,
        490.0000305175781,
        220.0
      ],
      [
        310.0,
        440.0000305175781,
        420.0
      ],
      [
        310.0,
        440.0,
        80.0
      ],
      [
        0.27338409423828125,
        700.0,
        140.0
      ],
      [
        -50.0,
        690.0,
        140.0
      ],
      [
        -200.0,
        690.0,
        140.0
      ],
      [
        0.27338409423828125,
        700.0,
        120.0
      ],
      [
        0.27338409423828125,
        700.0,
        140.0
      ],
      [
        -50.0,
        690.0,
        140.0
      ],
      [
        290.0,
        420.0,
        140.0
      ],
      [
        290.0,
        420.0,
        381.0
      ],
      [
        221.60464477539062,
        700.0,
        160.0
      ],
      [
        250.22265625,
        700.0,
        160.0
      ],
      [
        0.27338409423828125,
        700.0,
        160.0
      ],
      [
        108.27122497558594,
        700.0,
        160.0
      ],
      [
        0.27338409423828125,
        700.0,
        160.0
      ],
      [
        221.60464477539062,
        700.0,
        230.0
      ],
      [
        250.22265625,
        700.0,
        230.0
      ],
      [
        0.27338409423828125,
        700.0,
        230.0
      ],
      [
        108.27122497558594,
        700.0,
        230.0
      ],
      [
        250.22265625,
        700.0,
        230.0
      ],
      [
        254.0325927734375,
        700.0,
        230.0
      ],
      [
        -100.0,
        690.0,
        230.0
      ],
      [
        -200.0,
        690.0,
        230.0
      ],
      [
        -100.0,
        650.0,
        230.0
      ],
      [
        -100.0,
        690.0,
        230.0
      ],
      [
        90.45277404785156,
        728.1776123046875,
        140.0
      ],
      [
        68.63186645507812,
        713.5973510742188,
        140.0
      ],
      [
        0.27338409423828125,
        700.0,
        140.0
      ],
      [
        190.33387756347656,
        748.2157592773438,
        160.0
      ],
      [
        199.22744750976562,
        750.0,
        160.0
      ],
      [
        190.33387756347656,
        748.2157592773438,
        230.0
      ],
      [
        199.22744750976562,
        750.0,
        230.0
      ],
      [
        650.0,
        460.0,
        100.0
      ],
      [
        650.0,
        480.0,
        100.0
      ],
      [
        620.0,
        495.0,
        100.0
      ],
      [
        620.0,
        485.0,
        100.0
      ],
      [
        620.0,
        510.0,
        100.0
      ],
      [
        620.0,
        495.0,
        100.0
      ],
      [
        620.0,
        290.714111328125,
        100.0
      ],
      [
        620.0,
        485.0,
        100.0
      ],
      [
        310.0,
        250.0,
        100.0
      ],
      [
        310.0,
        440.0,
        100.0
      ],
      [
        399.4853820800781,
        400.0,
        100.0
      ],
      [
        416.7721252441406,
        453.2031555175781,
        100.0
      ],
      [
        416.7721252441406,
        346.7968444824219,
        100.0
      ],
      [
        399.4853820800781,
        400.0,
        100.0
      ],
      [
        455.27862548828125,
        481.1797790527344,
        95.5
      ],
      [
        455.27862548828125,
        481.1797790527344,
        99.99999237060547
      ],
      [
        455.27862548828125,
        500.0,
        100.0
      ],
      [
        455.27862548828125,
        500.0,
        95.5
      ],
      [
        455.27862548828125,
        500.0,
        80.0
      ],
      [
        458.4035949707031,
        486.5,
        90.0
      ],
      [
        455.2785949707031,
        486.5,
        87.5
      ],
      [
        550.0,
        510.0,
        100.0
      ],
      [
        550.0,
        510.0,
        80.0
      ],
      [
        455.27862548828125,
        510.0,
        100.0
      ],
      [
        620.0,
        510.0,
        100.0
      ],
      [
        650.0,
        480.0,
        98.0
      ],
      [
        650.0,
        460.0,
        98.0
      ],
      [
        650.0,
        480.0,
        100.0
      ],
      [
        650.0,
        480.0,
        98.0
      ],
      [
        455.27862548828125,
        500.0,
        215.0
      ],
      [
        455.27862548828125,
        500.0,
        100.0
      ],
      [
        524.7213745117188,
        500.0,
        215.0
      ],
      [
        455.27862548828125,
        500.0,
        215.0
      ],
      [
        600.0,
        500.0,
        130.0
      ],
      [
        559.7213745117188,
        500.0,
        130.0
      ],
      [
        559.7213745117188,
        500.0,
        145.0
      ],
      [
        559.7213745117188,
        500.0,
        140.0
      ],
      [
        559.7213745117188,
        500.0,
        130.0
      ],
      [
        550.0,
        580.0,
        220.0
      ],
      [
        550.0,
        680.0,
        220.0
      ],
      [
        550.0,
        510.0,
        140.0
      ],
      [
        550.0,
        510.0,
        133.5
      ],
      [
        550.0,
        510.0,
        133.5
      ],
      [
        550.0,
        510.0,
        100.0
      ],
      [
        550.0,
        510.0,
        220.0
      ],
      [
        550.0,
        510.0,
        140.0
      ],
      [
        694.2730712890625,
        1207.4046630859375,
        80.0
      ],
      [
        662.6243896484375,
        1110.0,
        160.0
      ],
      [
        662.6243896484375,
        1110.0,
        190.0
      ],
      [
        662.6243896484375,
        1110.0,
        80.0
      ],
      [
        662.6243896484375,
        1110.0,
        120.0
      ],
      [
        650.0,
        1071.1461181640625,
        190.0
      ],
      [
        662.6243896484375,
        1110.0,
        190.0
      ],
      [
        656.1259765625,
        1090.0,
        160.0
      ],
      [
        656.1259765625,
        1090.0,
        120.0
      ],
      [
        656.1259765625,
        1090.0,
        120.0
      ],
      [
        657.4256591796875,
        1094.0,
        120.0
      ],
      [
        656.1259765625,
        1090.0,
        120.0
      ],
      [
        662.6243896484375,
        1110.0,
        120.0
      ],
      [
        662.6243896484375,
        1110.0,
        160.0
      ],
      [
        656.1259765625,
        1090.0,
        160.0
      ],
      [
        720.0,
        1254.22314453125,
        80.0
      ],
      [
        720.0,
        1283.4163818359375,
        98.0423355102539
      ],
      [
        720.0,
        1315.77685546875,
        80.0
      ],
      [
        720.0,
        1285.0,
        99.02108001708984
      ],
      [
        720.0,
        1285.0,
        99.02108764648438
      ],
      [
        660.0,
        566.8431396484375,
        100.0
      ],
      [
        660.0,
        567.8578491210938,
        100.0
      ],
      [
        660.0,
        565.8279418945312,
        100.0
      ],
      [
        660.0,
        566.8431396484375,
        100.0
      ],
      [
        670.7326049804688,
        555.0900268554688,
        98.0
      ],
      [
        660.0,
        567.8578491210938,
        100.0
      ],
      [
        660.0,
        567.8578491210938,
        98.0
      ],
      [
        660.0,
        567.8578491210938,
        98.0
      ],
      [
        660.0,
        566.8431396484375,
        98.0
      ],
      [
        660.0,
        566.8431396484375,
        98.0
      ],
      [
        660.0,
        565.8279418945312,
        98.0
      ],
      [
        677.8394165039062,
        562.1814575195312,
        99.9787368774414
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -6971.595703125,
        -5122.0185546875,
        -300.0
      ],
      "bbox_max": [
        7986.5068359375,
        7452.45556640625,
        2163.576171875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -6971.595703125,
      "bbox_min": [
        -4714.78125,
        -300.0,
        -3000.0
      ],
      "bbox_max": [
        6661.31591796875,
        1650.0,
        0.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -6821.484375,
        -2954.5341796875,
        -300.0
      ],
      "bbox_max": [
        -3000.0,
        5224.01171875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6821.484375,
        2758.39404296875,
        -22.699951171875
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911992073059,
        0.31622785329818726
      ],
      "plane_d": 4052.21826171875,
      "bbox_min": [
        -4100.0,
        -2954.5341796875,
        -300.0
      ],
      "bbox_max": [
        -3000.0,
        3072.413818359375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -3605.199951171875,
        -2954.5341796875,
        -300.0
      ],
      "bbox_max": [
        -3000.0,
        -2226.63818359375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -4116.7685546875,
        -3995.13671875,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        -2339.345947265625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4116.7685546875,
        -3995.13671875,
        630.2245483398438
      ],
      "bbox_max": [
        -3000.0,
        -2426.19775390625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8469141721725464,
        0.5269691348075867,
        0.07099299877882004
      ],
      "plane_d": 4842.2216796875,
      "bbox_min": [
        -4110.7685546875,
        -3995.13671875,
        1045.652587890625
      ],
      "bbox_max": [
        -3343.854248046875,
        -2760.515625,
        1398.18115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3507.259521484375,
        -3995.13671875,
        1045.652587890625
      ],
      "bbox_max": [
        -3354.7705078125,
        -3883.6728515625,
        1398.18115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3380.023193359375,
        -3938.2197265625,
        1046.6051025390625
      ],
      "bbox_max": [
        -3343.854248046875,
        -3911.88134765625,
        1152.351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3661.619384765625,
        -3923.988037109375,
        630.2245483398438
      ],
      "bbox_max": [
        -3000.0,
        -2426.19775390625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3625.179443359375,
        -3923.988037109375,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3212.1396484375,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3464.2958984375,
        -3923.988037109375,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3212.1396484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3464.2958984375,
        -3923.988037109375,
        1046.84326171875
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451709151268005,
        -0.3576369881629944,
        0.3972178101539612
      ],
      "plane_d": 904.6746826171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3408.73486328125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        1220.0
      ],
      "bbox_max": [
        -3260.67529296875,
        -3559.13720703125,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3661.619384765625,
        -2969.13720703125,
        630.2245483398438
      ],
      "bbox_max": [
        -3195.179443359375,
        -2426.19775390625,
        1091.7215576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204001545906067,
        0.6658127903938293,
        0.19420865178108215
      ],
      "plane_d": 4133.041015625,
      "bbox_min": [
        -3515.1474609375,
        -2969.13720703125,
        630.224609375
      ],
      "bbox_max": [
        -3195.179443359375,
        -2584.24951171875,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7315089106559753,
        0.6458920836448669,
        0.21844476461410522
      ],
      "plane_d": 4102.8388671875,
      "bbox_min": [
        -3515.1474609375,
        -2659.722412109375,
        630.224609375
      ],
      "bbox_max": [
        -3452.1201171875,
        -2584.24951171875,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7315089106559753,
        0.6458920836448669,
        0.21844476461410522
      ],
      "plane_d": 4102.8388671875,
      "bbox_min": [
        -3658.444091796875,
        -3214.59765625,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        -2339.345947265625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3658.444091796875,
        -3214.59765625,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2365.345947265625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3003.01416015625,
        -3214.59765625,
        1181.8935546875
      ],
      "bbox_max": [
        -3000.0,
        -3210.00390625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3658.444091796875,
        -3052.4541015625,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2365.345947265625,
        1057.6986083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204001545906067,
        0.6658127903938293,
        0.19420865178108215
      ],
      "plane_d": 4133.041015625,
      "bbox_min": [
        -3452.1201171875,
        -3052.4541015625,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2659.722412109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3833.671875,
        -4714.78125,
        1040.098388671875
      ],
      "bbox_max": [
        -3000.0,
        -3939.684814453125,
        1397.2437744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4633953869342804,
        0.8772453665733337,
        -0.12532076239585876
      ],
      "plane_d": 5618.984375,
      "bbox_min": [
        -3652.99658203125,
        -4671.95703125,
        1040.098388671875
      ],
      "bbox_max": [
        -3000.0,
        -4327.0185546875,
        1191.9580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3833.671875,
        -4365.23046875,
        1040.098388671875
      ],
      "bbox_max": [
        -3398.428466796875,
        -3939.684814453125,
        1397.2437744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2771.56982421875,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        6661.31591796875,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -6971.595703125,
        -2769.29443359375,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        5936.4208984375,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -4205.1796875,
        -2769.29443359375,
        2.0755615234375
      ],
      "bbox_max": [
        -3605.362548828125,
        -2269.30224609375,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4205.1796875,
        -2769.29443359375,
        1371.9029541015625
      ],
      "bbox_max": [
        -4110.7685546875,
        -2619.13720703125,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.249755859375,
      "bbox_min": [
        -3714.01416015625,
        -2363.246337890625,
        2.0755615234375
      ],
      "bbox_max": [
        -3605.362548828125,
        -2269.30224609375,
        1182.983154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -6158.31884765625,
        3750.891357421875,
        347.8642578125
      ],
      "bbox_max": [
        -5532.3203125,
        4687.76513671875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -5573.556640625,
        -2428.59033203125,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        5936.4208984375,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3910660445690155,
        0.31802985072135925,
        0.8636690974235535
      ],
      "plane_d": 372.2137451171875,
      "bbox_min": [
        -5573.556640625,
        2154.178466796875,
        0.0
      ],
      "bbox_max": [
        -4474.53173828125,
        5531.40869140625,
        1000.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5342.2373046875,
        4972.24462890625,
        0.0
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        157.04103088378906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -5573.556640625,
        4475.62646484375,
        41.128997802734375
      ],
      "bbox_max": [
        -4474.53173828125,
        5531.40869140625,
        901.1133422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5332.0185546875,
        4987.5380859375,
        41.128997802734375
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5573.556640625,
        4626.0498046875,
        150.0
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        901.1133422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -4912.15185546875,
        -2428.59033203125,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        5936.4208984375,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -4912.15185546875,
        -2428.59033203125,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        3147.970458984375,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5895066857337952,
        -0.7432910799980164,
        0.3162282407283783
      ],
      "plane_d": 4052.218017578125,
      "bbox_min": [
        -4100.0,
        2200.0,
        0.0
      ],
      "bbox_max": [
        -3000.0,
        3121.493896484375,
        115.36239624023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.249755859375,
      "bbox_min": [
        -3714.02197265625,
        -2428.59033203125,
        0.0
      ],
      "bbox_max": [
        -3543.18798828125,
        -2269.13720703125,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3697.488525390625,
        -2428.59033203125,
        1091.7215576171875
      ],
      "bbox_max": [
        -3660.1962890625,
        -2384.901123046875,
        1181.53662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3662.39306640625,
        -2427.53564453125,
        1172.1954345703125
      ],
      "bbox_max": [
        -3660.1962890625,
        -2424.958984375,
        1174.1900634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -4591.423828125,
        3702.747802734375,
        150.0
      ],
      "bbox_max": [
        -3179.908203125,
        5936.4208984375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1430054008960724,
        0.10372365266084671,
        0.9842716455459595
      ],
      "plane_d": -505.2467041015625,
      "bbox_min": [
        -5704.54443359375,
        -2771.56982421875,
        150.0
      ],
      "bbox_max": [
        -3000.0,
        6661.31591796875,
        1403.2762451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4205.0,
        -2771.56982421875,
        1179.1334228515625
      ],
      "bbox_max": [
        -3697.73974609375,
        -2323.6279296875,
        1403.2762451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.302978515625,
        1210.5587158203125
      ],
      "bbox_max": [
        -3702.450439453125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -5331.83203125,
        -2428.069091796875,
        150.0
      ],
      "bbox_max": [
        -3000.0,
        6661.31591796875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -5331.83203125,
        -2428.069091796875,
        150.0
      ],
      "bbox_max": [
        -3000.0,
        5224.01171875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.249755859375,
      "bbox_min": [
        -3725.179443359375,
        -2428.069091796875,
        1173.7484130859375
      ],
      "bbox_max": [
        -3660.219970703125,
        -2323.558349609375,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3697.79833984375,
        -2384.901123046875,
        1181.5367431640625
      ],
      "bbox_max": [
        -3697.488525390625,
        -2384.451171875,
        1182.312255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5331.83203125,
        4987.8173828125,
        671.7750244140625
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        762.363525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555701851844788,
        0.0
      ],
      "plane_d": 7204.33935546875,
      "bbox_min": [
        -5704.54443359375,
        4430.01318359375,
        714.5433349609375
      ],
      "bbox_max": [
        -5174.01171875,
        5224.01171875,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        2958.814697265625,
        4000.0,
        137.9085693359375
      ],
      "bbox_max": [
        6769.1220703125,
        7184.23095703125,
        2142.593505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        2958.814697265625,
        5106.68994140625,
        183.4736785888672
      ],
      "bbox_max": [
        4964.0634765625,
        7184.23095703125,
        1954.7119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028518805280327797,
        -0.31919899582862854,
        0.947258472442627
      ],
      "plane_d": 1693.8587646484375,
      "bbox_min": [
        2958.814697265625,
        6651.18115234375,
        550.7012939453125
      ],
      "bbox_max": [
        3242.2421875,
        7184.23095703125,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        2958.814697265625,
        7077.4560546875,
        687.5199584960938
      ],
      "bbox_max": [
        3015.587890625,
        7184.23095703125,
        723.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        4138.5498046875,
        4000.0,
        137.9085693359375
      ],
      "bbox_max": [
        6769.1220703125,
        5140.50634765625,
        2142.593505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        4516.6787109375,
        4000.0,
        258.1121826171875
      ],
      "bbox_max": [
        6769.1220703125,
        5140.50634765625,
        2142.593505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        5075.16259765625,
        4000.0,
        1379.597412109375
      ],
      "bbox_max": [
        6769.1220703125,
        5140.50634765625,
        2142.593505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        -569.308837890625,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4651.89990234375,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        -569.308837890625,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4141.0390625,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        -569.308837890625,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4141.0390625,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9484592080116272,
        -0.020618677139282227,
        0.3162277638912201
      ],
      "plane_d": 291.7543029785156,
      "bbox_min": [
        -569.308837890625,
        5076.0478515625,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8558866381645203,
        -0.018606234341859818,
        0.5168285369873047
      ],
      "plane_d": 228.55836486816406,
      "bbox_min": [
        -569.308837890625,
        5716.41552734375,
        -22.699951171875
      ],
      "bbox_max": [
        -139.55206298828125,
        7382.458984375,
        640.17333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -569.308837890625,
        7296.97509765625,
        -22.699951171875
      ],
      "bbox_max": [
        -139.55206298828125,
        7382.458984375,
        630.946533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -489.0639953613281,
        7312.93701171875,
        150.00013732910156
      ],
      "bbox_max": [
        -197.38243103027344,
        7370.9560546875,
        640.17333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -361.5218505859375,
        7155.99462890625,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05985559523105621,
        -0.9467930197715759,
        0.3162282705307007
      ],
      "plane_d": 6873.22802734375,
      "bbox_min": [
        -150.0,
        7155.99462890625,
        -300.0
      ],
      "bbox_max": [
        448.3017578125,
        7287.82421875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3040.46826171875,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4141.0390625,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608350396156311,
        0.7279488444328308,
        0.3162280023097992
      ],
      "plane_d": -418.385498046875,
      "bbox_min": [
        3942.69775390625,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        4141.0390625,
        4149.736328125,
        -250.32057189941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        -569.3087768554688,
        4000.0,
        -295.782470703125
      ],
      "bbox_max": [
        4651.89990234375,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        816.3760375976562,
        4045.38671875,
        -281.4707336425781
      ],
      "bbox_max": [
        4144.63134765625,
        7327.39501953125,
        687.5199584960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0844237431883812,
        -0.9449194669723511,
        0.31622740626335144
      ],
      "plane_d": 5014.3017578125,
      "bbox_min": [
        3045.157470703125,
        4609.34765625,
        -113.31649780273438
      ],
      "bbox_max": [
        4040.1279296875,
        5034.5224609375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3966.75,
        4609.34765625,
        -113.31649780273438
      ],
      "bbox_max": [
        4040.1279296875,
        4951.876953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3242.2421875,
        4045.38671875,
        -281.4707336425781
      ],
      "bbox_max": [
        4144.63134765625,
        6651.18115234375,
        550.7012939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4949.31103515625,
        0.0
      ],
      "bbox_max": [
        4000.44775390625,
        4954.3212890625,
        24.795982360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3970.173828125,
        4045.38671875,
        -281.4707336425781
      ],
      "bbox_max": [
        4144.63134765625,
        4951.876953125,
        23.076099395751953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3970.173828125,
        4882.09033203125,
        0.0
      ],
      "bbox_max": [
        3999.89697265625,
        4951.876953125,
        23.076099395751953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608350396156311,
        0.7279488444328308,
        0.3162280023097992
      ],
      "plane_d": -418.385498046875,
      "bbox_min": [
        4006.63916015625,
        4045.38671875,
        -281.4707336425781
      ],
      "bbox_max": [
        4144.63134765625,
        4144.17333984375,
        -241.0099639892578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        -569.3087768554688,
        4000.0,
        -295.782470703125
      ],
      "bbox_max": [
        4651.89990234375,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        4047.874267578125,
        5080.8212890625,
        152.81594848632812
      ],
      "bbox_max": [
        4072.85498046875,
        5106.68994140625,
        183.4736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -569.3087768554688,
        7296.97509765625,
        625.141357421875
      ],
      "bbox_max": [
        -489.06396484375,
        7312.93701171875,
        763.2601318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -569.3087768554688,
        7296.97509765625,
        630.946533203125
      ],
      "bbox_max": [
        200.0,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6118655800819397,
        -0.1958032250404358,
        0.7663430571556091
      ],
      "plane_d": 3398.80615234375,
      "bbox_min": [
        3944.89013671875,
        4000.0,
        -295.782470703125
      ],
      "bbox_max": [
        4651.89990234375,
        5089.02490234375,
        749.28955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9035463333129883,
        -0.28914403915405273,
        0.31622743606567383
      ],
      "plane_d": 5019.0419921875,
      "bbox_min": [
        3944.89013671875,
        4000.0,
        -295.782470703125
      ],
      "bbox_max": [
        4237.6171875,
        4882.09033203125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608350396156311,
        0.7279488444328308,
        0.3162280023097992
      ],
      "plane_d": -418.385498046875,
      "bbox_min": [
        3944.89013671875,
        4000.0,
        -295.782470703125
      ],
      "bbox_max": [
        4237.6171875,
        4143.130859375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        3956.206787109375,
        4000.0,
        -240.4162139892578
      ],
      "bbox_max": [
        4651.89990234375,
        5089.02490234375,
        749.28955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5238755941390991,
        -0.5008544921875,
        0.6889841556549072
      ],
      "plane_d": 4560.046875,
      "bbox_min": [
        3956.206787109375,
        4954.3212890625,
        24.79598045349121
      ],
      "bbox_max": [
        4138.5498046875,
        5089.02490234375,
        177.77395629882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567955493927002,
        -0.463673859834671,
        0.6800244450569153
      ],
      "plane_d": 4550.9375,
      "bbox_min": [
        3956.206787109375,
        4979.27001953125,
        32.464569091796875
      ],
      "bbox_max": [
        4047.87451171875,
        5080.8212890625,
        152.81597900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -3000.0,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        -97.2362060546875,
        7296.97509765625,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        -97.2362060546875,
        7296.97509765625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319282174110413,
        -0.1775101274251938,
        0.31622785329818726
      ],
      "plane_d": 1065.060791015625,
      "bbox_min": [
        -431.851318359375,
        4000.0,
        -300.0
      ],
      "bbox_max": [
        -97.2362060546875,
        5716.41552734375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.948459267616272,
        -0.020618680864572525,
        0.3162277638912201
      ],
      "plane_d": 291.75433349609375,
      "bbox_min": [
        -249.89752197265625,
        4939.48486328125,
        -300.0
      ],
      "bbox_max": [
        -97.2362060546875,
        5716.41552734375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3932375907897949,
        -0.4582340121269226,
        0.797110915184021
      ],
      "plane_d": 2052.83154296875,
      "bbox_min": [
        -2708.39404296875,
        4955.25732421875,
        150.0
      ],
      "bbox_max": [
        -233.35060119628906,
        7296.97509765625,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8558866381645203,
        -0.018606234341859818,
        0.5168285369873047
      ],
      "plane_d": 228.55836486816406,
      "bbox_min": [
        -2525.290771484375,
        4955.25732421875,
        150.0
      ],
      "bbox_max": [
        -233.35060119628906,
        7296.97509765625,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2525.290771484375,
        6907.90576171875,
        150.0
      ],
      "bbox_max": [
        -569.3087768554688,
        7296.97509765625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -698.511962890625,
        7271.27490234375,
        763.2601928710938
      ],
      "bbox_max": [
        -569.3087768554688,
        7296.97509765625,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        6871.484375,
        150.0
      ],
      "bbox_max": [
        -1165.5224609375,
        7178.380859375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -3000.0,
      "bbox_min": [
        -5122.0185546875,
        -300.0,
        949.6846923828125
      ],
      "bbox_max": [
        -1550.0,
        1852.5999755859375,
        0.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3364546000957489,
        0.8870165944099426,
        0.31622767448425293
      ],
      "plane_d": 1797.4375,
      "bbox_min": [
        -3000.0,
        -3111.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1201.24462890625,
        -1978.615966796875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7519490718841553,
        0.5784223675727844,
        0.31622791290283203
      ],
      "plane_d": 266.113037109375,
      "bbox_min": [
        -3000.0,
        -3111.68505859375,
        -300.0
      ],
      "bbox_max": [
        -1201.24462890625,
        -1978.615966796875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7111499905586243,
        0.6279056072235107,
        0.3162280023097992
      ],
      "plane_d": 3988.61865234375,
      "bbox_min": [
        -3000.0,
        -3111.68505859375,
        -300.0
      ],
      "bbox_max": [
        -2832.052734375,
        -2803.447265625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -3000.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        949.6846923828125,
        -2021.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -3000.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        477.51397705078125,
        -2021.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320768237113953,
        0.5631359815597534,
        0.38332945108413696
      ],
      "plane_d": 259.0802001953125,
      "bbox_min": [
        -3000.0,
        -3623.86962890625,
        0.0
      ],
      "bbox_max": [
        -1050.0,
        -2021.68505859375,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5844033360481262,
        0.7305042147636414,
        0.35332190990448
      ],
      "plane_d": 957.4642333984375,
      "bbox_min": [
        -3000.0,
        -3623.86962890625,
        0.0
      ],
      "bbox_max": [
        -1050.0,
        -2671.68505859375,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8310546875,
      "bbox_min": [
        -3000.0,
        -3623.86962890625,
        0.0
      ],
      "bbox_max": [
        -1550.0,
        -2671.68505859375,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8973388671875,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -3000.0,
        -3565.30615234375,
        0.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2671.68505859375,
        1194.0616455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3000.0,
        -3565.30615234375,
        0.0
      ],
      "bbox_max": [
        -2100.0,
        -2954.536865234375,
        1194.0616455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3000.0,
        -3408.73486328125,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2954.536865234375,
        1194.0616455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3000.0,
        -3408.73486328125,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -3111.68505859375,
        1194.0616455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204001545906067,
        0.6658127903938293,
        0.19420865178108215
      ],
      "plane_d": 4133.041015625,
      "bbox_min": [
        -3000.0,
        -3111.68505859375,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2954.536865234375,
        311.6372375488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7315089106559753,
        0.6458920836448669,
        0.21844476461410522
      ],
      "plane_d": 4102.8388671875,
      "bbox_min": [
        -3000.0,
        -3111.68505859375,
        0.0
      ],
      "bbox_max": [
        -2861.24462890625,
        -2954.536865234375,
        150.8363037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054435841739177704,
        0.9979904890060425,
        0.032430119812488556
      ],
      "plane_d": 3654.259033203125,
      "bbox_min": [
        273.75537109375,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        477.51397705078125,
        -3646.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054435841739177704,
        0.9979904890060425,
        0.032430119812488556
      ],
      "plane_d": 3654.259033203125,
      "bbox_min": [
        273.75537109375,
        -3695.77197265625,
        0.0
      ],
      "bbox_max": [
        949.6846923828125,
        -3613.49072265625,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4633953869342804,
        0.8772453665733337,
        -0.12532076239585876
      ],
      "plane_d": 5618.984375,
      "bbox_min": [
        -3000.0,
        -5122.0185546875,
        1040.098388671875
      ],
      "bbox_max": [
        -2147.99658203125,
        -4650.2626953125,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3000.0,
        -5072.0185546875,
        1191.9580078125
      ],
      "bbox_max": [
        -2147.99658203125,
        -4650.2626953125,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2823.71630859375,
        -991.6719970703125,
        0.0
      ],
      "bbox_max": [
        -2355.001708984375,
        -503.75830078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4692252576351166,
        -0.76146399974823,
        0.4472138583660126
      ],
      "plane_d": 421.9500732421875,
      "bbox_min": [
        -2520.0,
        -991.6719970703125,
        0.0
      ],
      "bbox_max": [
        -2355.001708984375,
        -863.1936645507812,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1185.6846923828125,
        -2100.0,
        -300.0
      ],
      "bbox_max": [
        -800.0,
        -1347.3697509765625,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -1185.6846923828125,
        -1550.0,
        -300.0
      ],
      "bbox_max": [
        -800.0,
        -1347.3697509765625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2100.0,
        287.1609191894531
      ],
      "bbox_max": [
        -800.0,
        -1855.504150390625,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2906.989501953125,
        -897.0564575195312,
        -300.0
      ],
      "bbox_max": [
        -1821.7576904296875,
        322.07867431640625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4692252576351166,
        -0.76146399974823,
        0.4472138583660126
      ],
      "plane_d": 421.9500732421875,
      "bbox_min": [
        -2395.35791015625,
        -897.0564575195312,
        -300.0
      ],
      "bbox_max": [
        -1821.7576904296875,
        -575.3740234375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7848663926124573,
        -0.5329020619392395,
        0.31622785329818726
      ],
      "plane_d": 1159.303466796875,
      "bbox_min": [
        -1895.5322265625,
        -686.1002197265625,
        -300.0
      ],
      "bbox_max": [
        -1821.7576904296875,
        -609.2863159179688,
        7.897438049316406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7399791479110718,
        -0.5024248361587524,
        0.447213739156723
      ],
      "plane_d": 1093.001953125,
      "bbox_min": [
        -1895.5322265625,
        -612.2042846679688,
        0.0
      ],
      "bbox_max": [
        -1892.729736328125,
        -609.2863159179688,
        7.897438049316406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -3000.0,
        2944.781005859375,
        -300.0
      ],
      "bbox_max": [
        -800.0,
        4000.0,
        275.19207763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1010662093758583,
        -0.9432846307754517,
        0.3162275552749634
      ],
      "plane_d": 3427.828857421875,
      "bbox_min": [
        -3000.0,
        2944.781005859375,
        -300.0
      ],
      "bbox_max": [
        -1222.6312255859375,
        3548.820068359375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5895068049430847,
        -0.7432911992073059,
        0.31622785329818726
      ],
      "plane_d": 4052.21826171875,
      "bbox_min": [
        -3000.0,
        2944.781005859375,
        -300.0
      ],
      "bbox_max": [
        -2610.551025390625,
        3398.1728515625,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -3000.0,
        3121.493896484375,
        115.36239624023438
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18346190452575684,
        0.3073110282421112,
        0.9337567090988159
      ],
      "plane_d": -694.5667724609375,
      "bbox_min": [
        -3000.0,
        3141.74755859375,
        150.0
      ],
      "bbox_max": [
        -2669.724609375,
        3595.34423828125,
        275.19207763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5567466616630554,
        -0.7170891761779785,
        0.41930466890335083
      ],
      "plane_d": 3860.257568359375,
      "bbox_min": [
        -3000.0,
        3141.74755859375,
        150.0
      ],
      "bbox_max": [
        -2669.724609375,
        3398.1728515625,
        275.19207763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -0.0,
      "bbox_min": [
        -2820.0,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2670.0,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        -2820.0,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2670.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1261.748779296875,
      "bbox_min": [
        -2820.0,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2670.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1755.0640869140625,
      "bbox_min": [
        -1880.0,
        1230.0,
        -300.0
      ],
      "bbox_max": [
        -1430.0,
        2670.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1950.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1846.6668701171875,
        1750.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        2000.0,
        -10.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1846.6668701171875,
        1950.0,
        -30.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        -10.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2700.0,
      "bbox_min": [
        -2723.333251953125,
        1326.6666259765625,
        -10.000000953674316
      ],
      "bbox_max": [
        -1526.6666259765625,
        2573.333251953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 1261.748779296875,
      "bbox_min": [
        -2723.333251953125,
        1326.6666259765625,
        -10.000000953674316
      ],
      "bbox_max": [
        -2700.0,
        1330.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1755.0640869140625,
      "bbox_min": [
        -1880.0,
        1326.6666259765625,
        -10.000000953674316
      ],
      "bbox_max": [
        -1526.6666259765625,
        2573.333251953125,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1880.0,
        1950.0,
        -10.0
      ],
      "bbox_max": [
        -1846.6668701171875,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1850.0001220703125,
        1750.0,
        -10.0
      ],
      "bbox_max": [
        -1840.0,
        2000.0,
        0.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1949.9998779296875,
      "bbox_min": [
        -1850.0001220703125,
        1950.0,
        -10.0
      ],
      "bbox_max": [
        -1840.0,
        1950.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2700.0,
      "bbox_min": [
        -2720.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2570.0,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2720.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -2700.0,
        2570.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 2678.888916015625,
      "bbox_min": [
        -2720.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        2570.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 1312.37060546875,
      "bbox_min": [
        -2720.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        2560.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2529.270263671875,
      "bbox_min": [
        -2720.0,
        2550.0,
        200.0
      ],
      "bbox_max": [
        -2700.0,
        2560.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2550.0,
      "bbox_min": [
        -2700.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2570.0,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -1530.0,
        2550.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 2100.0,
      "bbox_min": [
        -2700.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2550.0,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        -1870.0,
        2100.0,
        0.0
      ],
      "bbox_max": [
        -1530.0,
        2550.0,
        531.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3594779074192047,
        -0.9298422336578369,
        0.07854417711496353
      ],
      "plane_d": 2730.958984375,
      "bbox_min": [
        -1870.0,
        2100.0,
        130.0
      ],
      "bbox_max": [
        -1530.0,
        2318.712646484375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3594778776168823,
        -0.9298421740531921,
        0.07854465395212173
      ],
      "plane_d": 1490.041259765625,
      "bbox_min": [
        -1771.570068359375,
        2280.72119140625,
        130.0
      ],
      "bbox_max": [
        -1726.0,
        2318.712646484375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 2080.4140625,
      "bbox_min": [
        -1870.0,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2120.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1860.0,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2120.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1511.8624267578125,
      "bbox_min": [
        -1540.0,
        2100.0,
        200.0
      ],
      "bbox_max": [
        -1530.0,
        2120.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1750.0,
      "bbox_min": [
        -2700.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1815.0,
        2100.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        -2700.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1870.0,
        1330.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        1750.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9974586963653564,
        0.07124704867601395
      ],
      "plane_d": 1312.37060546875,
      "bbox_min": [
        -1870.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        1350.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9974586963653564,
        -0.0,
        0.07124704867601395
      ],
      "plane_d": 1831.0491943359375,
      "bbox_min": [
        -1860.0,
        1330.0,
        200.0
      ],
      "bbox_max": [
        -1850.0,
        1350.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1850.0,
      "bbox_min": [
        -1850.0,
        2000.0,
        0.0
      ],
      "bbox_max": [
        -1850.0,
        2100.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1950.0,
      "bbox_min": [
        -1900.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1815.0,
        2000.0,
        225.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1840.0,
        1950.0,
        0.0
      ],
      "bbox_max": [
        -1820.0,
        2000.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1820.0,
      "bbox_min": [
        -1820.0,
        1950.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        2000.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1840.0,
      "bbox_min": [
        -1840.0,
        1750.0,
        0.0
      ],
      "bbox_max": [
        -1820.0,
        1950.0,
        225.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1820.0,
      "bbox_min": [
        -1820.0,
        1750.0,
        185.0
      ],
      "bbox_max": [
        -1820.0,
        1800.0,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16353431344032288,
        0.9344819188117981,
        0.3162277042865753
      ],
      "plane_d": -930.3038330078125,
      "bbox_min": [
        -2890.642578125,
        -685.6819458007812,
        -300.0
      ],
      "bbox_max": [
        -1313.2769775390625,
        844.7424926757812,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2807.00048828125,
        -685.6819458007812,
        -300.0
      ],
      "bbox_max": [
        -1313.2769775390625,
        844.7424926757812,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15418164432048798,
        0.8810380697250366,
        0.4472135305404663
      ],
      "plane_d": -877.0989379882812,
      "bbox_min": [
        -2807.00048828125,
        -685.6819458007812,
        -300.0
      ],
      "bbox_max": [
        -1313.2769775390625,
        844.7424926757812,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7848663926124573,
        -0.5329020619392395,
        0.31622785329818726
      ],
      "plane_d": 1159.303466796875,
      "bbox_min": [
        -1928.2808837890625,
        -685.6819458007812,
        -300.0
      ],
      "bbox_max": [
        -1313.2769775390625,
        844.7424926757812,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7399791479110718,
        -0.5024248361587524,
        0.447213739156723
      ],
      "plane_d": 1093.001953125,
      "bbox_min": [
        -1928.2808837890625,
        -612.1884155273438,
        -300.0
      ],
      "bbox_max": [
        -1313.2769775390625,
        844.7424926757812,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9361191391944885,
        0.15388573706150055,
        0.31622791290283203
      ],
      "plane_d": 1314.5240478515625,
      "bbox_min": [
        -1928.2808837890625,
        -609.2863159179688,
        -300.0
      ],
      "bbox_max": [
        -1313.2769775390625,
        844.7424926757812,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8825817704200745,
        0.14508481323719025,
        0.4472133219242096
      ],
      "plane_d": 1239.3453369140625,
      "bbox_min": [
        -1928.2808837890625,
        -609.2863159179688,
        0.0
      ],
      "bbox_max": [
        -1418.4259033203125,
        728.8226928710938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4692252576351166,
        -0.76146399974823,
        0.4472138583660126
      ],
      "plane_d": 421.9500732421875,
      "bbox_min": [
        -1928.2808837890625,
        -609.2863159179688,
        7.897435665130615
      ],
      "bbox_max": [
        -1895.5322265625,
        -575.2562866210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5121459960938,
      "bbox_min": [
        -800.0,
        2700.0,
        -300.0
      ],
      "bbox_max": [
        7681.30224609375,
        4000.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4204522669315338,
        0.06168942153453827,
        0.9052150249481201
      ],
      "plane_d": 665.100341796875,
      "bbox_min": [
        -800.0,
        2700.0,
        -300.0
      ],
      "bbox_max": [
        6811.5068359375,
        4000.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        2780.0,
        2700.0,
        -300.0
      ],
      "bbox_max": [
        5046.24072265625,
        4000.0,
        1336.528076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        3560.334716796875,
        2700.0,
        605.2196655273438
      ],
      "bbox_max": [
        4157.6171875,
        3150.14306640625,
        1007.5693969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        3560.334716796875,
        2700.0,
        605.2196655273438
      ],
      "bbox_max": [
        3737.0400390625,
        2778.274169921875,
        725.1106567382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        2780.0,
        2700.0,
        -300.0
      ],
      "bbox_max": [
        4157.6171875,
        4000.0,
        981.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.608350396156311,
        0.7279488444328308,
        0.3162280023097992
      ],
      "plane_d": -418.385498046875,
      "bbox_min": [
        3286.541015625,
        3366.0,
        -300.0
      ],
      "bbox_max": [
        4098.64111328125,
        4000.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2780.0,
        2700.0,
        80.0
      ],
      "bbox_max": [
        3662.3603515625,
        3200.0,
        667.9532470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        2780.0,
        2700.0,
        80.0
      ],
      "bbox_max": [
        2924.8818359375,
        3100.0,
        199.68505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        3252.70068359375,
        2700.0,
        360.0
      ],
      "bbox_max": [
        3662.3603515625,
        3200.0,
        667.9532470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4106284976005554,
        0.01650269143283367,
        0.9116533994674683
      ],
      "plane_d": 760.2809448242188,
      "bbox_min": [
        -800.0,
        3150.14306640625,
        -300.0
      ],
      "bbox_max": [
        6811.5068359375,
        4000.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7007350325584412,
        0.5362348556518555,
        0.4705556631088257
      ],
      "plane_d": 762.2274780273438,
      "bbox_min": [
        4157.6171875,
        3150.14306640625,
        981.6990966796875
      ],
      "bbox_max": [
        5075.16259765625,
        4000.0,
        1379.597412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -150.0,
      "bbox_min": [
        -800.0,
        3767.0244140625,
        -300.0
      ],
      "bbox_max": [
        -279.15447998046875,
        4000.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9319282174110413,
        -0.1775101274251938,
        0.31622785329818726
      ],
      "plane_d": 1065.060791015625,
      "bbox_min": [
        -444.3485107421875,
        3831.220458984375,
        -300.0
      ],
      "bbox_max": [
        -279.15447998046875,
        4000.0,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.027883131057024002,
        0.7254633903503418,
        0.6876956224441528
      ],
      "plane_d": 797.6544189453125,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.0238037109375,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        329.8454895019531
      ],
      "bbox_max": [
        7550.0,
        -1319.9400634765625,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        329.8454895019531
      ],
      "bbox_max": [
        6992.103515625,
        -1319.9400634765625,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2400.0,
        -1700.0,
        329.8454895019531
      ],
      "bbox_max": [
        6992.103515625,
        -1319.9400634765625,
        590.90966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        296.4333801269531
      ],
      "bbox_max": [
        7600.0,
        -1246.4334716796875,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2400.0,
        -1390.9161376953125,
        296.4333801269531
      ],
      "bbox_max": [
        7600.0,
        -1246.4334716796875,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.41241455078125,
      "bbox_min": [
        2400.0,
        -1350.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -3670.01708984375,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022904695942997932,
        0.8625975847244263,
        0.5053718686103821
      ],
      "plane_d": 1267.3873291015625,
      "bbox_min": [
        650.0,
        -2850.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.0238037109375,
      "bbox_min": [
        2300.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        650.0,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027094177901744843,
        0.9482962489128113,
        0.31622782349586487
      ],
      "plane_d": 817.0989990234375,
      "bbox_min": [
        650.0,
        -843.0780639648438,
        -300.0
      ],
      "bbox_max": [
        2273.75537109375,
        -696.68505859375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -800.0,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -800.0,
        -2500.0,
        -300.0
      ],
      "bbox_max": [
        0.0,
        -1127.742431640625,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -800.0,
        -1412.9681396484375,
        -300.0
      ],
      "bbox_max": [
        -279.618896484375,
        -1127.742431640625,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -800.0,
        -1412.9681396484375,
        -300.0
      ],
      "bbox_max": [
        -551.24462890625,
        -1278.748779296875,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -800.0,
        -1855.504150390625,
        -112.83790588378906
      ],
      "bbox_max": [
        -551.24462890625,
        -1371.68505859375,
        287.160888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29317936301231384,
        0.9022449254989624,
        0.31622767448425293
      ],
      "plane_d": 1075.9822998046875,
      "bbox_min": [
        -800.0,
        -1452.5167236328125,
        -112.83790588378906
      ],
      "bbox_max": [
        -551.24462890625,
        -1371.68505859375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -551.24462890625,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -551.24462890625,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4163157343864441,
        0.8524560332298279,
        0.3162277638912201
      ],
      "plane_d": 939.8093872070312,
      "bbox_min": [
        -551.24462890625,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016502970829606056,
        0.5776039958000183,
        0.8161503076553345
      ],
      "plane_d": 497.69219970703125,
      "bbox_min": [
        523.75537109375,
        -867.0938720703125,
        0.0
      ],
      "bbox_max": [
        650.0,
        -843.0780639648438,
        16.99639320373535
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1585269570350647,
        -0.2054760754108429,
        0.9657374024391174
      ],
      "plane_d": 128.0882568359375,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        7986.5068359375,
        2700.0,
        1793.450439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1284712553024292,
        -0.3080694079399109,
        0.9426496624946594
      ],
      "plane_d": 160.421142578125,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        7986.5068359375,
        2700.0,
        1663.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12591767311096191,
        -0.43786942958831787,
        0.8901770114898682
      ],
      "plane_d": 367.447509765625,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        7801.5068359375,
        2700.0,
        1293.5762939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        4530.3369140625,
        2700.0,
        1185.495849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4204522669315338,
        0.06168942153453827,
        0.9052150249481201
      ],
      "plane_d": 665.100341796875,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        4530.3369140625,
        2700.0,
        1185.495849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        4147.26904296875,
        2700.0,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        4050.0,
        2236.2041015625,
        940.5958251953125
      ],
      "bbox_max": [
        4147.26904296875,
        2700.0,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        4050.0,
        2236.2041015625,
        964.6398315429688
      ],
      "bbox_max": [
        4137.6171875,
        2371.977294921875,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        4077.6171875,
        935.8558959960938,
        611.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3825902044773102,
        0.0,
        0.9239181876182556
      ],
      "plane_d": 814.5899047851562,
      "bbox_min": [
        4050.0,
        1340.1431884765625,
        789.6677856445312
      ],
      "bbox_max": [
        4137.6171875,
        1387.95849609375,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        4050.0,
        1340.1431884765625,
        789.6677856445312
      ],
      "bbox_max": [
        4137.6171875,
        1374.29296875,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5121459960938,
      "bbox_min": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "bbox_max": [
        7986.5068359375,
        2700.0,
        1793.450439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4204522669315338,
        0.06168942153453827,
        0.9052150249481201
      ],
      "plane_d": 665.100341796875,
      "bbox_min": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "bbox_max": [
        4832.60107421875,
        2700.0,
        1325.8907470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        3000.0,
        660.0,
        0.0
      ],
      "bbox_max": [
        4050.0,
        2700.0,
        975.8950805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        3000.0,
        660.0,
        0.0
      ],
      "bbox_max": [
        3669.991455078125,
        2700.0,
        679.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        3000.0,
        820.0,
        0.0
      ],
      "bbox_max": [
        3669.991455078125,
        2700.0,
        679.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        3240.0,
        820.0,
        0.0
      ],
      "bbox_max": [
        3350.0,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3825902044773102,
        0.0,
        0.9239181876182556
      ],
      "plane_d": 814.5899047851562,
      "bbox_min": [
        3240.0,
        1690.0,
        460.0
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        1790.47265625,
        460.0
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1829.9998779296875,
      "bbox_min": [
        3000.0,
        1830.0,
        140.0
      ],
      "bbox_max": [
        3240.0,
        1836.1837158203125,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        3227.146728515625,
        1830.0,
        450.7663879394531
      ],
      "bbox_max": [
        3240.0,
        1836.1837158203125,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        3054.73388671875,
        1830.0,
        277.64373779296875
      ],
      "bbox_max": [
        3252.70068359375,
        2700.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        3217.469482421875,
        1830.0,
        441.3879089355469
      ],
      "bbox_max": [
        3240.0,
        1892.20361328125,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        3000.0,
        887.2413940429688,
        128.96551513671875
      ],
      "bbox_max": [
        3240.0,
        2700.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        3000.0,
        1830.0,
        171.30172729492188
      ],
      "bbox_max": [
        3228.21484375,
        2700.0,
        451.8016357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1829.9998779296875,
      "bbox_min": [
        3000.0,
        1830.0,
        171.30172729492188
      ],
      "bbox_max": [
        3228.21484375,
        1830.0,
        451.8016357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        3000.0,
        1830.0,
        206.71871948242188
      ],
      "bbox_max": [
        3211.686279296875,
        2494.87451171875,
        440.3035583496094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1829.9998779296875,
      "bbox_min": [
        3000.0,
        1830.0,
        206.71871948242188
      ],
      "bbox_max": [
        3211.686279296875,
        2494.87451171875,
        440.3035583496094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        3000.0,
        2471.92041015625,
        261.5539245605469
      ],
      "bbox_max": [
        3007.493408203125,
        2494.87451171875,
        267.9293518066406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        820.0,
        375.30828857421875
      ],
      "bbox_max": [
        4050.0,
        2700.0,
        975.8950805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5601329803466797,
        0.06843777745962143,
        0.8255710005760193
      ],
      "plane_d": 1309.8272705078125,
      "bbox_min": [
        3285.123046875,
        935.8558959960938,
        488.7391357421875
      ],
      "bbox_max": [
        4050.0,
        2700.0,
        975.89501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        3437.258056640625,
        935.8558959960938,
        495.7249755859375
      ],
      "bbox_max": [
        4050.0,
        1506.344482421875,
        789.6677856445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5660791993141174,
        0.06026303768157959,
        0.8221452236175537
      ],
      "plane_d": 1356.604248046875,
      "bbox_min": [
        3737.0400390625,
        2371.977294921875,
        725.110595703125
      ],
      "bbox_max": [
        4050.0,
        2700.0,
        964.6397705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3825902044773102,
        0.0,
        0.9239181876182556
      ],
      "plane_d": 814.5899047851562,
      "bbox_min": [
        3240.0,
        820.0,
        375.30828857421875
      ],
      "bbox_max": [
        4050.0,
        1790.47265625,
        795.417236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        3240.0,
        820.0,
        375.30828857421875
      ],
      "bbox_max": [
        4050.0,
        1690.0,
        795.417236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        3250.0,
        820.0,
        375.30828857421875
      ],
      "bbox_max": [
        3350.0,
        820.0,
        505.5504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        3250.0,
        820.0,
        464.1409912109375
      ],
      "bbox_max": [
        3350.0,
        820.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        -550.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        3000.0,
        2700.0,
        1180.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.5706354975700378,
        0.03875378891825676,
        0.8202885389328003
      ],
      "plane_d": 1400.6068115234375,
      "bbox_min": [
        365.8096618652344,
        1690.0,
        80.0
      ],
      "bbox_max": [
        3000.0,
        2700.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1829.9998779296875,
      "bbox_min": [
        2780.0,
        1830.0,
        140.0
      ],
      "bbox_max": [
        3000.0,
        2700.0,
        293.0434875488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5134666562080383,
        0.06992331147193909,
        0.8552559614181519
      ],
      "plane_d": 1142.2545166015625,
      "bbox_min": [
        2924.8818359375,
        2492.608642578125,
        199.68502807617188
      ],
      "bbox_max": [
        3000.0,
        2700.0,
        261.7391662597656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        365.8096618652344,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -326.482421875,
      "bbox_min": [
        1550.0001220703125,
        2011.7158203125,
        500.0
      ],
      "bbox_max": [
        1588.2843017578125,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        365.8096618652344,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1083.078369140625,
        1737.94091796875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        365.8096618652344,
        1690.0,
        240.0
      ],
      "bbox_max": [
        450.0,
        1719.423583984375,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        966.79248046875,
        1696.69873046875,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2588212490081787,
        -0.9659253358840942,
        0.0
      ],
      "plane_d": 1397.29833984375,
      "bbox_min": [
        966.79248046875,
        1715.8818359375,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588212490081787,
        -0.9659253358840942,
        0.0
      ],
      "plane_d": 1917.529052734375,
      "bbox_min": [
        966.79248046875,
        1715.8818359375,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071014642715454,
        -0.7071121335029602,
        0.0
      ],
      "plane_d": 491.2655029296875,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071041464805603,
        -0.7071094512939453,
        -5.75447211303981e-06
      ],
      "plane_d": 1912.5379638671875,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        982.94091796875,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        -550.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        2966.428466796875,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        2950.0,
        715.7142944335938,
        60.0
      ],
      "bbox_max": [
        2966.428466796875,
        768.5,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3451910614967346,
        0.9385325312614441,
        0.0
      ],
      "plane_d": 13.817352294921875,
      "bbox_min": [
        -550.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        1760.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -550.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        1760.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -550.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        360.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        480.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        480.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        1150.0,
        78.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        480.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        480.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1111.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        480.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1120.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        480.0,
        1111.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1120.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        440.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        440.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 331.15606689453125,
      "bbox_min": [
        477.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1111.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 331.15606689453125,
      "bbox_min": [
        477.0,
        1110.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        477.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        360.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1150.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        441.0,
        1111.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1150.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        441.0,
        1111.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        360.0,
        1150.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        360.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        395.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        500.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        600.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        395.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1460.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        600.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1440.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -295.1610107421875,
      "bbox_min": [
        445.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1439.9998779296875,
      "bbox_min": [
        445.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1450.0,
      "bbox_min": [
        525.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        540.0,
        1450.0,
        67.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 525.0,
      "bbox_min": [
        525.0,
        1440.0,
        65.4999771118164
      ],
      "bbox_max": [
        525.0,
        1450.0,
        67.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1450.0,
      "bbox_min": [
        525.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        535.9999389648438,
        1450.0,
        65.4999771118164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 525.0,
      "bbox_min": [
        525.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        525.0,
        1450.0,
        65.4999771118164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -429.3250732421875,
      "bbox_min": [
        445.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        360.0,
        1150.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        360.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1420.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        480.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1420.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        480.0,
        1170.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1420.0,
        78.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        360.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        360.0,
        1280.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1420.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        360.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        441.0,
        1416.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1135.922607421875,
      "bbox_min": [
        360.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        441.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1309.0,
        78.0
      ],
      "bbox_max": [
        400.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        400.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        360.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1420.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1135.922607421875,
      "bbox_min": [
        360.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1309.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        360.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        440.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        440.0,
        1150.0,
        60.0
      ],
      "bbox_max": [
        625.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        480.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        625.0,
        1170.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        625.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        625.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        440.0,
        1150.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        360.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        360.0,
        346.7968444824219,
        60.0
      ],
      "bbox_max": [
        630.0,
        604.1421508789062,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        60.0
      ],
      "bbox_max": [
        630.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.85065096616745,
        -0.2763929069042206,
        0.4472135007381439
      ],
      "plane_d": -265.04254150390625,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        60.0
      ],
      "bbox_max": [
        500.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506511449813843,
        0.27639296650886536,
        0.44721314311027527
      ],
      "plane_d": -486.1569519042969,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        60.0
      ],
      "bbox_max": [
        500.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -442.9906921386719,
      "bbox_min": [
        455.27862548828125,
        476.08453369140625,
        60.0
      ],
      "bbox_max": [
        500.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        456.27862548828125,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        500.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        480.0,
        481.1798095703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        570.0,
        560.0,
        60.0
      ],
      "bbox_max": [
        630.0,
        604.1421508789062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -570.0,
      "bbox_min": [
        570.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        620.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        650.0,
        634.1421508789062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9483067989349365,
        0.31735536456108093,
        0.0
      ],
      "plane_d": -778.2506713867188,
      "bbox_min": [
        620.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        650.0,
        586.1421508789062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        620.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        630.907958984375,
        567.050048828125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        620.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        623.85791015625,
        560.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        630.907958984375,
        567.050048828125,
        78.0
      ],
      "bbox_max": [
        650.0,
        586.1421508789062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -550.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        1500.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        310.0,
        560.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        80.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        310.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        310.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        340.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        1240.9998779296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        340.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        310.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        310.0,
        920.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        310.0,
        920.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -319.9999694824219,
      "bbox_min": [
        320.0,
        956.0,
        78.0
      ],
      "bbox_max": [
        320.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        359.0,
        920.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        921.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        310.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        310.0,
        1241.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        1250.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": -359.55975341796875,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        310.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -319.9999694824219,
      "bbox_min": [
        320.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        351.20001220703125,
        928.0,
        62.40000915527344
      ],
      "bbox_max": [
        360.0,
        928.7999877929688,
        64.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        352.0,
        921.0,
        64.00000762939453
      ],
      "bbox_max": [
        360.0,
        928.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        350.0,
        928.7999877929688,
        60.0
      ],
      "bbox_max": [
        360.0,
        930.0,
        62.40000915527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -550.0,
        830.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1500.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -550.0,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        310.0,
        1500.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -550.0,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        260.0,
        1430.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -50.0,
        1410.0,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -550.0,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        260.0,
        1413.3333740234375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        -530.0,
        1250.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -475.0,
        830.556396484375,
        60.0
      ],
      "bbox_max": [
        -50.0,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123724579811096,
        -0.3535531163215637,
        0.7071068286895752
      ],
      "plane_d": 421.4258117675781,
      "bbox_min": [
        -309.493896484375,
        830.556396484375,
        60.0042839050293
      ],
      "bbox_max": [
        -231.40599060058594,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123727560043335,
        0.35355329513549805,
        0.7071065902709961
      ],
      "plane_d": -222.87403869628906,
      "bbox_min": [
        -309.493896484375,
        911.17822265625,
        60.0042839050293
      ],
      "bbox_max": [
        -231.40599060058594,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.4938659667969,
        971.80615234375,
        60.00611877441406
      ],
      "bbox_max": [
        -289.5,
        1011.7999877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.493896484375,
        1006.4426879882812,
        60.0042839050293
      ],
      "bbox_max": [
        -286.5886535644531,
        1050.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5862517952919006,
        -0.3953181803226471,
        0.7071297764778137
      ],
      "plane_d": 540.6658935546875,
      "bbox_min": [
        -303.613037109375,
        1045.6845703125,
        60.0042839050293
      ],
      "bbox_max": [
        -286.5886535644531,
        1050.0,
        74.1191635131836
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6122786402702332,
        -0.3534996509552002,
        0.7072148323059082
      ],
      "plane_d": 419.9613037109375,
      "bbox_min": [
        -475.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -86.40599060058594,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7069985866546631,
        0.7072149515151978
      ],
      "plane_d": 719.5504150390625,
      "bbox_min": [
        -475.0,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -86.40599060058594,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -475.0,
        1077.77587890625,
        60.0
      ],
      "bbox_max": [
        -86.40599060058594,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -475.0,
        1077.77587890625,
        60.0
      ],
      "bbox_max": [
        -132.95298767089844,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35349076986312866,
        -0.6124177575111389,
        0.7070987820625305
      ],
      "plane_d": 705.6907958984375,
      "bbox_min": [
        -310.0,
        1077.77587890625,
        60.0
      ],
      "bbox_max": [
        -231.8204803466797,
        1239.02783203125,
        69.02511596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -310.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.02783203125,
        69.02511596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        -0.0
      ],
      "plane_d": -286.2166748046875,
      "bbox_min": [
        -310.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.02783203125,
        69.02511596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -310.0,
        1235.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1239.02783203125,
        64.02666473388672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -475.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -183.61666870117188,
        1370.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        -475.0,
        1235.0,
        60.0
      ],
      "bbox_max": [
        -310.0,
        1370.0,
        65.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        0.0
      ],
      "plane_d": -1093.5050048828125,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1391.728515625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        0.0
      ],
      "plane_d": -122.06173706054688,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 907.3590087890625,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -425.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        -475.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -432.32232666015625,
        1370.0,
        64.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.38268694281578064,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1049.3099365234375,
      "bbox_min": [
        -472.835205078125,
        1322.164794921875,
        60.0
      ],
      "bbox_max": [
        -450.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1435.9219970703125,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -450.0,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        0.0
      ],
      "plane_d": -77.86785888671875,
      "bbox_min": [
        -472.835205078125,
        1328.8531494140625,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 951.5531005859375,
      "bbox_min": [
        -472.835205078125,
        1345.0,
        60.0
      ],
      "bbox_max": [
        -466.1469421386719,
        1361.1468505859375,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        -0.0
      ],
      "plane_d": -286.2166748046875,
      "bbox_min": [
        -310.0,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -183.61666870117188,
        1365.5921630859375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1230.0,
      "bbox_min": [
        -310.0,
        1230.0,
        69.02511596679688
      ],
      "bbox_max": [
        -295.0,
        1230.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -63.999996185302734,
      "bbox_min": [
        -225.0,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -183.61666870117188,
        1365.5921630859375,
        64.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9238792061805725,
        -0.3826843500137329,
        0.0
      ],
      "plane_d": 720.583251953125,
      "bbox_min": [
        -222.835205078125,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -183.61666870117188,
        1365.3895263671875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238792061805725,
        0.3826843500137329,
        -0.0
      ],
      "plane_d": -308.837646484375,
      "bbox_min": [
        -222.835205078125,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -183.61666870117188,
        1365.3895263671875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -216.14694213867188,
        1320.0,
        60.0
      ],
      "bbox_max": [
        -183.61666870117188,
        1365.3895263671875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -216.14694213867188,
        1361.1468505859375,
        60.0
      ],
      "bbox_max": [
        -205.90431213378906,
        1365.3895263671875,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        0.9238786101341248,
        -0.0
      ],
      "plane_d": -1189.176513671875,
      "bbox_min": [
        -210.64144897460938,
        1325.2418212890625,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        0.3826843202114105,
        -0.0
      ],
      "plane_d": -353.03155517578125,
      "bbox_min": [
        -210.64144897460938,
        1325.2418212890625,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238791465759277,
        -0.3826843202114105,
        0.0
      ],
      "plane_d": 676.3892211914062,
      "bbox_min": [
        -210.64144897460938,
        1325.2418212890625,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -63.999996185302734,
      "bbox_min": [
        -210.64144897460938,
        1325.2418212890625,
        60.0
      ],
      "bbox_max": [
        -175.0,
        1370.0,
        64.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.38268694281578064,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1340.2503662109375,
      "bbox_min": [
        -209.63284301757812,
        1325.2418212890625,
        60.0
      ],
      "bbox_max": [
        -182.32232666015625,
        1367.835205078125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38268595933914185,
        -0.9238786101341248,
        0.0
      ],
      "plane_d": 1296.0570068359375,
      "bbox_min": [
        -187.34521484375,
        1325.2418212890625,
        60.0
      ],
      "bbox_max": [
        -182.32232666015625,
        1327.3223876953125,
        64.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35349076986312866,
        -0.6124177575111389,
        0.7070987820625305
      ],
      "plane_d": 705.6907958984375,
      "bbox_min": [
        -309.493896484375,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -249.1448516845703,
        1083.898193359375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5862517952919006,
        -0.3953181803226471,
        0.7071297764778137
      ],
      "plane_d": 540.6658935546875,
      "bbox_min": [
        -309.493896484375,
        1050.0,
        60.0
      ],
      "bbox_max": [
        -279.7840576171875,
        1075.0986328125,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.493896484375,
        1050.0,
        74.1191635131836
      ],
      "bbox_max": [
        -303.6130676269531,
        1051.7982177734375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1345.0,
        75.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1348.347412109375,
      "bbox_min": [
        190.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071041464805603,
        -0.0
      ],
      "plane_d": -1078.5234375,
      "bbox_min": [
        212.05908203125,
        1310.0,
        60.0
      ],
      "bbox_max": [
        215.2666778564453,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        120.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071041464805603,
        -0.0
      ],
      "plane_d": -1078.5234375,
      "bbox_min": [
        120.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": 724.588623046875,
      "bbox_min": [
        120.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1252.94091796875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        0.2588256597518921,
        0.0
      ],
      "plane_d": -78.86228942871094,
      "bbox_min": [
        250.6217041015625,
        1240.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        253.30126953125,
        1250.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1250.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 581.1431274414062,
      "bbox_min": [
        250.6217041015625,
        1300.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        253.30126953125,
        1300.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1300.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.049578726291656494,
        0.1196933388710022,
        0.9915722608566284
      ],
      "plane_d": -183.64974975585938,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1240.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488455414772,
        0.03555978089570999,
        0.995673418045044
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        -33.161930084228516,
        864.2627563476562,
        60.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06570588052272797,
        0.06570590287446976,
        0.9956733584403992
      ],
      "plane_d": -134.10910034179688,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        60.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.16403737664222717,
        0.9864540696144104
      ],
      "plane_d": -223.22462463378906,
      "bbox_min": [
        27.78174591064453,
        922.21826171875,
        60.0
      ],
      "bbox_max": [
        90.0,
        1000.0,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.045137323439121246,
        0.10897087305784225,
        0.9930195808410645
      ],
      "plane_d": -173.246337890625,
      "bbox_min": [
        27.78174591064453,
        922.21826171875,
        67.0
      ],
      "bbox_max": [
        79.34313201904297,
        957.9048461914062,
        72.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08340271562337875,
        0.08340274542570114,
        0.9930195808410645
      ],
      "plane_d": -150.7300262451172,
      "bbox_min": [
        -7.90482234954834,
        898.3732299804688,
        72.0
      ],
      "bbox_max": [
        48.99494934082031,
        922.21826171875,
        77.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -28.56972885131836,
        864.2627563476562,
        77.0
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        2.688058853149414,
        870.4802856445312,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1240.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        2.688058853149414,
        870.4802856445312,
        79.9343032836914
      ],
      "bbox_max": [
        3.5756804943084717,
        870.6568603515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        0.7071000337600708,
        0.0
      ],
      "plane_d": -699.5860595703125,
      "bbox_min": [
        90.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        250.6217041015625,
        1240.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1114.7694091796875,
      "bbox_min": [
        190.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1240.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": 724.588623046875,
      "bbox_min": [
        212.05908203125,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        215.2666778564453,
        1240.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        260.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        260.0,
        1241.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        260.0,
        1241.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1309.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1135.922607421875,
      "bbox_min": [
        270.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        310.0,
        1309.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        650.0,
        333.51434326171875,
        60.0
      ],
      "bbox_max": [
        1200.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        650.0,
        333.51434326171875,
        60.0
      ],
      "bbox_max": [
        784.1421508789062,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        333.51434326171875,
        60.0
      ],
      "bbox_max": [
        660.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -344.5075988769531,
      "bbox_min": [
        658.9999389648438,
        344.507568359375,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -344.5075988769531,
      "bbox_min": [
        650.0,
        344.507568359375,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        650.0,
        586.1421508789062,
        60.0
      ],
      "bbox_max": [
        733.1422119140625,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        586.1421508789062,
        78.0
      ],
      "bbox_max": [
        733.1422119140625,
        641.0000610351562,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        650.0,
        586.1421508789062,
        78.0
      ],
      "bbox_max": [
        710.9116821289062,
        641.0000610351562,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -930.2266845703125,
      "bbox_min": [
        687.3342895507812,
        595.192138671875,
        78.0
      ],
      "bbox_max": [
        710.9116821289062,
        611.698486328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        687.3342895507812,
        595.192138671875,
        78.0
      ],
      "bbox_max": [
        689.698486328125,
        597.5563354492188,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707107663154602,
        0.707105815410614,
        4.917645242130675e-07
      ],
      "plane_d": -930.2266845703125,
      "bbox_min": [
        674.5391235351562,
        625.8406372070312,
        78.0
      ],
      "bbox_max": [
        689.698486328125,
        641.0000610351562,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        655.8578491210938,
        640.0,
        60.0
      ],
      "bbox_max": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        704.1422119140625,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        707.730224609375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        721.0000610351562,
        704.1422119140625,
        78.0
      ],
      "bbox_max": [
        725.0022583007812,
        707.730224609375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7072440385818481,
        0.7069695591926575,
        0.0
      ],
      "plane_d": 45.334869384765625,
      "bbox_min": [
        665.698486328125,
        640.0,
        60.0
      ],
      "bbox_max": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        704.85205078125,
        641.0000610351562,
        60.0
      ],
      "bbox_max": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        760.0,
        686.0,
        78.0
      ],
      "bbox_max": [
        765.6922607421875,
        696.1694946289062,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        686.0,
        78.0
      ],
      "bbox_max": [
        765.6922607421875,
        689.9500122070312,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        764.0615844726562,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        760.0,
        686.0,
        60.0
      ],
      "bbox_max": [
        851.6212158203125,
        707.730224609375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        686.0,
        72.85089111328125
      ],
      "bbox_max": [
        760.0,
        696.1694946289062,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07647191733121872,
        -0.07647191733121872,
        0.9941348433494568
      ],
      "plane_d": 57.35394287109375,
      "bbox_min": [
        822.269775390625,
        700.0,
        60.0
      ],
      "bbox_max": [
        837.730224609375,
        707.730224609375,
        61.189266204833984
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        665.698486328125,
        640.0000610351562,
        66.99735260009766
      ],
      "bbox_max": [
        770.0,
        707.730224609375,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        760.0,
        696.1694946289062,
        78.0
      ],
      "bbox_max": [
        760.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        2.1591460608760826e-05
      ],
      "plane_d": -930.2283935546875,
      "bbox_min": [
        665.698486328125,
        640.0000610351562,
        78.0
      ],
      "bbox_max": [
        675.5390625,
        649.8406372070312,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        696.1694946289062,
        66.99735260009766
      ],
      "bbox_max": [
        770.0,
        707.730224609375,
        74.85089874267578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        696.1694946289062,
        66.99735260009766
      ],
      "bbox_max": [
        770.0,
        707.730224609375,
        74.85089874267578
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        706.1732788085938,
        66.99735260009766
      ],
      "bbox_max": [
        770.0,
        707.730224609375,
        69.78567504882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1250.0,
        880.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        650.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1210.0,
        1690.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        740.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1210.0,
        1690.0,
        80.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1472.83544921875,
        71.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        780.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        820.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        871.110595703125,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        820.0,
        1540.0,
        78.0
      ],
      "bbox_max": [
        832.5558471679688,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        78.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        820.0,
        1450.0,
        64.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        64.0
      ],
      "bbox_max": [
        871.110595703125,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        69.1110610961914
      ],
      "bbox_max": [
        890.0,
        1450.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        780.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1010.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1170.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1170.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -330.4908447265625,
      "bbox_min": [
        855.0,
        1160.0,
        60.0
      ],
      "bbox_max": [
        881.5714111328125,
        1170.0,
        71.28570556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        855.0,
        1160.0,
        60.0
      ],
      "bbox_max": [
        881.5714111328125,
        1170.0,
        71.28570556640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -870.0,
      "bbox_min": [
        870.0,
        1160.0,
        65.50000762939453
      ],
      "bbox_max": [
        870.0,
        1170.0,
        67.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        858.9999389648438,
        1160.0,
        60.0
      ],
      "bbox_max": [
        870.0,
        1170.0,
        65.50001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -870.0,
      "bbox_min": [
        870.0,
        1160.0,
        60.0
      ],
      "bbox_max": [
        870.0,
        1170.0,
        65.50001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        780.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1170.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        950.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        780.0,
        1120.0,
        70.71428680419922
      ],
      "bbox_max": [
        905.0,
        1170.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        780.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        780.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1150.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        905.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 527.358154296875,
      "bbox_min": [
        891.6666870117188,
        1120.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        905.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        891.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 328.7020263671875,
      "bbox_min": [
        891.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        895.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 895.0,
      "bbox_min": [
        891.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        895.0,
        1160.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        891.0,
        1160.0,
        78.0
      ],
      "bbox_max": [
        895.0,
        1160.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        876.4285888671875,
        1120.0,
        70.71428680419922
      ],
      "bbox_max": [
        905.0,
        1170.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 328.7020263671875,
      "bbox_min": [
        876.4285888671875,
        1160.0,
        70.71428680419922
      ],
      "bbox_max": [
        895.0,
        1170.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -330.4908447265625,
      "bbox_min": [
        876.4285888671875,
        1160.0,
        70.71428680419922
      ],
      "bbox_max": [
        895.0,
        1170.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        876.4285888671875,
        1160.0,
        70.71428680419922
      ],
      "bbox_max": [
        895.0,
        1160.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        1280.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        80.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1280.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1404.0,
      "bbox_min": [
        820.0,
        1404.0,
        78.0
      ],
      "bbox_max": [
        827.0,
        1404.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        64.0
      ],
      "bbox_max": [
        820.0,
        1400.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        780.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        960.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        780.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1010.0,
        880.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07647191733121872,
        -0.07647191733121872,
        0.9941348433494568
      ],
      "plane_d": 57.35394287109375,
      "bbox_min": [
        780.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        960.0,
        880.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        740.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        740.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        740.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        740.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        780.0,
        1420.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        740.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        760.0,
        1420.0,
        78.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        760.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        760.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1300.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        760.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        760.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        68.99735260009766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        68.99735260009766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        650.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        650.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        650.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        650.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1028.5911865234375,
      "bbox_min": [
        650.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        650.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        650.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        650.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1690.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        650.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        650.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        721.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        78.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        650.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        650.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        740.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        650.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        720.0,
        750.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        -550.0,
        250.0,
        79.99999237060547
      ],
      "bbox_max": [
        3000.0,
        1690.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        1910.0,
        706.95654296875,
        80.0
      ],
      "bbox_max": [
        3000.0,
        1690.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1910.0,
        706.95654296875,
        80.0
      ],
      "bbox_max": [
        3000.0,
        1470.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        2964.5,
        706.95654296875,
        80.0
      ],
      "bbox_max": [
        3000.0,
        887.2413330078125,
        128.96551513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        -550.0,
        250.0,
        79.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1308.2840576171875,
        138.0
      ],
      "bbox_max": [
        1770.0,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1508.2841796875,
        370.0
      ],
      "bbox_max": [
        1549.9998779296875,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1660.0,
        1308.2840576171875,
        138.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1660.0,
        1308.2840576171875,
        138.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        280.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1371.7872314453125,
      "bbox_min": [
        1660.0,
        1378.2838134765625,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1680.0,
        1308.2840576171875,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1680.0,
        1363.2840576171875,
        140.0
      ],
      "bbox_max": [
        1695.0,
        1400.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1695.0,
        1363.2840576171875,
        140.0
      ],
      "bbox_max": [
        1695.0,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        -550.0,
        250.0,
        79.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        760.0,
        304.0712890625,
        79.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        810.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1250.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1629.9998779296875,
      "bbox_min": [
        1600.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1415.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1398.28369140625,
        410.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1660.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1770.0,
        1398.28369140625,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1660.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1770.0,
        1398.28369140625,
        280.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1371.7872314453125,
      "bbox_min": [
        1660.0,
        1220.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1398.28369140625,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1378.28369140625,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1308.2840576171875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1750.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1750.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1280.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        1250.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1280.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1363.2840576171875,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1210.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1630.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1630.0,
        1030.0,
        120.0
      ],
      "bbox_max": [
        1680.0,
        1210.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1657.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1200.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1140.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1660.0,
        1140.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        995.0,
        80.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1690.0,
        995.0,
        120.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1700.0,
        1195.85791015625,
        120.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 356.4822998046875,
      "bbox_min": [
        1700.0,
        1195.85791015625,
        310.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 116.3343505859375,
      "bbox_min": [
        1700.0,
        1195.85791015625,
        310.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1690.0,
        995.0,
        120.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 1234.2078857421875,
      "bbox_min": [
        1690.0,
        995.0,
        310.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 116.3343505859375,
      "bbox_min": [
        1690.0,
        1195.85791015625,
        310.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        995.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1457.91650390625,
      "bbox_min": [
        1680.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1200.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1600.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1600.0,
        1270.0,
        671.822998046875
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1600.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1600.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1600.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1625.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1600.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1600.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1600.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1600.0,
        1130.0,
        104.66666412353516
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1600.0,
        1160.0,
        106.66666412353516
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1600.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1625.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1600.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1600.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1600.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1600.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1600.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        960.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1630.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1600.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1655.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1655.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        960.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1700.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1250.0,
        760.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1690.0,
        763.746826171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1530.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1400.0,
        763.746826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1400.0,
        763.746826171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1530.0,
        1270.0,
        622.3255004882812
      ],
      "bbox_max": [
        1600.0,
        1400.0,
        763.746826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1130.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1555.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1555.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1600.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1555.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1530.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1530.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1555.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1530.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1530.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1530.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1535.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1530.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1530.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1530.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1530.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1530.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1600.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1170.0,
        106.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1160.0,
        106.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1535.0,
        1130.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1535.0,
        1130.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1659.7220458984375,
      "bbox_min": [
        1530.0,
        960.0,
        120.0
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1556.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1530.0,
        1030.0,
        120.0
      ],
      "bbox_max": [
        1557.0,
        1120.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1555.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1557.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1530.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1535.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1530.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1535.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -579.8275756835938,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1530.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        714.2493896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        714.2493896484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1350.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        714.2493896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1350.0,
        1270.0,
        106.52173614501953
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        714.2493896484375
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1400.0,
        1270.0,
        530.401611328125
      ],
      "bbox_max": [
        1530.0,
        1400.0,
        714.2493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 42.4263916015625,
      "bbox_min": [
        1350.0,
        1290.0,
        138.0
      ],
      "bbox_max": [
        1479.7767333984375,
        1419.7767333984375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1969.644775390625,
      "bbox_min": [
        1387.393798828125,
        1292.393798828125,
        340.0
      ],
      "bbox_max": [
        1457.7491455078125,
        1362.7491455078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1919.644775390625,
      "bbox_min": [
        1387.393798828125,
        1292.393798828125,
        390.0
      ],
      "bbox_max": [
        1422.393798828125,
        1327.393798828125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1969.644775390625,
      "bbox_min": [
        1372.393798828125,
        1327.393798828125,
        340.0
      ],
      "bbox_max": [
        1422.7491455078125,
        1377.7491455078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1919.644775390625,
      "bbox_min": [
        1372.393798828125,
        1327.393798828125,
        390.0
      ],
      "bbox_max": [
        1387.393798828125,
        1342.393798828125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1350.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1270.0,
        465.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1350.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1395.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1475.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1475.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1475.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1395.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1395.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1395.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1395.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1455.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1455.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1455.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1455.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1350.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1350.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1350.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1350.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1350.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1270.0,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1350.0,
        1220.0,
        104.34782409667969
      ],
      "bbox_max": [
        1508.7454833984375,
        1270.0,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37631431221961975,
        0.9264920949935913,
        0.0
      ],
      "plane_d": -573.57470703125,
      "bbox_min": [
        1499.5404052734375,
        1221.19482421875,
        141.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1230.57275390625,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211491346359253,
        -0.389210045337677,
        0.0
      ],
      "plane_d": 1858.0826416015625,
      "bbox_min": [
        1499.5404052734375,
        1221.19482421875,
        141.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3131498396396637,
        -0.7712410092353821,
        0.5541882514953613
      ],
      "plane_d": 1329.209716796875,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3131498694419861,
        0.7712409496307373,
        0.5541881918907166
      ],
      "plane_d": -560.33056640625,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7378709316253662,
        -0.3116414248943329,
        0.5986869931221008
      ],
      "plane_d": 1398.631591796875,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.737870991230011,
        0.3116414248943329,
        0.5986870527267456
      ],
      "plane_d": 635.110107421875,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 152.99998474121094,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619802355766296,
        -0.9265393614768982,
        0.0
      ],
      "plane_d": 1700.7138671875,
      "bbox_min": [
        1504.5679931640625,
        1224.2843017578125,
        148.0
      ],
      "bbox_max": [
        1505.5,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619802355766296,
        0.9265393614768982,
        0.0
      ],
      "plane_d": -569.3077392578125,
      "bbox_min": [
        1504.5679931640625,
        1225.3372802734375,
        148.0
      ],
      "bbox_max": [
        1505.5,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1350.0,
        1220.0,
        104.34782409667969
      ],
      "bbox_max": [
        1400.0,
        1270.0,
        108.69564819335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1350.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1350.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1170.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1350.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1370.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1455.0,
        1130.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1455.0,
        1130.0,
        138.0
      ],
      "bbox_max": [
        1455.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1300.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        102.17391204833984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1300.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        102.17391204833984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1130.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1250.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        379.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1250.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1220.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1300.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 491.9349670410156,
      "bbox_min": [
        1336.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        1336.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        1346.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1220.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        1220.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1149.9998779296875,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1340.0,
        1150.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1250.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1290.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        1290.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1290.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1310.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1250.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1350.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1350.0,
        1290.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1350.0,
        1290.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071054577827454,
        0.7071080803871155,
        0.0
      ],
      "plane_d": 42.423095703125,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1350.0,
        1290.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1814.335693359375,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1347.928955078125,
        1232.928955078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1290.0,
        1160.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1814.3355712890625,
      "bbox_min": [
        1297.928955078125,
        1252.9288330078125,
        138.0
      ],
      "bbox_max": [
        1312.928955078125,
        1267.9288330078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1396.0,
        992.9839477539062,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1476.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        1396.0,
        1030.0,
        120.0
      ],
      "bbox_max": [
        1477.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1475.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1477.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1405.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1455.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1396.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1405.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1397.0,
        1120.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1397.0,
        1120.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2940855622291565,
        0.9557791948318481,
        0.0
      ],
      "plane_d": -511.7098693847656,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1380.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1380.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        100.0
      ],
      "bbox_max": [
        1380.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1250.0,
        820.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        992.9840087890625,
        515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1381.503662109375,
        960.0,
        140.0
      ],
      "bbox_max": [
        1492.0,
        992.9840087890625,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1381.503662109375,
        960.0,
        140.0
      ],
      "bbox_max": [
        1412.0,
        969.1033325195312,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1381.503662109375,
        960.0,
        160.0
      ],
      "bbox_max": [
        1390.0,
        962.6142578125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1250.0,
        820.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1300.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 442.741455078125,
      "bbox_min": [
        1320.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1320.0,
      "bbox_min": [
        1320.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        880.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        1330.0,
        820.0,
        170.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.9557790756225586,
        0.0
      ],
      "plane_d": -473.4782409667969,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        959.5372924804688,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        950.0,
        125.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1380.0,
        890.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        950.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        890.0,
        88.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1480.0,
        890.0,
        88.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1510.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1520.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 490.1461181640625,
      "bbox_min": [
        1510.0,
        900.0,
        88.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        900.0,
        88.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1510.0,
        904.0,
        90.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1480.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        950.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1480.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1500.0,
        950.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1480.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1510.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 490.1461181640625,
      "bbox_min": [
        1510.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        936.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27716064453125,
        0.9608235955238342,
        0.0
      ],
      "plane_d": -491.8677978515625,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1380.0,
        910.0,
        120.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1380.0,
        959.5372924804688,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1380.0,
        959.5372924804688,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1320.0,
      "bbox_min": [
        1320.0,
        901.5384521484375,
        98.0
      ],
      "bbox_max": [
        1320.0,
        921.5384521484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3451910614967346,
        0.9385325312614441,
        0.0
      ],
      "plane_d": 13.817352294921875,
      "bbox_min": [
        760.0,
        304.0712890625,
        79.99999237060547
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        334.07470703125,
        80.0
      ],
      "bbox_max": [
        1190.0,
        707.730224609375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        760.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1190.0,
        707.730224609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        760.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1190.0,
        680.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        760.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        880.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        880.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1049.4876708984375,
      "bbox_min": [
        880.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        950.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        950.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1040.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1040.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        760.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        840.0,
        640.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        760.0,
        615.8577880859375,
        80.0
      ],
      "bbox_max": [
        784.1422119140625,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        760.0,
        615.8577880859375,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        760.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        840.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        760.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        995.0,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        760.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        995.0,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 784.1422119140625,
      "bbox_min": [
        760.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        805.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -805.0,
      "bbox_min": [
        805.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        805.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.9238800406455994,
        0.0
      ],
      "plane_d": -309.68353271484375,
      "bbox_min": [
        760.0,
        644.1637573242188,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        760.0,
        644.1637573242188,
        98.0
      ],
      "bbox_max": [
        770.0000610351562,
        654.1421508789062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        782.269775390625,
        701.7156982421875,
        80.0
      ],
      "bbox_max": [
        854.0377807617188,
        707.730224609375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        782.269775390625,
        701.7156982421875,
        120.0
      ],
      "bbox_max": [
        794.298828125,
        707.730224609375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      "bbox_max": [
        854.0377807617188,
        707.730224609375,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        760.0,
        334.07470703125,
        140.0
      ],
      "bbox_max": [
        1150.0,
        707.730224609375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        760.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1049.4876708984375,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        990.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        880.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        516.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        950.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        990.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1040.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1040.0,
        600.0,
        140.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        760.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        707.730224609375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        760.0,
        516.0999755859375,
        140.0
      ],
      "bbox_max": [
        775.0,
        707.730224609375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        760.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        775.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        760.0,
        341.656982421875,
        190.0
      ],
      "bbox_max": [
        1150.0,
        707.730224609375,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        840.0,
        500.0,
        190.0
      ],
      "bbox_max": [
        1150.0,
        640.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        840.0,
        500.0,
        190.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1049.4876708984375,
      "bbox_min": [
        840.0,
        600.0,
        190.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        640.0,
        190.0
      ],
      "bbox_max": [
        880.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        950.0,
        500.0,
        190.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        950.0,
        600.0,
        190.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        950.0,
        600.0,
        190.0
      ],
      "bbox_max": [
        990.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        600.0,
        190.0
      ],
      "bbox_max": [
        950.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1040.0,
        600.0,
        190.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        190.0
      ],
      "bbox_max": [
        766.0144653320312,
        707.730224609375,
        232.14804077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        701.7157592773438,
        220.0
      ],
      "bbox_max": [
        762.6031494140625,
        707.730224609375,
        232.14804077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        760.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        760.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        950.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1030.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1030.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1030.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1033.75,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1183.0,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1033.75,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1033.75,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1030.0,
        1610.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1030.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1183.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        1030.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1036.5,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1030.0,
        1610.0,
        114.0
      ],
      "bbox_max": [
        1037.5,
        1610.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1037.2222900390625,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1037.5947265625,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1187.731689453125,
        1639.419189453125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1037.5947265625,
        1639.419189453125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1590.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684099584817886,
        0.0,
        0.9931507110595703
      ],
      "plane_d": 40.8941650390625,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1030.0,
        1440.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1226.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1226.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        950.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        950.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        950.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        950.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        950.0,
        1550.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        950.0,
        1550.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        950.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        950.0,
        1570.0,
        120.0
      ],
      "bbox_max": [
        960.0,
        1586.6666259765625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        950.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        950.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1460.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        950.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        950.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        950.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        950.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        960.0,
        1300.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1143.07421875,
        133.9837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1000.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1003.75,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1000.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1000.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        1003.75,
        1610.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1620.0,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1590.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -831.8172607421875,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        980.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        980.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        980.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        120.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        100.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        980.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1440.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1000.0,
        1140.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1000.0,
        1140.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 646.6708984375,
      "bbox_min": [
        1020.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1019.9999389648438,
      "bbox_min": [
        1020.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1250.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        980.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1000.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1019.9999389648438,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1020.0,
        1206.0,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1020.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1020.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1206.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1020.0,
        1200.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        988.9999389648438,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        950.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        950.0,
        1100.9998779296875,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        950.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1010.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1160.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1020.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1160.0,
        1110.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1159.5999755859375,
        940.0,
        130.0
      ],
      "bbox_max": [
        1160.0,
        940.7999877929688,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1020.0,
        1079.5999755859375,
        130.0
      ],
      "bbox_max": [
        1020.7999877929688,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.0,
        1080.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1110.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.0,
        1083.7332763671875,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1170.0,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1010.7999877929688,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        936.6666870117188,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1170.0,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1010.7999877929688,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1010.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1010.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974522560834885
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1010.7999877929688,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1010.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1010.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974522560834885
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1010.7999877929688,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        950.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        950.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        950.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        960.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.21319580078125,
      "bbox_min": [
        960.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        976.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -989.9999389648438,
      "bbox_min": [
        976.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 969.9999389648438,
      "bbox_min": [
        976.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        950.0,
        970.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        950.0,
        1100.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1100.9998779296875,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1096.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1096.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -332.7269287109375,
      "bbox_min": [
        950.0,
        970.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1100.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        950.0,
        970.0,
        103.00000762939453
      ],
      "bbox_max": [
        980.0,
        1094.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        950.0,
        970.0,
        108.0
      ],
      "bbox_max": [
        980.0,
        1084.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        956.0,
        1070.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1084.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        956.0,
        1070.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1070.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        950.0,
        970.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1084.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -581.377685546875,
      "bbox_min": [
        950.0,
        970.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1084.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -990.0,
      "bbox_min": [
        950.0,
        970.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1070.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        950.0,
        970.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        950.0,
        1070.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1070.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -581.377685546875,
      "bbox_min": [
        950.0,
        1080.0,
        103.00000762939453
      ],
      "bbox_max": [
        960.0,
        1094.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -581.377685546875,
      "bbox_min": [
        950.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1080.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": 326.8238220214844,
      "bbox_min": [
        1125.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1125.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1140.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": 326.8238220214844,
      "bbox_min": [
        1080.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1130.0,
        910.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -909.9999389648438,
      "bbox_min": [
        1080.0,
        910.0,
        80.0
      ],
      "bbox_max": [
        1130.0,
        910.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        950.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        920.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        950.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        920.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        958.2843017578125,
        900.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        980.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        930.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        950.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        930.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        950.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        930.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        978.2843017578125,
        920.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        978.2843017578125,
        920.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        921.7156982421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        921.7156982421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        950.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1240.0,
        1630.0,
        379.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        950.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        580.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        950.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        950.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        950.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        985.4664306640625,
        1179.3992919921875,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        950.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        985.4664306640625,
        1179.3992919921875,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1000.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9418852925300598,
        -0.33593469858169556,
        0.0
      ],
      "plane_d": -550.1356201171875,
      "bbox_min": [
        950.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        950.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        950.0,
        1120.0,
        280.0
      ],
      "bbox_max": [
        1000.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        950.0,
        1120.0,
        280.0
      ],
      "bbox_max": [
        1000.0,
        1170.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1166.1483154296875,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        950.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        580.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1030.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1039.49951171875,
        1610.0,
        160.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1039.49951171875,
        1610.0,
        160.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1039.49951171875,
        1630.0,
        160.0
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1057.5947265625,
        1630.0,
        303.5163879394531
      ],
      "bbox_max": [
        1240.0,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1630.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        1039.49951171875,
        1630.0,
        160.0
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        190.0
      ],
      "bbox_max": [
        1083.078369140625,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1039.49951171875,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        158.0
      ],
      "bbox_max": [
        1039.49951171875,
        1690.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1540.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1030.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1540.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1030.0,
        1460.0,
        355.9431457519531
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1470.0,
        355.9431457519531
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1470.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        390.0852355957031
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1519.9998779296875,
      "bbox_min": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1520.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1090.0,
      "bbox_min": [
        1030.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1460.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1090.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1310.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1310.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1090.0,
        1380.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1075.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1090.0,
        1310.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1030.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        950.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1680.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        950.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1680.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 149.99998474121094,
      "bbox_min": [
        950.0,
        1652.0,
        140.0
      ],
      "bbox_max": [
        970.0,
        1680.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -572.7564697265625,
      "bbox_min": [
        950.0,
        1652.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        950.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1658.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        950.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        970.0,
        1600.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        950.0,
        1590.0,
        140.0
      ],
      "bbox_max": [
        960.0,
        1600.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        960.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1580.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        960.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1580.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        960.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        970.0,
        1580.0,
        159.99996948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        950.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        954.0000610351562,
        1580.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        950.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        950.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        370.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1519.9998779296875,
      "bbox_min": [
        950.0,
        1310.0,
        275.943115234375
      ],
      "bbox_max": [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        950.0,
        1310.0,
        275.943115234375
      ],
      "bbox_max": [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        950.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        -0.9603399634361267,
        0.0
      ],
      "plane_d": 1215.2716064453125,
      "bbox_min": [
        950.0,
        1541.28955078125,
        160.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        -0.9603399634361267,
        0.0
      ],
      "plane_d": 1215.2716064453125,
      "bbox_min": [
        950.0,
        1541.28955078125,
        140.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1180.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1020.3999633789062,
        950.0,
        140.0
      ],
      "bbox_max": [
        1180.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1020.3999633789062,
        950.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1150.0,
        950.0,
        255.0000762939453
      ],
      "bbox_max": [
        1160.0,
        960.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1038.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.7999877929688,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1020.0,
        1083.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": -1112.6187744140625,
      "bbox_min": [
        1010.7999877929688,
        1092.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1030.0,
        1092.0,
        380.0
      ],
      "bbox_max": [
        1037.0,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974522560834885
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.7999877929688,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1046.6666259765625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1046.6666259765625,
        1110.0,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        1113.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1037.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1075.0,
        1310.0,
        580.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1470.0,
        580.0
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1075.0,
        1310.0,
        580.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1310.0,
        580.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        950.0,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1250.0,
        950.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5852661132812,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        950.0,
        940.3999633789062,
        140.0
      ],
      "bbox_max": [
        1160.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1160.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1155.0,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1160.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        950.0,
        940.3999633789062,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        245.16854858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        950.0,
        944.6067504882812,
        220.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        245.16854858398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        950.0,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1046.6666259765625,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        950.0,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1001.8842163085938,
        944.6067504882812,
        263.49517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        950.0,
        940.6796264648438,
        245.16854858398438
      ],
      "bbox_max": [
        995.8233642578125,
        944.6067504882812,
        263.49517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        995.4842529296875,
        940.6796264648438,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        950.0,
        924.773681640625,
        263.49517822265625
      ],
      "bbox_max": [
        986.7498779296875,
        940.6796264648438,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        160.0
      ],
      "bbox_max": [
        1240.0,
        916.4603881835938,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1690.0,
        600.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1690.0,
        140.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        780.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        780.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1690.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        780.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1670.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1610.0,
        100.0
      ],
      "bbox_max": [
        940.0,
        1670.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        940.0,
        1610.0,
        110.0
      ],
      "bbox_max": [
        940.0,
        1650.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1655.0,
        100.0
      ],
      "bbox_max": [
        805.0,
        1670.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        780.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        950.0,
        1595.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        800.0,
        1590.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1586.6666259765625,
        120.0
      ],
      "bbox_max": [
        950.0,
        1595.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98626708984375,
      "bbox_min": [
        780.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        832.5558471679688,
        1460.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1460.0,
        89.1501693725586
      ],
      "bbox_max": [
        950.0,
        1541.28955078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        933.0026245117188,
        1460.0,
        98.0
      ],
      "bbox_max": [
        950.0,
        1541.28955078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        98.0
      ],
      "bbox_max": [
        950.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        945.5584716796875,
        1460.0,
        98.0
      ],
      "bbox_max": [
        950.0,
        1545.3692626953125,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1570.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        820.0,
        1472.83544921875,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1540.0,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -945.5584716796875,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        120.0
      ],
      "bbox_max": [
        945.5584716796875,
        1570.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        780.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        780.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        890.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        933.0026245117188,
        1524.8212890625,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        780.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        780.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1460.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        970.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        930.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        836.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        836.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        836.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -949.9999389648438,
      "bbox_min": [
        836.0,
        950.0,
        108.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        780.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1460.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        780.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": -529.0731201171875,
      "bbox_min": [
        845.0,
        1120.0,
        108.0
      ],
      "bbox_max": [
        901.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        -0.0,
        -0.4472135901451111
      ],
      "plane_d": 854.177978515625,
      "bbox_min": [
        900.0,
        1120.0,
        108.0
      ],
      "bbox_max": [
        901.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        -0.0,
        -0.4472135901451111
      ],
      "plane_d": 854.177978515625,
      "bbox_min": [
        900.0,
        1130.0,
        108.0
      ],
      "bbox_max": [
        901.0,
        1166.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": -529.0731201171875,
      "bbox_min": [
        845.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        -0.8574929237365723
      ],
      "plane_d": 527.358154296875,
      "bbox_min": [
        845.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        895.0,
        1130.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        845.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        895.0,
        1130.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 905.0,
      "bbox_min": [
        901.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        -0.0,
        -0.4472135901451111
      ],
      "plane_d": 854.177978515625,
      "bbox_min": [
        901.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        780.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1460.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        780.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        1460.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        945.5584716796875,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1404.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        883.0,
        1404.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1404.0,
      "bbox_min": [
        883.0,
        1404.0,
        98.0
      ],
      "bbox_max": [
        890.0,
        1404.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98627471923828,
      "bbox_min": [
        933.0026245117188,
        1280.0,
        98.0
      ],
      "bbox_max": [
        945.5584716796875,
        1310.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1460.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 148.34939575195312,
      "bbox_min": [
        820.0,
        1404.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1404.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1404.0,
      "bbox_min": [
        820.0,
        1404.0,
        80.0
      ],
      "bbox_max": [
        890.0,
        1404.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        80.0
      ],
      "bbox_max": [
        882.9999389648438,
        1450.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15730521082878113,
        0.0,
        0.9875500798225403
      ],
      "plane_d": 49.98627471923828,
      "bbox_min": [
        820.0,
        1280.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1310.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15730521082878113,
        0.0,
        -0.9875500798225403
      ],
      "plane_d": -51.96137237548828,
      "bbox_min": [
        832.5558471679688,
        1280.0,
        80.0
      ],
      "bbox_max": [
        945.5584716796875,
        1310.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        945.5584716796875,
        1460.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        780.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        1165.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        930.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        930.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        1165.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        1165.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        -0.0,
        -0.4472135901451111
      ],
      "plane_d": 854.177978515625,
      "bbox_min": [
        885.0,
        1120.0,
        110.0
      ],
      "bbox_max": [
        900.0,
        1165.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        925.0,
        1100.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -721.3172607421875,
      "bbox_min": [
        805.0,
        990.0,
        110.0
      ],
      "bbox_max": [
        925.0,
        1100.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        805.0,
        990.0,
        110.0
      ],
      "bbox_max": [
        925.0,
        1100.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 618.4806518554688,
      "bbox_min": [
        805.0,
        990.0,
        110.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        805.0,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        805.0,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        805.0,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        822.5736083984375,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        0.4117811918258667,
        0.0
      ],
      "plane_d": 303.2713623046875,
      "bbox_min": [
        805.0,
        1045.0,
        110.0
      ],
      "bbox_max": [
        822.5736083984375,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -474.04644775390625,
      "bbox_min": [
        820.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        824.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 472.2575988769531,
      "bbox_min": [
        820.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -474.04644775390625,
      "bbox_min": [
        820.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -949.9999389648438,
      "bbox_min": [
        820.0,
        950.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1280.0,
        110.0
      ],
      "bbox_max": [
        945.5584716796875,
        1460.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        780.0,
        1280.0,
        120.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        110.0
      ],
      "bbox_max": [
        945.5584716796875,
        1460.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1310.0,
        110.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        820.0,
        1450.0,
        110.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        760.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        760.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.0,
        -0.44721364974975586
      ],
      "plane_d": 742.3746948242188,
      "bbox_min": [
        760.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        760.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        775.0,
        1040.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        775.0,
        1280.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        775.0000610351562,
        1040.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        775.0000610351562,
        1130.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        776.0,
        1166.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        776.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        760.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1279.9998779296875,
      "bbox_min": [
        760.0,
        1280.0,
        110.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        770.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        770.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        770.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        760.0,
        900.0,
        108.0
      ],
      "bbox_max": [
        776.0,
        1130.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        760.0,
        1040.0,
        108.0
      ],
      "bbox_max": [
        776.0,
        1130.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        760.0,
        1040.0,
        108.0
      ],
      "bbox_max": [
        776.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        760.0,
        1130.0,
        108.0
      ],
      "bbox_max": [
        776.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        771.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        771.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        760.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        771.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        760.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1680.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        780.0,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        950.0,
        1680.0,
        600.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35496851801872253,
        -0.9348782300949097,
        0.0
      ],
      "plane_d": 598.481689453125,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -741.3171997070312,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": -1293.248291015625,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": 283.2706604003906,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        170.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -721.3172607421875,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        925.0,
        1100.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        925.0,
        1100.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        907.4263916015625,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        0.4117811918258667,
        0.0
      ],
      "plane_d": 303.2713623046875,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        907.4263916015625,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 618.4806518554688,
      "bbox_min": [
        865.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        907.4263916015625,
        1027.5386962890625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        869.3509521484375,
        995.6954345703125,
        160.0
      ],
      "bbox_max": [
        890.0,
        1027.5386962890625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9348785877227783,
        0.35496786236763,
        0.0
      ],
      "plane_d": -1176.133056640625,
      "bbox_min": [
        869.3509521484375,
        995.6954345703125,
        160.0
      ],
      "bbox_max": [
        890.0,
        1027.5386962890625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9348782896995544,
        -0.3549685478210449,
        0.0
      ],
      "plane_d": 1186.830078125,
      "bbox_min": [
        869.3509521484375,
        999.4923706054688,
        160.0
      ],
      "bbox_max": [
        890.0,
        1027.5386962890625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35496246814727783,
        -0.9348806142807007,
        0.0
      ],
      "plane_d": 648.4893798828125,
      "bbox_min": [
        869.3509521484375,
        1023.7418212890625,
        160.0
      ],
      "bbox_max": [
        879.3509521484375,
        1027.5386962890625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        0.8660252690315247,
        0.0
      ],
      "plane_d": -681.5838623046875,
      "bbox_min": [
        805.3590087890625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 805.3590087890625,
      "bbox_min": [
        805.3590087890625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        -0.8660252690315247,
        -0.0
      ],
      "plane_d": 1452.3023681640625,
      "bbox_min": [
        805.3590087890625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000002384185791,
        -0.8660252690315247,
        0.0
      ],
      "plane_d": 612.3018798828125,
      "bbox_min": [
        805.3590087890625,
        1128.4915771484375,
        140.0
      ],
      "bbox_max": [
        950.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        805.3590087890625,
        1192.0,
        140.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        805.3590087890625,
        1192.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1272.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        874.6409912109375,
        1212.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1252.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1252.0,
      "bbox_min": [
        874.6409912109375,
        1252.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1252.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        874.6409912109375,
        1128.4915771484375,
        140.0
      ],
      "bbox_max": [
        950.0,
        1232.41455078125,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        910.0,
        1128.4915771484375,
        280.0
      ],
      "bbox_max": [
        950.0,
        1190.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        910.0,
        1128.4915771484375,
        280.0
      ],
      "bbox_max": [
        950.0,
        1190.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8479983806610107,
        0.5299989581108093,
        0.0
      ],
      "plane_d": 140.97979736328125,
      "bbox_min": [
        874.6409912109375,
        1151.58544921875,
        140.0
      ],
      "bbox_max": [
        910.0,
        1232.4144287109375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        892.3572387695312,
        1151.58544921875,
        280.0
      ],
      "bbox_max": [
        910.0,
        1190.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.0,
      "bbox_min": [
        874.6409912109375,
        1212.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1232.4144287109375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1212.0,
      "bbox_min": [
        874.6409912109375,
        1212.0,
        320.0
      ],
      "bbox_max": [
        910.0,
        1212.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        885.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1161.771484375,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 885.0,
      "bbox_min": [
        885.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1161.771484375,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8479983806610107,
        0.5299989581108093,
        0.0
      ],
      "plane_d": 140.97979736328125,
      "bbox_min": [
        885.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1161.771484375,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -280.0,
      "bbox_min": [
        885.0,
        1120.0,
        280.0
      ],
      "bbox_max": [
        950.0,
        1161.771484375,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        780.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1680.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 149.99998474121094,
      "bbox_min": [
        780.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1680.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        780.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        950.0,
        1680.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        790.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        950.0,
        1664.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        790.0,
        1655.0,
        150.0
      ],
      "bbox_max": [
        805.0,
        1664.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1586.6666259765625,
        150.0
      ],
      "bbox_max": [
        950.0,
        1595.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        150.0
      ],
      "bbox_max": [
        790.0,
        1670.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 1230.3658447265625,
      "bbox_min": [
        780.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        799.9999389648438,
        1590.0,
        144.9999542236328
      ],
      "bbox_max": [
        948.0,
        1658.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1590.0,
        145.0
      ],
      "bbox_max": [
        948.0,
        1595.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        812.0000610351562,
        1590.0,
        145.0
      ],
      "bbox_max": [
        815.0,
        1595.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1655.0,
        140.0
      ],
      "bbox_max": [
        805.0,
        1670.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        780.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1595.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        140.0
      ],
      "bbox_max": [
        790.0,
        1590.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 1630.9515380859375,
      "bbox_min": [
        945.0,
        1586.6666259765625,
        140.0
      ],
      "bbox_max": [
        950.0,
        1595.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        790.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1580.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        800.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1580.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70710688829422,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 466.63031005859375,
      "bbox_min": [
        780.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1550.0,
        290.0852355957031
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        799.9147338867188,
        1280.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1550.0,
        290.0852355957031
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        820.0,
        1520.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1550.0,
        275.943115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1540.0,
        145.9430694580078
      ],
      "bbox_max": [
        820.0,
        1550.0,
        160.08518981933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        820.0,
        1520.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1540.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1550.0,
        145.9430694580078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        -0.9603399634361267,
        0.0
      ],
      "plane_d": 1215.2716064453125,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1541.28955078125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        854.056884765625,
        1310.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1520.0,
        275.943115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1472.83544921875,
        140.0
      ],
      "bbox_max": [
        929.0144653320312,
        1520.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1310.0,
        160.08518981933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 452.5483703613281,
      "bbox_min": [
        780.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        780.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1540.0,
        160.08518981933594
      ],
      "bbox_max": [
        820.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        820.0,
        1280.0,
        160.08518981933594
      ],
      "bbox_max": [
        820.0,
        1310.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        760.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        453.3333435058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        810.0,
        950.0,
        453.33331298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        570.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        760.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        140.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        760.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1010.0,
        867.8524780273438,
        80.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        867.8524780273438,
        98.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1029.7410888671875,
        867.8524780273438,
        98.0
      ],
      "bbox_max": [
        1235.0,
        900.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1047.9403076171875,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1215.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1215.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1215.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 713.8992309570312,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1140.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1140.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        900.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        760.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1049.56103515625,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        866.4380493164062,
        720.11572265625,
        98.77336120605469
      ],
      "bbox_max": [
        1049.56103515625,
        887.8524780273438,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        867.8525390625,
        118.0
      ],
      "bbox_max": [
        1049.56103515625,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1034.1600341796875,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1049.56103515625,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        867.8525390625,
        98.77336120605469
      ],
      "bbox_max": [
        1029.7412109375,
        867.8525390625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        760.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1034.1600341796875,
        900.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        760.0,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1034.1600341796875,
        900.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.7073715925216675,
        0.7068419456481934,
        0.0
      ],
      "plane_d": 83.90362548828125,
      "bbox_min": [
        780.0,
        735.8578491210938,
        118.0
      ],
      "bbox_max": [
        1034.1600341796875,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1034.1600341796875,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.381051242351532,
        0.9245539903640747,
        0.0
      ],
      "plane_d": -434.4053649902344,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1014.2000122070312,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        882.0472412109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        780.0,
        735.8578491210938,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1081.87353515625,
      "bbox_min": [
        780.0,
        735.8578491210938,
        118.0
      ],
      "bbox_max": [
        794.1421508789062,
        750.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1141.87353515625,
      "bbox_min": [
        836.568603515625,
        748.4000244140625,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        862.0322265625,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        882.0472412109375,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        780.0,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        825.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1132.5,
      "bbox_min": [
        1132.5,
        825.0,
        120.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1142.5,
      "bbox_min": [
        1142.5,
        825.0,
        135.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        780.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        930.0,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        760.0,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1200.0,
        900.0,
        570.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        555.5635375976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        766.0144653320312,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1132.5,
      "bbox_min": [
        1107.5,
        825.0,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        1132.5,
        825.0,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1142.5,
      "bbox_min": [
        1142.5,
        825.0,
        140.0
      ],
      "bbox_max": [
        1142.5,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        1107.5,
        825.0,
        145.0
      ],
      "bbox_max": [
        1117.5,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8201950788497925,
        -0.3988734185695648,
        0.41009753942489624
      ],
      "plane_d": 1128.7607421875,
      "bbox_min": [
        1039.16015625,
        825.0,
        170.0
      ],
      "bbox_max": [
        1120.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        867.8525390625,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9778024554252625,
        0.2095290869474411
      ],
      "plane_d": -975.0087280273438,
      "bbox_min": [
        810.0,
        867.8525390625,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        926.1367797851562,
        867.8525390625,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1075.0,
        1310.0,
        750.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1470.0,
        750.0
      ],
      "bbox_max": [
        1075.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1075.0,
        1310.0,
        750.0
      ],
      "bbox_max": [
        1075.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1135.85791015625,
        1068.85791015625,
        750.0
      ],
      "bbox_max": [
        1160.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -550.0,
        250.0,
        79.99999237060547
      ],
      "bbox_max": [
        760.0,
        1690.0,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        360.0,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        650.0,
        1690.0,
        550.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        360.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1690.0,
        550.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        360.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        340.0
      ],
      "face_count": 20
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        360.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1690.0,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        371.2994384765625,
        1495.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1690.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        425.0,
        1520.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1600.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        425.0,
        1600.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1600.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        380.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        440.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        380.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        440.0,
        1510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        360.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        360.0,
        1240.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        360.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        360.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        360.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        1390.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        360.0,
        1340.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1390.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1124.2998046875,
      "bbox_min": [
        360.0,
        1340.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1390.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        360.0,
        1340.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1390.0,
        200.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -185.0,
      "bbox_min": [
        360.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        360.0,
        1360.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        360.0,
        1380.0,
        185.0
      ],
      "bbox_max": [
        440.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        360.0,
        1390.0,
        190.0
      ],
      "bbox_max": [
        440.0,
        1390.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        360.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1425.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        360.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        400.0,
        1310.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        400.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1310.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        400.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        440.0,
        1310.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        440.0,
        1495.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        440.0,
        1600.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        440.0,
        1688.0108642578125,
        240.0
      ],
      "bbox_max": [
        450.0,
        1690.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        440.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        440.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        440.0,
        1510.0,
        140.0
      ],
      "bbox_max": [
        450.0,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        440.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1420.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5449883937835693,
        0.0,
        -0.8384436964988708
      ],
      "plane_d": -168.5271759033203,
      "bbox_min": [
        440.0,
        1310.0,
        85.0
      ],
      "bbox_max": [
        450.0,
        1415.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        440.0,
        1310.0,
        85.0
      ],
      "bbox_max": [
        450.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        440.0,
        1405.0,
        85.0
      ],
      "bbox_max": [
        450.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        440.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        440.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1240.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        440.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        450.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1090.0,
        100.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        450.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 520.0,
      "bbox_min": [
        450.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1690.0,
        550.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        510.5146179199219,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1346.4150390625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        510.5146179199219,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1346.4150390625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        530.4696044921875,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1331.971435546875,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -602.2073974609375,
      "bbox_min": [
        573.6023559570312,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1331.971435546875,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510567784309387,
        0.3090161681175232,
        0.0
      ],
      "plane_d": -942.6142578125,
      "bbox_min": [
        573.6023559570312,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510567784309387,
        -0.3090161681175232,
        0.0
      ],
      "plane_d": -148.44259643554688,
      "bbox_min": [
        573.6023559570312,
        1245.6285400390625,
        520.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877826809883118,
        0.8090188503265381,
        0.0
      ],
      "plane_d": -1361.7041015625,
      "bbox_min": [
        581.5086059570312,
        1245.6285400390625,
        520.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877826809883118,
        -0.8090188503265381,
        0.0
      ],
      "plane_d": 717.474365234375,
      "bbox_min": [
        581.5086059570312,
        1309.3330078125,
        520.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 627.7926025390625,
      "bbox_min": [
        602.2073974609375,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1331.971435546875,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5877838730812073,
        0.809018075466156,
        0.0
      ],
      "plane_d": -638.7296142578125,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1235.0,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        535.0
      ],
      "bbox_max": [
        650.0,
        1187.59912109375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        647.2877197265625,
        1185.6285400390625,
        535.0
      ],
      "bbox_max": [
        650.0,
        1187.59912109375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -631.7926025390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1235.0,
        535.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        631.7926025390625,
        1235.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        631.7926025390625,
        1185.6285400390625,
        535.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        627.7926025390625,
        1235.0,
        520.0
      ],
      "bbox_max": [
        631.7926025390625,
        1235.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        631.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1235.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 647.2877197265625,
      "bbox_min": [
        631.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1204.1727294921875,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8384436964988708,
        0.5449883937835693,
        0.0
      ],
      "plane_d": -111.27178955078125,
      "bbox_min": [
        647.2877197265625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1204.1727294921875,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        647.2877197265625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        650.0,
        1187.59912109375,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        631.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        647.2877197265625,
        1190.0,
        535.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        631.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        647.2877197265625,
        1190.0,
        535.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.6250033378601074,
        0.7806220650672913
      ],
      "plane_d": 335.09832763671875,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6250033378601074,
        -0.7806220650672913
      ],
      "plane_d": -331.975830078125,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 643.2876586914062,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -635.7925415039062,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        635.7926025390625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877838730812073,
        -0.809018075466156,
        -0.0
      ],
      "plane_d": 1440.44677734375,
      "bbox_min": [
        627.7926025390625,
        1260.6669921875,
        520.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056182384491,
        -0.3090183436870575,
        -0.0
      ],
      "plane_d": 1021.359619140625,
      "bbox_min": [
        648.4913330078125,
        1260.6669921875,
        520.0
      ],
      "bbox_max": [
        650.0,
        1309.3330078125,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056182384491,
        0.3090183436870575,
        0.0
      ],
      "plane_d": 227.1824951171875,
      "bbox_min": [
        648.4913330078125,
        1260.6669921875,
        520.0
      ],
      "bbox_max": [
        650.0,
        1265.3101806640625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        602.2073974609375,
        1225.0,
        520.0
      ],
      "bbox_max": [
        627.7926025390625,
        1331.971435546875,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1324.3714599609375,
      "bbox_min": [
        602.2073974609375,
        1324.3714599609375,
        520.0
      ],
      "bbox_max": [
        627.7926025390625,
        1331.971435546875,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -612.0,
      "bbox_min": [
        612.0,
        1324.3714599609375,
        530.0
      ],
      "bbox_max": [
        618.0,
        1331.971435546875,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 618.0,
      "bbox_min": [
        612.0,
        1324.3714599609375,
        530.0
      ],
      "bbox_max": [
        618.0,
        1331.971435546875,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1331.971435546875,
      "bbox_min": [
        612.0,
        1324.3714599609375,
        530.0
      ],
      "bbox_max": [
        618.0,
        1331.971435546875,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        612.0,
        1324.3714599609375,
        530.0
      ],
      "bbox_max": [
        618.0,
        1331.971435546875,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        612.0,
        1324.3714599609375,
        540.0
      ],
      "bbox_max": [
        618.0,
        1331.971435546875,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        450.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1690.0,
        520.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        450.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        640.0,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        450.0,
        1460.0,
        120.0
      ],
      "bbox_max": [
        640.0,
        1690.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        450.0,
        1500.0,
        120.0
      ],
      "bbox_max": [
        640.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        450.0,
        1500.0,
        120.0
      ],
      "bbox_max": [
        640.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1634.350341796875,
        120.0
      ],
      "bbox_max": [
        584.3502807617188,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        522.7098388671875,
        1634.350341796875,
        120.0
      ],
      "bbox_max": [
        584.3502807617188,
        1675.537109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        450.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        640.0,
        1690.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        584.3502807617188,
        1690.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        584.3502807617188,
        1675.537109375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        450.0,
        1495.0,
        140.0
      ],
      "bbox_max": [
        488.5288391113281,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        450.0,
        1495.0,
        150.0
      ],
      "bbox_max": [
        488.5288391113281,
        1510.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        584.3502807617188,
        1500.0,
        140.0
      ],
      "bbox_max": [
        640.0,
        1634.350341796875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        625.537109375,
        1500.0,
        140.0
      ],
      "bbox_max": [
        640.0,
        1572.7098388671875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314698338508606,
        -0.5555698871612549,
        0.0
      ],
      "plane_d": 1393.865478515625,
      "bbox_min": [
        450.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        640.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807853698730469,
        -0.1950903981924057,
        0.0
      ],
      "plane_d": 920.3382568359375,
      "bbox_min": [
        450.0,
        1500.0,
        80.0
      ],
      "bbox_max": [
        640.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        -0.9807853698730469,
        0.0
      ],
      "plane_d": 1745.3179931640625,
      "bbox_min": [
        450.0,
        1634.350341796875,
        80.0
      ],
      "bbox_max": [
        584.3502807617188,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555696487426758,
        -0.8314700126647949,
        0.0
      ],
      "plane_d": 1683.560546875,
      "bbox_min": [
        522.7098388671875,
        1634.350341796875,
        80.0
      ],
      "bbox_max": [
        584.3502807617188,
        1675.537109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        450.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1425.0,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        450.0,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        650.0,
        1425.0,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        505.25732421875,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        650.0,
        1352.5953369140625,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 627.7926025390625,
      "bbox_min": [
        573.6023559570312,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        520.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.5877838730812073,
        0.809018075466156,
        0.0
      ],
      "plane_d": -638.7296142578125,
      "bbox_min": [
        627.7926025390625,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        650.0,
        1225.0,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        96.81153869628906
      ],
      "bbox_max": [
        650.0,
        1225.0,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -501.5,
      "bbox_min": [
        627.7926025390625,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7999877929688,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        627.7926025390625,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7999877929688,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1222.0,
      "bbox_min": [
        627.7926025390625,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7999877929688,
        1222.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257304906845093,
        -0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": 472.9090270996094,
      "bbox_min": [
        647.2877197265625,
        1185.6285400390625,
        96.81153869628906
      ],
      "bbox_max": [
        650.0,
        1187.59912109375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1015.7371826171875,
      "bbox_min": [
        627.7926025390625,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        650.0,
        1185.6285400390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257304906845093,
        -0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": 472.9090270996094,
      "bbox_min": [
        647.2877197265625,
        1177.281005859375,
        83.30496978759766
      ],
      "bbox_max": [
        650.0,
        1185.6285400390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877838730812073,
        -0.809018075466156,
        -0.0
      ],
      "plane_d": 1440.44677734375,
      "bbox_min": [
        627.7926025390625,
        1260.6669921875,
        80.0
      ],
      "bbox_max": [
        650.0,
        1324.3714599609375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.951056182384491,
        -0.3090183436870575,
        -0.0
      ],
      "plane_d": 1021.359619140625,
      "bbox_min": [
        648.4913330078125,
        1260.6669921875,
        80.0
      ],
      "bbox_max": [
        650.0,
        1309.3330078125,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.951056182384491,
        0.3090183436870575,
        0.0
      ],
      "plane_d": 227.1824951171875,
      "bbox_min": [
        648.4913330078125,
        1260.6669921875,
        80.0
      ],
      "bbox_max": [
        650.0,
        1265.3101806640625,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -602.2073974609375,
      "bbox_min": [
        573.6023559570312,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.5877826809883118,
        0.8090188503265381,
        0.0
      ],
      "plane_d": -1361.7041015625,
      "bbox_min": [
        573.6023559570312,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1225.0,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -501.5,
      "bbox_min": [
        602.2000122070312,
        1222.0,
        500.0
      ],
      "bbox_max": [
        602.2073974609375,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        602.2000122070312,
        1222.0,
        500.0
      ],
      "bbox_max": [
        602.2073974609375,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1222.0,
      "bbox_min": [
        602.2000122070312,
        1222.0,
        500.0
      ],
      "bbox_max": [
        602.2073974609375,
        1222.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1015.737060546875,
      "bbox_min": [
        582.7122802734375,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510567784309387,
        0.3090161681175232,
        0.0
      ],
      "plane_d": -942.6142578125,
      "bbox_min": [
        573.6023559570312,
        1260.6669921875,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9510567784309387,
        -0.3090161681175232,
        0.0
      ],
      "plane_d": -148.44259643554688,
      "bbox_min": [
        573.6023559570312,
        1285.0,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5877826809883118,
        -0.8090188503265381,
        0.0
      ],
      "plane_d": 717.474365234375,
      "bbox_min": [
        581.5086059570312,
        1309.3330078125,
        80.0
      ],
      "bbox_max": [
        602.2073974609375,
        1324.3714599609375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1324.3714599609375,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        80.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 518.0,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        80.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 612.5,
      "bbox_min": [
        602.2073974609375,
        1225.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -617.5,
      "bbox_min": [
        612.5,
        1225.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        612.5,
        1225.0,
        518.0
      ],
      "bbox_max": [
        617.5,
        1314.3714599609375,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.3714599609375,
      "bbox_min": [
        612.5,
        1300.3714599609375,
        518.0
      ],
      "bbox_max": [
        617.5,
        1314.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1314.3714599609375,
      "bbox_min": [
        612.5,
        1314.3714599609375,
        518.0
      ],
      "bbox_max": [
        617.5,
        1314.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1230.0,
      "bbox_min": [
        617.5,
        1225.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        617.5,
        1225.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1225.0,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.3714599609375,
      "bbox_min": [
        617.5,
        1300.3714599609375,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        617.5,
        1314.3714599609375,
        518.0
      ],
      "bbox_max": [
        620.0,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1314.3714599609375,
      "bbox_min": [
        617.5,
        1314.3714599609375,
        518.0
      ],
      "bbox_max": [
        620.0,
        1314.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.3714599609375,
      "bbox_min": [
        602.2073974609375,
        1225.0,
        518.0
      ],
      "bbox_max": [
        612.5,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        610.0,
        1314.3714599609375,
        518.0
      ],
      "bbox_max": [
        612.5,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1314.3714599609375,
      "bbox_min": [
        610.0,
        1314.3714599609375,
        518.0
      ],
      "bbox_max": [
        612.5,
        1314.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        602.2073974609375,
        1225.0,
        518.0
      ],
      "bbox_max": [
        612.5,
        1225.0,
        520.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1225.0,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        80.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        518.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        602.2073974609375,
        1300.3714599609375,
        80.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.3714599609375,
      "bbox_min": [
        620.0,
        1300.3714599609375,
        80.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        620.0,
        1300.3714599609375,
        140.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        602.2073974609375,
        1300.3714599609375,
        80.0
      ],
      "bbox_max": [
        620.0,
        1324.3714599609375,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.3714599609375,
      "bbox_min": [
        602.2073974609375,
        1300.3714599609375,
        80.0
      ],
      "bbox_max": [
        610.0,
        1324.3714599609375,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        602.2073974609375,
        1300.3714599609375,
        140.0
      ],
      "bbox_max": [
        610.0,
        1324.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1314.3714599609375,
      "bbox_min": [
        610.0,
        1300.3714599609375,
        90.0
      ],
      "bbox_max": [
        620.0,
        1314.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.3714599609375,
      "bbox_min": [
        610.0,
        1300.3714599609375,
        90.0
      ],
      "bbox_max": [
        620.0,
        1314.3714599609375,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        610.0,
        1300.3714599609375,
        90.0
      ],
      "bbox_max": [
        620.0,
        1314.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        610.0,
        1300.3714599609375,
        90.0
      ],
      "bbox_max": [
        620.0,
        1314.3714599609375,
        90.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -501.5,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7926025390625,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7926025390625,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1222.0,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7926025390625,
        1222.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38275146484375,
      "bbox_min": [
        505.25732421875,
        1285.0,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1352.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        450.0,
        1223.5849609375,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1425.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        450.0,
        1223.5849609375,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1425.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        450.0,
        1274.7840576171875,
        91.5
      ],
      "bbox_max": [
        460.0,
        1425.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5449883937835693,
        0.0,
        -0.8384436964988708
      ],
      "plane_d": -168.5271759033203,
      "bbox_min": [
        450.0,
        1310.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1415.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        450.0,
        1310.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        450.0,
        1405.0,
        91.5
      ],
      "bbox_max": [
        460.0,
        1405.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506508469581604,
        -0.27639344334602356,
        0.44721344113349915
      ],
      "plane_d": 744.7139282226562,
      "bbox_min": [
        500.0,
        1223.5849609375,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38275146484375,
      "bbox_min": [
        500.0,
        1285.0,
        80.0
      ],
      "bbox_max": [
        510.5146179199219,
        1301.1802978515625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        450.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1282.04931640625,
        330.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        450.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        1282.04931640625,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        450.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        450.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        450.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        450.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        650.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        450.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        650.0,
        1000.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        450.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        650.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        450.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        596.4761352539062,
        1282.04931640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        450.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1130.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        450.0,
        1110.0,
        98.0
      ],
      "bbox_max": [
        453.0,
        1130.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5257307887077332,
        -0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": 1119.5582275390625,
      "bbox_min": [
        529.0932006835938,
        1184.6285400390625,
        98.0
      ],
      "bbox_max": [
        584.0886840820312,
        1224.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1015.737060546875,
      "bbox_min": [
        529.0932006835938,
        1184.6285400390625,
        98.0
      ],
      "bbox_max": [
        584.0886840820312,
        1224.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506508469581604,
        -0.27639344334602356,
        0.44721344113349915
      ],
      "plane_d": 744.7139282226562,
      "bbox_min": [
        529.0932006835938,
        1222.9669189453125,
        98.0
      ],
      "bbox_max": [
        530.4696044921875,
        1224.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257307887077332,
        -0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": 1119.5582275390625,
      "bbox_min": [
        450.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        596.4761352539062,
        1233.5849609375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1015.737060546875,
      "bbox_min": [
        516.7057495117188,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        596.4761352539062,
        1233.5849609375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506508469581604,
        -0.27639344334602356,
        0.44721344113349915
      ],
      "plane_d": 744.7139282226562,
      "bbox_min": [
        516.7057495117188,
        1217.4046630859375,
        80.0
      ],
      "bbox_max": [
        529.6189575195312,
        1233.5849609375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 331.15606689453125,
      "bbox_min": [
        450.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -332.8201599121094,
      "bbox_min": [
        450.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        450.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 166.4100799560547,
      "bbox_min": [
        450.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        450.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        450.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        483.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        483.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        483.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        480.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        480.0,
        1110.0,
        118.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        450.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        450.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        450.0,
        1240.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        360.0,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        360.0,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        360.0,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0002752529107965529,
        -0.0
      ],
      "plane_d": -550.2064208984375,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        650.0,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6504541039466858,
        -0.759545624256134,
        0.0
      ],
      "plane_d": 302.9510498046875,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        260.0
      ],
      "bbox_max": [
        550.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7121667861938477,
        0.7020103335380554,
        -0.0
      ],
      "plane_d": -953.280517578125,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        260.0
      ],
      "bbox_max": [
        550.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -259.9999694824219,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        260.0
      ],
      "bbox_max": [
        550.0,
        799.9862060546875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        512.6419067382812,
        799.9862060546875,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        549.9669799804688,
        750.0,
        240.0
      ],
      "bbox_max": [
        650.0,
        869.8349609375,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        549.9669799804688,
        769.8019409179688,
        80.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        600.1320190429688,
        920.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -550.0,
        750.0,
        79.99999237060547
      ],
      "bbox_max": [
        360.0,
        1500.0,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        310.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1460.0,
        340.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        310.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1415.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        310.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1415.0,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        310.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        310.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1415.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        310.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        360.0,
        1390.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        310.0,
        1340.0,
        185.0
      ],
      "bbox_max": [
        360.0,
        1390.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1124.2998046875,
      "bbox_min": [
        310.0,
        1340.0,
        185.0
      ],
      "bbox_max": [
        360.0,
        1390.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        330.0,
        1340.0,
        185.0
      ],
      "bbox_max": [
        360.0,
        1390.0,
        200.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -185.0,
      "bbox_min": [
        330.0,
        1350.0,
        185.0
      ],
      "bbox_max": [
        360.0,
        1380.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        330.0,
        1360.0,
        185.0
      ],
      "bbox_max": [
        360.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        330.0,
        1380.0,
        185.0
      ],
      "bbox_max": [
        360.0,
        1380.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        350.0,
        1390.0,
        190.0
      ],
      "bbox_max": [
        360.0,
        1390.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -550.0,
        750.0,
        79.99999237060547
      ],
      "bbox_max": [
        310.0,
        1500.0,
        540.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -100.0,
        750.0,
        79.99999237060547
      ],
      "bbox_max": [
        310.0,
        1500.0,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -100.0,
        750.0,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1500.0,
        420.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -100.0,
        750.0,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1490.0,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -100.0,
        830.0,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1430.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        830.0,
        80.0
      ],
      "bbox_max": [
        -50.0,
        1413.666748046875,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -100.0,
        830.0,
        80.0
      ],
      "bbox_max": [
        -50.0,
        830.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -100.0,
        1413.3333740234375,
        80.0
      ],
      "bbox_max": [
        -66.33332824707031,
        1413.666748046875,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        -50.0,
        860.0,
        79.99999237060547
      ],
      "bbox_max": [
        260.0,
        1310.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -50.0,
        860.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1310.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1310.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        97.5,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1270.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        79.99999237060547
      ],
      "bbox_max": [
        120.0,
        1250.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0858488604426384,
        0.03555978462100029,
        0.9956733584403992
      ],
      "plane_d": -107.93418884277344,
      "bbox_min": [
        -50.0,
        860.0,
        80.0
      ],
      "bbox_max": [
        -28.569726943969727,
        875.3493041992188,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        82.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -126.0,
      "bbox_min": [
        -100.0,
        750.0,
        82.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        -100.0,
        750.0,
        82.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        126.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        260.0,
        1430.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -50.0,
        1417.3333740234375,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -100.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        -50.0,
        830.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -100.0,
        1413.666748046875,
        82.0
      ],
      "bbox_max": [
        -62.666664123535156,
        1417.3333740234375,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1310.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        1240.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1310.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        97.5,
        1240.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1240.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1270.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15402749180793762,
        -0.06380031257867813,
        0.9860045313835144
      ],
      "plane_d": -35.5994873046875,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509023427963257,
        0.9807853102684021,
        -5.211193609966358e-08
      ],
      "plane_d": -853.2298583984375,
      "bbox_min": [
        -50.0,
        860.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555700659751892,
        0.0
      ],
      "plane_d": 489.2572021484375,
      "bbox_min": [
        35.2203254699707,
        933.3508911132812,
        102.0
      ],
      "bbox_max": [
        51.626747131347656,
        957.9048461914062,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        82.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        82.0
      ],
      "bbox_max": [
        70.2081527709961,
        945.1792602539062,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14221441745758057,
        -0.14221446216106415,
        0.9795662760734558
      ],
      "plane_d": 33.228851318359375,
      "bbox_min": [
        3.5756804943084717,
        870.6568603515625,
        93.0
      ],
      "bbox_max": [
        70.2081527709961,
        945.1792602539062,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314697742462158,
        -0.5555700659751892,
        0.0
      ],
      "plane_d": 489.2572021484375,
      "bbox_min": [
        27.78174591064453,
        922.21826171875,
        102.0
      ],
      "bbox_max": [
        43.123802185058594,
        945.1792602539062,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -100.0,
        750.0,
        104.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -100.0,
        770.0,
        104.0
      ],
      "bbox_max": [
        -50.0,
        1430.0,
        126.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        830.0,
        104.0
      ],
      "bbox_max": [
        -50.0,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -100.0,
        830.0,
        104.0
      ],
      "bbox_max": [
        -50.0,
        830.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -100.0,
        1417.3333740234375,
        104.0
      ],
      "bbox_max": [
        -60.0,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -100.0,
        770.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        1050.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        1050.0,
        120.0
      ],
      "bbox_max": [
        -50.0,
        1050.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        -50.0,
        750.0,
        104.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -50.0,
        750.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1316.54541015625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        1265.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1316.54541015625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1316.54541015625,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        -50.0,
        750.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        104.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0694173201918602,
        -0.16758783161640167,
        0.9834102392196655
      ],
      "plane_d": 52.008216857910156,
      "bbox_min": [
        79.34313201904297,
        934.9437866210938,
        114.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        119.21685028076172
      ],
      "bbox_max": [
        97.20521545410156,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.21856677532196045,
        0.9758220314979553
      ],
      "plane_d": 95.61320495605469,
      "bbox_min": [
        79.34313201904297,
        946.42431640625,
        114.0
      ],
      "bbox_max": [
        99.67156219482422,
        973.212158203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.21856677532196045,
        0.9758220314979553
      ],
      "plane_d": 95.61320495605469,
      "bbox_min": [
        79.34313201904297,
        946.42431640625,
        114.0
      ],
      "bbox_max": [
        98.67143249511719,
        973.212158203125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        105.11277770996094,
        750.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        753.2655639648438,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.21856677532196045,
        0.9758220314979553
      ],
      "plane_d": 95.61320495605469,
      "bbox_min": [
        84.67156982421875,
        968.9339599609375,
        120.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        90.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        110.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0694173201918602,
        -0.16758783161640167,
        0.9834102392196655
      ],
      "plane_d": 52.008216857910156,
      "bbox_min": [
        99.67156219482422,
        968.9339599609375,
        120.0
      ],
      "bbox_max": [
        110.0,
        986.8224487304688,
        123.04846954345703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        110.0,
        753.2655639648438,
        104.0
      ],
      "bbox_max": [
        260.0,
        1265.0,
        126.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        110.0,
        753.2655639648438,
        104.0
      ],
      "bbox_max": [
        161.99351501464844,
        1265.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        949.7266235351562,
        104.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0694173201918602,
        -0.16758783161640167,
        0.9834102392196655
      ],
      "plane_d": 52.008216857910156,
      "bbox_min": [
        110.0,
        949.7266235351562,
        104.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        104.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        104.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        110.0,
        753.2655639648438,
        120.0
      ],
      "bbox_max": [
        161.99351501464844,
        1265.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        110.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        120.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        120.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.21856677532196045,
        0.9758220314979553
      ],
      "plane_d": 95.61320495605469,
      "bbox_min": [
        110.0,
        986.8224487304688,
        123.04846954345703
      ],
      "bbox_max": [
        120.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        110.0,
        1000.0,
        125.29412078857422
      ],
      "bbox_max": [
        120.0,
        1000.0,
        126.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        -100.0,
        750.0,
        126.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -100.0,
        750.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        1320.9090576171875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        770.0,
        126.0
      ],
      "bbox_max": [
        -50.0,
        1050.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -100.0,
        770.0,
        126.0
      ],
      "bbox_max": [
        -50.0,
        770.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -50.0,
        750.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        1320.9090576171875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1265.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        1320.9090576171875,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        750.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        842.9404907226562,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        105.11277770996094,
        750.0,
        126.0
      ],
      "bbox_max": [
        110.0,
        753.2655639648438,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        110.0,
        753.2655639648438,
        126.0
      ],
      "bbox_max": [
        260.0,
        1265.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        110.0,
        753.2655639648438,
        126.0
      ],
      "bbox_max": [
        161.99351501464844,
        1265.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1240.0,
        126.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        110.0,
        1240.0,
        126.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        126.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        -100.0,
        750.0,
        130.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -100.0,
        750.0,
        130.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -100.0,
        750.0,
        130.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -139.99998474121094,
      "bbox_min": [
        -50.0,
        750.0,
        130.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        -50.0,
        750.0,
        130.0
      ],
      "bbox_max": [
        254.03262329101562,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        -50.0,
        750.0,
        130.0
      ],
      "bbox_max": [
        161.99351501464844,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509048759937286,
        0.9807852506637573,
        0.0
      ],
      "plane_d": -823.8062744140625,
      "bbox_min": [
        -50.0,
        830.0,
        130.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -50.0,
        830.0,
        140.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        107.05952453613281,
        934.9437866210938,
        140.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        -100.0,
        750.0,
        155.0
      ],
      "bbox_max": [
        246.4127197265625,
        970.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1889248639345169,
        0.9819916486740112,
        0.0
      ],
      "plane_d": -834.130615234375,
      "bbox_min": [
        -100.0,
        839.8079223632812,
        155.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.220703097715159e-06,
        1.0,
        -0.0
      ],
      "plane_d": -839.807861328125,
      "bbox_min": [
        -100.0,
        839.8079223632812,
        155.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        107.05952453613281,
        934.9437866210938,
        155.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        -100.0,
        830.0,
        160.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        175.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.1889248639345169,
        0.9819916486740112,
        0.0
      ],
      "plane_d": -834.130615234375,
      "bbox_min": [
        -100.0,
        839.8079223632812,
        160.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.220703097715159e-06,
        1.0,
        -0.0
      ],
      "plane_d": -839.807861328125,
      "bbox_min": [
        -100.0,
        839.8079223632812,
        160.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        107.05952453613281,
        934.9437866210938,
        160.0
      ],
      "bbox_max": [
        114.03263092041016,
        970.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -155.0,
      "bbox_min": [
        -100.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        -100.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        -100.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        110.0,
        1348.1817626953125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1265.0,
        130.0
      ],
      "bbox_max": [
        110.0,
        1348.1817626953125,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        130.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -100.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -100.0,
        1050.0,
        130.0
      ],
      "bbox_max": [
        -50.0,
        1050.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -50.0,
        1050.0,
        144.0
      ],
      "bbox_max": [
        0.0,
        1050.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        110.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        260.0,
        1265.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1240.0,
        130.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        110.0,
        1240.0,
        130.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        120.0,
        1240.0,
        130.0
      ],
      "bbox_max": [
        120.0,
        1250.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        254.03262329101562,
        970.0,
        130.0
      ],
      "bbox_max": [
        260.0,
        1000.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        0.0,
        970.0,
        155.0
      ],
      "bbox_max": [
        260.0,
        1490.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -175.0,
      "bbox_min": [
        0.0,
        970.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        230.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        0.0,
        970.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        0.0,
        1240.0,
        155.0
      ],
      "bbox_max": [
        110.0,
        1370.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        155.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        110.0,
        970.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1240.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        110.0,
        1240.0,
        155.0
      ],
      "bbox_max": [
        120.0,
        1240.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6757246255874634,
        0.7371541261672974
      ],
      "plane_d": 796.7407836914062,
      "bbox_min": [
        10.0,
        1370.0,
        175.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        10.0,
        1370.0,
        175.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        10.0,
        1430.0,
        230.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        210.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        210.0,
        1240.0,
        190.0
      ],
      "bbox_max": [
        260.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        260.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1460.0,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -970.0,
      "bbox_min": [
        260.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1415.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        970.0,
        112.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -340.0,
      "bbox_min": [
        260.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1415.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        260.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1415.0,
        340.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        260.0,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        260.0,
        970.0,
        109.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        970.0,
        112.5
      ],
      "bbox_max": [
        300.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        300.0,
        970.0,
        112.5
      ],
      "bbox_max": [
        310.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        270.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1415.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        270.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        1310.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -550.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1430.0,
        540.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        -550.0,
        830.0,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        0.16439898312091827
      ],
      "plane_d": 1380.9515380859375,
      "bbox_min": [
        -550.0,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1430.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        -350.0,
        1413.3333740234375,
        80.0
      ],
      "bbox_max": [
        -350.0,
        1430.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9863939881324768,
        -0.0,
        0.16439899802207947
      ],
      "plane_d": 512.9248657226562,
      "bbox_min": [
        -550.0,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        -550.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        -533.3333129882812,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -340.0,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1240.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -340.0,
        1210.4000244140625,
        80.0
      ],
      "bbox_max": [
        -340.0,
        1240.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 1077.953857421875,
      "bbox_min": [
        -309.5,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1240.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -300.0,
        1175.720458984375,
        80.0
      ],
      "bbox_max": [
        -119.5,
        1240.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -300.0,
        1230.0,
        80.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 162.27667236328125,
      "bbox_min": [
        -309.5,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1175.720458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -309.5,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1175.720458984375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6123727560043335,
        0.35355329513549805,
        0.7071065902709961
      ],
      "plane_d": -222.87403869628906,
      "bbox_min": [
        -309.5,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123724579811096,
        -0.3535531163215637,
        0.7071068286895752
      ],
      "plane_d": 421.4258117675781,
      "bbox_min": [
        -289.5,
        850.55029296875,
        80.0
      ],
      "bbox_max": [
        -254.49293518066406,
        911.17822265625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903998374939,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        1051.7982177734375,
        80.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -309.5,
        1051.7982177734375,
        80.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5862517952919006,
        -0.3953181803226471,
        0.7071297764778137
      ],
      "plane_d": 540.6658935546875,
      "bbox_min": [
        -309.5,
        1051.7982177734375,
        80.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1050.0,
        80.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999999701976776,
        -0.8660255074501038,
        0.0
      ],
      "plane_d": 1077.953857421875,
      "bbox_min": [
        -450.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1240.0,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999999701976776,
        0.8660255074501038,
        0.0
      ],
      "plane_d": -783.4539794921875,
      "bbox_min": [
        -434.5,
        1051.800048828125,
        120.0
      ],
      "bbox_max": [
        -119.5,
        1240.0,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -355.21795654296875,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -294.49993896484375,
        1101.0794677734375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -434.5,
        1074.6842041015625,
        120.0
      ],
      "bbox_max": [
        -119.5,
        1240.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660245537757874,
        -0.5000016093254089,
        0.0
      ],
      "plane_d": 925.1785888671875,
      "bbox_min": [
        -409.5,
        1141.0794677734375,
        130.0
      ],
      "bbox_max": [
        -399.5,
        1158.39990234375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -355.0,
        1074.6842041015625,
        120.0
      ],
      "bbox_max": [
        -119.5,
        1240.0,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -340.21795654296875,
        1074.6842041015625,
        250.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1101.0794677734375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        -355.0,
        1210.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -355.0,
        1210.4000244140625,
        125.0
      ],
      "bbox_max": [
        -340.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        -310.0,
        1210.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -300.0,
        1210.4000244140625,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -300.0,
        1230.0,
        120.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -450.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1175.720458984375,
        540.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -450.0,
        770.0,
        120.0
      ],
      "bbox_max": [
        -309.5,
        770.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -334.136474609375,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -309.5,
        1066.02392578125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252094268799,
        -0.5000004768371582,
        0.0
      ],
      "plane_d": 674.0302734375,
      "bbox_min": [
        -309.5,
        750.0,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1175.720458984375,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660256266593933,
        -0.4999997317790985,
        0.0
      ],
      "plane_d": 675.9923706054688,
      "bbox_min": [
        -309.5,
        850.556396484375,
        120.0
      ],
      "bbox_max": [
        -109.5,
        1175.720458984375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -235.18533325195312,
      "bbox_min": [
        -309.5,
        911.17822265625,
        120.0
      ],
      "bbox_max": [
        -110.63330841064453,
        1175.720458984375,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.00611877441406
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        205.0
      ],
      "bbox_max": [
        -289.4999694824219,
        984.4795532226562,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        210.0
      ],
      "bbox_max": [
        -289.4999694824219,
        974.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -289.4999694824219,
        1006.4411010742188,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.0
      ],
      "bbox_max": [
        -110.63330841064453,
        1175.720458984375,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8289904594421387,
        -0.5592629313468933,
        0.0
      ],
      "plane_d": 844.8052978515625,
      "bbox_min": [
        -309.5,
        971.800048828125,
        120.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        500.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -249.99998474121094,
      "bbox_min": [
        -309.5,
        1051.800048828125,
        250.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -296.82049560546875,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -202.5,
      "bbox_min": [
        -296.82049560546875,
        971.800048828125,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        -0.0
      ],
      "plane_d": -363.12939453125,
      "bbox_min": [
        -224.5,
        1045.8167724609375,
        200.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        202.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        -0.0
      ],
      "plane_d": -363.12939453125,
      "bbox_min": [
        -296.82049560546875,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -971.800048828125,
      "bbox_min": [
        -296.82049560546875,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -229.5,
        991.800048828125,
        225.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -210.0,
      "bbox_min": [
        -296.82049560546875,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -229.5,
        991.800048828125,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -205.0,
      "bbox_min": [
        -296.82049560546875,
        971.800048828125,
        202.5
      ],
      "bbox_max": [
        -229.5,
        991.800048828125,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -991.800048828125,
      "bbox_min": [
        -289.5,
        991.800048828125,
        202.5
      ],
      "bbox_max": [
        -240.74679565429688,
        991.800048828125,
        205.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660241961479187,
        0.5000022649765015,
        0.0
      ],
      "plane_d": -363.1294250488281,
      "bbox_min": [
        -224.5,
        1045.8167724609375,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -484.369873046875,
      "bbox_min": [
        -110.63330841064453,
        1158.39990234375,
        120.0
      ],
      "bbox_max": [
        -109.5,
        1160.36279296875,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -309.5,
        750.0,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        -309.5,
        750.0,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -309.5,
        770.0,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1050.0,
        120.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        -160.0,
        1050.0,
        130.0
      ],
      "bbox_max": [
        -100.0,
        1050.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -160.0,
        830.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        -160.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -160.0,
        920.0,
        230.0
      ],
      "bbox_max": [
        -150.0,
        920.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        -150.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        -150.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 110.0,
      "bbox_min": [
        -150.0,
        1000.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        -150.0,
        1040.0,
        230.0
      ],
      "bbox_max": [
        -110.0,
        1040.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        -150.0,
        840.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -110.0,
        920.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        -150.0,
        840.0,
        240.0
      ],
      "bbox_max": [
        -100.0,
        920.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        -110.0,
        920.0,
        240.0
      ],
      "bbox_max": [
        -100.0,
        920.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        360.0,
        490.0000305175781,
        100.0
      ],
      "bbox_max": [
        550.0,
        750.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        360.0,
        490.0000305175781,
        100.0
      ],
      "bbox_max": [
        550.0,
        750.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        360.0,
        490.0000305175781,
        220.0
      ],
      "bbox_max": [
        380.0,
        510.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        410.0107116699219,
        749.9893188476562,
        460.0
      ],
      "bbox_max": [
        410.03387451171875,
        750.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -500.0,
        346.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        750.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        -500.0,
        420.0,
        120.0
      ],
      "bbox_max": [
        290.0,
        750.0,
        420.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -500.0,
        420.0,
        120.0
      ],
      "bbox_max": [
        290.0,
        700.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        0.9807853698730469,
        0.0
      ],
      "plane_d": -686.4963989257812,
      "bbox_min": [
        -50.0,
        690.0,
        120.0
      ],
      "bbox_max": [
        0.27338409423828125,
        700.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        -200.0,
        420.0,
        140.0
      ],
      "bbox_max": [
        290.0,
        700.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        290.0,
        420.0,
        140.0
      ],
      "bbox_max": [
        290.0,
        440.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        -200.0,
        650.0,
        140.0
      ],
      "bbox_max": [
        254.0325927734375,
        700.0,
        420.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -200.0,
        690.0,
        140.0
      ],
      "bbox_max": [
        0.27338409423828125,
        700.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        0.9807853698730469,
        0.0
      ],
      "plane_d": -686.4963989257812,
      "bbox_min": [
        -50.0,
        690.0,
        140.0
      ],
      "bbox_max": [
        0.27338409423828125,
        700.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        -200.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        254.0325927734375,
        700.0,
        420.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -200.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        -50.0,
        690.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        160.0
      ],
      "bbox_max": [
        -100.0,
        690.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -690.0,
      "bbox_min": [
        -200.0,
        650.0,
        230.0
      ],
      "bbox_max": [
        -50.0,
        690.0,
        420.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -100.0,
        650.0,
        230.0
      ],
      "bbox_max": [
        -100.0,
        690.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19670066237449646,
        0.9804636240005493,
        0.0
      ],
      "plane_d": -696.1595458984375,
      "bbox_min": [
        -50.0,
        700.0,
        120.0
      ],
      "bbox_max": [
        254.03260803222656,
        750.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        -50.0,
        700.0,
        120.0
      ],
      "bbox_max": [
        254.03260803222656,
        750.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1950903981924057,
        0.9807853698730469,
        0.0
      ],
      "plane_d": -686.4963989257812,
      "bbox_min": [
        0.27338409423828125,
        700.0,
        140.0
      ],
      "bbox_max": [
        68.63186645507812,
        713.5973510742188,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -230.0,
      "bbox_min": [
        0.27338409423828125,
        700.0,
        230.0
      ],
      "bbox_max": [
        254.03260803222656,
        750.0,
        230.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5555700063705444,
        0.8314698338508606,
        0.0
      ],
      "plane_d": -565.204833984375,
      "bbox_min": [
        64.73006439208984,
        723.0171508789062,
        120.0
      ],
      "bbox_max": [
        199.22744750976562,
        750.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        64.73006439208984,
        723.0171508789062,
        140.0
      ],
      "bbox_max": [
        199.22744750976562,
        750.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -159.99998474121094,
      "bbox_min": [
        189.17669677734375,
        748.2157592773438,
        160.0
      ],
      "bbox_max": [
        199.22744750976562,
        750.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -229.99998474121094,
      "bbox_min": [
        189.17669677734375,
        748.2157592773438,
        230.0
      ],
      "bbox_max": [
        199.22744750976562,
        750.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        216.0,
        250.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        680.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        310.0,
        250.0,
        80.0
      ],
      "bbox_max": [
        650.0,
        680.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        310.0,
        250.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        620.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565996170044,
        -0.3090168535709381,
        0.0
      ],
      "plane_d": -256.32647705078125,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        550.0,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565996170044,
        0.3090168535709381,
        -0.0
      ],
      "plane_d": -503.5399475097656,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        550.0,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        455.2785949707031,
        481.1797790527344,
        80.0
      ],
      "bbox_max": [
        550.0,
        510.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        455.2785949707031,
        481.1797790527344,
        80.0
      ],
      "bbox_max": [
        514.7213745117188,
        500.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.27862548828125,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        95.5
      ],
      "bbox_max": [
        455.27862548828125,
        500.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.27862548828125,
      "bbox_min": [
        455.2785949707031,
        481.1797790527344,
        80.0
      ],
      "bbox_max": [
        465.2785949707031,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -486.5,
      "bbox_min": [
        455.2785949707031,
        486.5,
        87.5
      ],
      "bbox_max": [
        458.4035949707031,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        455.2785949707031,
        481.1798095703125,
        85.0
      ],
      "bbox_max": [
        460.0,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -486.5,
      "bbox_min": [
        455.2785949707031,
        486.5,
        85.0
      ],
      "bbox_max": [
        460.0,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        455.27862548828125,
        500.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.27862548828125,
      "bbox_min": [
        455.27862548828125,
        500.0,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        550.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        620.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        620.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        290.0,
        250.0,
        99.99999237060547
      ],
      "bbox_max": [
        625.0,
        680.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        290.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        290.0,
        420.0,
        381.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        360.0,
        266.0564880371094,
        99.99999237060547
      ],
      "bbox_max": [
        625.0,
        680.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        399.4853820800781,
        290.714111328125,
        99.99999237060547
      ],
      "bbox_max": [
        625.0,
        680.0,
        220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        99.99999237060547
      ],
      "bbox_max": [
        620.0,
        680.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.27862548828125,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        99.99999237060547
      ],
      "bbox_max": [
        620.0,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565996170044,
        0.3090168535709381,
        -0.0
      ],
      "plane_d": -503.5399475097656,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        100.0
      ],
      "bbox_max": [
        416.7721252441406,
        400.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        120.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        524.7213745117188,
        485.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        524.7213745117188,
        485.0,
        120.0
      ],
      "bbox_max": [
        559.7213745117188,
        485.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        524.7213745117188,
        485.0,
        130.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -19.15392303466797,
      "bbox_min": [
        524.7213745117188,
        485.0,
        130.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        559.7213745117188,
        485.0,
        140.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        559.7213745117188,
        485.0,
        140.0
      ],
      "bbox_max": [
        559.7213745117188,
        500.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        559.7213745117188,
        495.0,
        130.0
      ],
      "bbox_max": [
        559.7213745117188,
        500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        455.27862548828125,
        500.0,
        100.0
      ],
      "bbox_max": [
        620.0,
        680.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.27862548828125,
      "bbox_min": [
        455.27862548828125,
        500.0,
        100.0
      ],
      "bbox_max": [
        550.0,
        510.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        455.27862548828125,
        500.0,
        100.0
      ],
      "bbox_max": [
        550.0,
        510.0,
        220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.27862548828125,
        500.0,
        215.0
      ],
      "bbox_max": [
        524.7213745117188,
        510.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        550.0,
        500.0,
        100.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        559.7213745117188,
        500.0,
        130.0
      ],
      "bbox_max": [
        580.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -133.5,
      "bbox_min": [
        565.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        580.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        565.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        565.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -156.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.0,
      "bbox_min": [
        620.0,
        495.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        449.9999694824219,
        580.0,
        220.0
      ],
      "bbox_max": [
        550.0,
        680.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        550.0,
        580.0,
        220.0
      ],
      "bbox_max": [
        550.0,
        680.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        650.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        760.0,
        1690.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        650.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        760.0,
        1690.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 520.0,
      "bbox_min": [
        650.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1670.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        650.0,
        1187.59912109375,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1346.4150390625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        650.0,
        1187.59912109375,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1304.6898193359375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        650.0,
        1187.59912109375,
        520.0
      ],
      "bbox_max": [
        699.5303955078125,
        1304.6898193359375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056182384491,
        0.3090183436870575,
        0.0
      ],
      "plane_d": 227.1824951171875,
      "bbox_min": [
        650.0,
        1204.1727294921875,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1304.6898193359375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        650.0,
        1204.1727294921875,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1235.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8384436964988708,
        0.5449883937835693,
        0.0
      ],
      "plane_d": -111.27178955078125,
      "bbox_min": [
        650.0,
        1204.1727294921875,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1235.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.2877197265625,
      "bbox_min": [
        650.0,
        1220.0,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1235.0,
        535.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        650.0,
        1226.0,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1235.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1226.0,
      "bbox_min": [
        657.341796875,
        1226.0,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1229.0,
        525.2528686523438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1229.0,
      "bbox_min": [
        657.341796875,
        1226.0,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1229.0,
        525.2528686523438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6581774950027466,
        0.0,
        0.7528628706932068
      ],
      "plane_d": 38.70989990234375,
      "bbox_min": [
        657.341796875,
        1226.0,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1229.0,
        525.2528686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 658.0,
      "bbox_min": [
        657.341796875,
        1226.0,
        520.0
      ],
      "bbox_max": [
        660.2877197265625,
        1229.0,
        525.2528686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7528525590896606,
        -0.0,
        0.6581891179084778
      ],
      "plane_d": -842.3194580078125,
      "bbox_min": [
        659.6295166015625,
        1226.0,
        524.5
      ],
      "bbox_max": [
        660.2877197265625,
        1229.0,
        525.2528686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7528525590896606,
        -0.0,
        -0.6581891179084778
      ],
      "plane_d": 839.28076171875,
      "bbox_min": [
        657.341796875,
        1226.0,
        522.5
      ],
      "bbox_max": [
        658.0,
        1229.0,
        523.2528686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056182384491,
        -0.3090183436870575,
        -0.0
      ],
      "plane_d": 1021.359619140625,
      "bbox_min": [
        650.0,
        1285.0,
        520.0
      ],
      "bbox_max": [
        656.3976440429688,
        1304.6898193359375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        650.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1670.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        685.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        650.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1352.5953369140625,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        650.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1304.6898193359375,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        650.0,
        1071.1461181640625,
        80.0
      ],
      "bbox_max": [
        699.5303955078125,
        1304.6898193359375,
        520.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.951056182384491,
        -0.3090183436870575,
        -0.0
      ],
      "plane_d": 1021.359619140625,
      "bbox_min": [
        650.0,
        1265.3101806640625,
        80.0
      ],
      "bbox_max": [
        656.3976440429688,
        1304.6898193359375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.951056182384491,
        0.3090183436870575,
        0.0
      ],
      "plane_d": 227.1824951171875,
      "bbox_min": [
        650.0,
        1265.3101806640625,
        80.0
      ],
      "bbox_max": [
        656.3976440429688,
        1285.0,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.5257304906845093,
        -0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": 472.9090270996094,
      "bbox_min": [
        650.0,
        1071.1461181640625,
        80.0
      ],
      "bbox_max": [
        699.5303955078125,
        1223.5849609375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1015.7371826171875,
      "bbox_min": [
        650.0,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        650.5369262695312,
        1177.281005859375,
        83.30496978759766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        650.0,
        1071.1461181640625,
        80.0
      ],
      "bbox_max": [
        662.6243896484375,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        650.0,
        1071.1461181640625,
        120.0
      ],
      "bbox_max": [
        662.6243896484375,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        650.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        662.6243896484375,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        650.0,
        1090.0,
        160.0
      ],
      "bbox_max": [
        662.6243896484375,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        650.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1285.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        650.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1285.0,
        190.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        662.6243896484375,
        1110.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1285.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506506085395813,
        -0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": -301.5865478515625,
      "bbox_min": [
        694.2730712890625,
        1207.4046630859375,
        80.0
      ],
      "bbox_max": [
        720.0,
        1285.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257304906845093,
        -0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": 472.9090270996094,
      "bbox_min": [
        694.2730712890625,
        1207.4046630859375,
        80.0
      ],
      "bbox_max": [
        708.0369262695312,
        1223.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        650.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        662.6243896484375,
        1110.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        650.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        650.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        656.1259765625,
        1090.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506503105163574,
        0.2763932943344116,
        0.4472144842147827
      ],
      "plane_d": -1011.917236328125,
      "bbox_min": [
        699.5303955078125,
        1283.4163818359375,
        80.0
      ],
      "bbox_max": [
        720.0,
        1352.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506506085395813,
        -0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": -301.5865478515625,
      "bbox_min": [
        719.4853515625,
        1283.4163818359375,
        98.0423355102539
      ],
      "bbox_max": [
        720.0,
        1285.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        720.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        760.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        720.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        760.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        720.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        760.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506506085395813,
        -0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": -301.5865478515625,
      "bbox_min": [
        720.0,
        1254.22314453125,
        80.0
      ],
      "bbox_max": [
        730.0,
        1315.77685546875,
        99.02108764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506503105163574,
        0.2763932943344116,
        0.4472144842147827
      ],
      "plane_d": -1011.917236328125,
      "bbox_min": [
        720.0,
        1285.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1315.77685546875,
        99.02108001708984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        650.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -239.99998474121094,
      "bbox_min": [
        650.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        650.0,
        850.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        650.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        80.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        80.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        190.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        660.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        190.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        660.0,
        515.8578491210938,
        80.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        660.0,
        540.836669921875,
        80.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        670.7326049804688,
        540.836669921875,
        98.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3629886209964752,
        0.3629886209964752,
        0.8581832647323608
      ],
      "plane_d": -535.9135131835938,
      "bbox_min": [
        660.0,
        555.0900268554688,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        660.0,
        555.0900268554688,
        80.0
      ],
      "bbox_max": [
        689.698486328125,
        597.5563354492188,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        660.0,
        555.0900268554688,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        573.9141845703125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7032982110977173,
        0.7108950018882751,
        -0.0
      ],
      "plane_d": -876.375244140625,
      "bbox_min": [
        673.1273803710938,
        562.1814575195312,
        99.9787368774414
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        660.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        760.0,
        516.0999755859375,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        660.0,
        476.0,
        140.0
      ],
      "bbox_max": [
        760.0,
        516.0999755859375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -476.0,
      "bbox_min": [
        660.0,
        476.0,
        140.0
      ],
      "bbox_max": [
        661.0,
        476.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        715.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        760.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        660.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        760.0,
        460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        650.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        567.8578491210938,
        143.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        650.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        567.8578491210938,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        650.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        567.8578491210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        658.9852905273438,
        566.8431396484375,
        98.0
      ],
      "bbox_max": [
        660.0,
        567.8578491210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 139.0,
      "bbox_min": [
        650.0,
        471.0,
        139.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        650.0,
        471.0,
        139.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -491.0,
      "bbox_min": [
        650.0,
        491.0,
        139.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -143.49998474121094,
      "bbox_min": [
        650.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -491.0,
      "bbox_min": [
        650.0,
        472.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -472.0,
      "bbox_min": [
        651.0,
        472.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        472.0,
        143.5
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CElevator piece: elev1",
      "entity_class": "CElevator",
      "piece_name": "elev1",
      "offset": 20086,
      "centroid": [
        615.0,
        1320.9936930338542,
        81.55555555555556
      ],
      "bbox_min": [
        610.0,
        1314.3714599609375,
        80.0
      ],
      "bbox_max": [
        620.0,
        1324.3714599609375,
        86.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 10.0,
        "height_z": 6.0,
        "door_width": 10.0,
        "door_depth": 10.0,
        "leaf_depth": 10.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          620.0,
          1314.3714599609375,
          80.0
        ],
        [
          620.0,
          1314.3714599609375,
          80.0
        ],
        [
          610.0,
          1314.3714599609375,
          80.0
        ],
        [
          610.0,
          1314.3714599609375,
          80.0
        ],
        [
          620.0,
          1324.3714599609375,
          80.0
        ],
        [
          610.0,
          1324.3714599609375,
          80.0
        ],
        [
          620.0,
          1314.3714599609375,
          80.5
        ],
        [
          610.0,
          1314.3714599609375,
          80.5
        ],
        [
          610.0,
          1324.3714599609375,
          80.5
        ],
        [
          620.0,
          1324.3714599609375,
          80.5
        ],
        [
          613.0,
          1324.271484375,
          80.5
        ],
        [
          615.0,
          1324.271484375,
          80.5
        ],
        [
          617.0,
          1324.271484375,
          86.0
        ],
        [
          615.0,
          1324.271484375,
          86.0
        ],
        [
          617.0,
          1324.271484375,
          80.5
        ],
        [
          615.0,
          1324.271484375,
          80.5
        ],
        [
          613.0,
          1324.271484375,
          86.0
        ],
        [
          615.0,
          1324.271484375,
          86.0
        ]
      ],
      "plane_distance": 1324.2715,
      "authentic_texture": "cbaseelevpaneldown"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 22025,
      "centroid": [
        615.0,
        1324.3714599609375,
        535.0
      ],
      "bbox_min": [
        612.0,
        1324.3714599609375,
        530.0
      ],
      "bbox_max": [
        618.0,
        1324.3714599609375,
        540.0
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 0.0,
        "height_z": 10.0,
        "door_width": 6.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          612.0,
          1324.3714599609375,
          530.0
        ],
        [
          612.0,
          1324.3714599609375,
          540.0
        ],
        [
          618.0,
          1324.3714599609375,
          540.0
        ],
        [
          618.0,
          1324.3714599609375,
          530.0
        ]
      ],
      "plane_distance": 1324.3715
    },
    {
      "tag": "CSlidingDoor piece: timerPOL",
      "entity_class": "CSlidingDoor",
      "piece_name": "timerPOL",
      "offset": 22979,
      "centroid": [
        656.0,
        1227.5,
        520.0499877929688
      ],
      "bbox_min": [
        653.0,
        1224.0,
        520.0499877929688
      ],
      "bbox_max": [
        659.0,
        1231.0,
        520.0499877929688
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 7.0,
        "height_z": 0.0,
        "door_width": 7.0,
        "door_depth": 6.0,
        "leaf_depth": 5.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          653.0,
          1224.0,
          520.0499877929688
        ],
        [
          659.0,
          1231.0,
          520.0499877929688
        ],
        [
          653.0,
          1231.0,
          520.0499877929688
        ],
        [
          659.0,
          1224.0,
          520.0499877929688
        ]
      ],
      "plane_distance": -520.05,
      "authentic_texture": "airlobbyflrbrn1"
    }
  ],
  "tutorial_messages": []
}